// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg width=%27100%25%27 height=%27100%25%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3crect width=%27100%25%27 height=%27100%25%27 fill=%27none%27 rx=%278%27 ry=%278%27 stroke=%27%23dcdcdc%27 stroke-width=%272%27 stroke-dasharray=%2713%27 stroke-dashoffset=%270%27 stroke-linecap=%27round%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2728%27 height=%2749%27 viewBox=%270 0 28 49%27%3E%3Cg fill-rule=%27evenodd%27%3E%3Cg id=%27hexagons%27 fill=%27%239C92AC%27 fill-opacity=%270.25%27 fill-rule=%27nonzero%27%3E%3Cpath d=%27M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 270px;
  min-width: 270px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #1d1d1d;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #2b2b2b;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #2b2b2b;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

.form-container {
  width: 100%;
  max-width: 1400px;
  padding-left: 50px;
  height: 100vh;
  padding-bottom: 100px;
  padding-right: 50px;
  margin: auto;
  overflow: auto;
}

.form-container-business {
  width: 100%;
  max-width: 1400px;
  padding-left: 50px;
  height: 70vh;
  padding-right: 50px;
  margin: auto;
  overflow: auto;
  padding-bottom: 180px;
}

.search-bar-text {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: "#AAAAAA";
}

.search-card {
  width: max-content !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 5px !important;
  color: black !important;
  background-color: #F5F5F5 !important;
  padding: 1px !important;
}

.table-container {
  max-width: 100%;
  margin: auto;
  height: 80vh;
}

.loader {
  flex: 1 1;
}

.perfect-scroll {
  height: 80vh;
  overflow-y: auto;
}

.link-hover {
  cursor: pointer;
}

.type {
  color: #414141;
  font-family: Barlow;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.link-hover:hover {
  color: #548dff;
  font-weight: 600;
}

.map-container {
  max-width: 100%;
  margin: auto;
  overflow-x: hidden;
}

.spanUser {
  color: #6B6B6B;
}

.tab-container {
  max-width: 100%;
  margin: auto;
}

.spanTerm {
  color: #C2C2C2;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.span2 {
  color: #1e1d1d;
  font-size: 16px;
  font-weight: 700;
  box-shadow: #1e1d1d;
}

.businessName {
  font-size: 18px;
  color: #616161;
  font-weight: 400;
  line-height: 26px;
}

.businessId {
  font-size: 14px;
  color: #8A8A8A;
  font-weight: 200;
}

.bolds {
  font-size: 12px;
  text-align: left;
  font-weight: 500;
  color: #979595;
}

.switch {
  font-size: "14px";
  color: #548DFF;
  font-weight: 500;
}

.success {
  background-color: #e7fcf6;
  color: #13710e;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 500;
}

.pending {
  background-color: #fff7ed;
  color: #fed6a9;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 500;
}

.statusText {
  color: #fff;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 500;
}

.suspended {
  background-color: #ffb0ad;
  color: #d8382d;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 500;
}

.arrow {
  font-size: 30px;
  color: #b2b2b2;
  margin-left: 25px;
  margin-top: 20px;
}

input.lager {
  width: 16px;
  height: 16px;
  border-radius: 50px;
  background-color: #9b1d1d;
}

input.lager:checked {
  width: 16px;
  height: 16px;
  border-radius: 50px;
}

.permission {
  color: #548dff;
  font-size: small;
  cursor: pointer;
}

.permission2 {
  color: #b2b2b2;
  font-size: small;
  cursor: pointer;
}

ul.orderlist {
  text-align: left;
  font-size: 12px;
}

.serviceText {
  font-size: 14px;
  font-weight: 400;
}

.service {
  padding: 8px;
  border: 1px solid #d2d2d2;
  border-radius: 6px;
  /* width:120px; */
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.service:hover {
  cursor: pointer;
  background-color: #a5bff5;
  color: white;
}

.link {
  text-decoration: none;
  color: #999191;
  font-size: 14px;
  font-weight: 500;
}

.active {
  border-bottom: 2px solid #548dff;
  text-decoration: none;
}

.homeIcon {
  font-size: 16px;
}

.link:hover {
  text-decoration: none;
  color: #999191;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 2px solid #548dff;
}

.icon {
  color: rgb(255, 255, 255);
  position: absolute;
  top: 3px;
  right: 3px;
  background-color: #5599FF;
  font-size: 12px;
  border-radius: 10px;
}

.bold {
  font-weight: 700;
  margin-left: 5px;
}

.paddings {
  /* margin-left: 250px; */
  margin-right: 450px;
  text-align: center;
}

.grey-letter {
  color: #AAA;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App {
  background-color: #fbfcff;
  height: 100vh;
  overflow: auto;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.overflow_calender {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.height_for_booking {
  height: 76vh !important;
  border: 1px solid rgb(229, 228, 228);
  border-radius: 10px;
}

.height_for_calendar {
  height: 93vh !important;
}

.overflow_calender::-webkit-scrollbar {
  display: none; /* WebKit (Chrome, Safari, etc.) */
}

.height_fixed_cal {
  height: 75vh;
  overflow-y: scroll;
}

#style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar {
  width: 5px;
  background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  height: 5px;
  background-color: #FFBF00;
}

.col input,
.col select,
.col textarea {
  border: none !important;
  font-size: 14px;
  color: gray;
}

:focus {
  box-shadow: none !important;
  outline: none !important;
}

.col input:focus,
.col select:focus,
.col textarea:focus {
  box-shadow: none;
  outline: none;
}

.input_wrapper {
  border: 1px solid lightgray;
  border-radius: 8px;
  width: 100%;
  background-color: white;
  overflow: hidden;
}

.input_wrapper label {
  padding-left: 10px;
  font-size: 12px;
  color: gray;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.form-check {
  padding-left: 45px !important;
  padding-top: 10px;
}

.checkbox_lbl {
  font-size: 14px !important;
  color: black !important;
}

.cancel_btn {
  background-color: lightgray !important;
}

.service_publish {
  border: 1px solid lightgray;
  border-radius: 8px;
  background-color: white !important;
}

.form_btns {
  height: 35px;
  font-size: 14px !important;
}

.span_input_url {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 0px !important;
  font-size: 14px !important;
  color: gray !important;
  background-color: #e5e5e5 !important;
}

.switch_btn_col_th {
  width: 50px !important;
}

.MuiTableCell-root {
  text-align: unset !important;
}

.css-g2z002-MuiSvgIcon-root-MuiPaginationItem-icon {
  fill: #f0bc08 !important;
}

li {
  list-style: none;
}

.text-green {
  color: #89e0c1;
}

.border-green {
  border: 1px solid #89e0c1;
}

.text-light-grey {
  color: #b1b4b7 !important;
}

.text-secondary {
  color: #6f6f6f !important;
}

.custom-border {
  border: 1px solid #e7eaec !important;
  border-radius: 8px !important;
}

.MuiButtonBase-root {
  font-size: 16px !important;
}

.pr-6px {
  padding-right: 6px !important;
}

.pl-6px {
  padding-left: 6px !important;
}

.mt-12px {
  margin-top: 12px !important;
}

.mt-9px {
  margin-top: 9px !important;
}

:focus {
  outline: 0 !important;
  box-shadow: none !important;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root {
  position: static !important;
}

.border-right {
  border-right: 1px solid #eeeff0;
}

.service-add-detail {
  height: 100% !important;
}
.service-add-detail .price-input-wrapper .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
  color: #7f7f7f !important;
  padding-left: 6px;
}
.service-add-detail .price-input-wrapper .MuiOutlinedInput-notchedOutline {
  border: none !important;
}
.service-add-detail .form-check {
  padding: 0 !important;
  padding-left: 24px !important;
}
.service-add-detail .service-menu {
  background: white;
  padding: 0;
  margin: 0;
}
.service-add-detail .service-menu a {
  text-decoration: none;
}
.service-add-detail .service-menu .active-menu {
  background: #fdf8e6;
}
.service-add-detail .service-menu .active-menu .menu-link,
.service-add-detail .service-menu .active-menu .caret {
  color: #f0bc08 !important;
}
.service-add-detail .service-menu li:hover {
  background: #fdf8e6;
}
.service-add-detail .service-menu li:hover .menu-link,
.service-add-detail .service-menu li:hover .caret {
  color: #f0bc08 !important;
}
.service-add-detail .service-menu li {
  padding: 12px 10px;
  padding-bottom: 0;
  border-radius: 8px;
  cursor: pointer;
}
.service-add-detail .service-menu li .caret {
  color: #aaaaaa;
  font-size: 18px;
}
.service-add-detail .service-menu li .link-wrap {
  border-bottom: 0.5px solid #ededed !important;
}
.service-add-detail .service-menu li .menu {
  font-size: 14px;
  font-weight: 400;
  color: #4c4c4c;
  padding-bottom: 10px;
}
.service-add-detail .service-card {
  width: 100px;
  height: 100px;
  background: lightgray;
  border-radius: 100%;
  position: relative;
}
.service-add-detail .service-card .camera {
  position: absolute;
  bottom: 0;
  right: 8px;
}
.service-add-detail .head {
  font-size: 14px;
  font-weight: 400;
}
.service-add-detail .card-detail {
  font-size: 12px;
}
.service-add-detail .input-group {
  position: relative;
  width: 100%;
}
.service-add-detail .input-group .input-label {
  position: absolute;
  font-size: 11px;
  top: 5px;
  left: 10px;
}
.service-add-detail .input-group .input {
  width: 100%;
  padding: 25px 10px 4px 10px;
  font-weight: 400;
  color: black !important;
  background: white;
  font-size: 14px;
}
.service-add-detail .input-group .input:focus {
  outline: 1px solid #ffd705 !important;
  outline-offset: 2px;
}
.service-add-detail .input-group ::placeholder {
  font-size: 14px !important;
}
.service-add-detail .form-check-label {
  color: black !important;
}
.service-add-detail .form-check-input[type=checkbox]:checked {
  background-color: #ffd705 !important;
}
.service-add-detail input[type=checkbox] {
  border-radius: 4px !important;
}
.service-add-detail .form-check-label {
  font-size: 14px !important;
}
.service-add-detail .checkbox-label {
  color: black !important;
  font-size: 14px;
}
.service-add-detail .cancel-btn,
.service-add-detail .save-btn {
  border: 0;
  outline: 0;
  border-radius: 8px;
  font-weight: 400;
  box-shadow: none !important;
  text-transform: capitalize;
  outline: none !important;
  border: 0 !important;
}
.service-add-detail .save-btn {
  padding: 10px 60px;
}
.service-add-detail .cancel-btn {
  padding: 10px 45px;
}
.service-add-detail .save-btn:hover {
  background: #ffd705 !important;
}
.service-add-detail .save-btn {
  background: #ffd705;
  color: white;
}
.service-add-detail .add-btn {
  border: 0;
  outline: 0;
  padding: 16px 20px;
  border-radius: 8px;
  background: #ffd705;
  color: white;
  font-size: 14px;
}
.service-add-detail .cancel-btn {
  background: #e9e9e9;
  color: #9f9f9f;
}
.service-add-detail .cancel-btn:hover {
  background: #e9e9e9 !important;
}
.service-add-detail .select-service-type {
  font-size: 12px;
  color: black;
}
.service-add-detail .input-dropdown {
  padding: 12.5px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.right-select {
  position: relative;
}
.right-select span {
  position: absolute;
  top: 0;
}
.right-select .right-select-input {
  padding: 27px 10px 2px 10px;
  font-size: 14px !important;
}
.right-select .select-label {
  position: absolute;
  font-size: 11px;
  top: 5px;
  left: 10px;
}

.attributes {
  padding: 10px;
}
.attributes .areas {
  font-size: 14px;
}
.attributes .tag {
  padding: 10px 25px;
}
.attributes .tag .cross {
  color: #ffd705 !important;
  position: absolute;
  right: 0px;
  top: 0px;
}
.attributes .enter-tags {
  font-weight: 400;
  border: 0;
  outline: 0;
  font-size: 14px !important;
  background: transparent;
}
.attributes .enter-tags::placeholder {
  font-size: 14px !important;
}
.attributes .tags-wrap {
  margin-bottom: 5px;
}

.group-input {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  border: none !important;
  font-size: 14px !important;
  position: absolute !important;
  width: 130px;
  right: 0;
  top: -52px;
  padding-top: 13px;
  padding-bottom: 13px;
  background: #efefef;
  color: #7f7f7f;
}

.add-column {
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.add-column .add-circle-icon {
  color: #cfcfcf;
  border: 1px solid #cfcfcf;
  border-radius: 8px;
  padding: 0 7px;
  margin: 5px;
}

.att-table {
  border: 1px solid #e7eaec !important;
  overflow-x: hidden;
}
.att-table .description-cell {
  width: 260px;
}
.att-table .table-add-new {
  cursor: pointer;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: white;
  padding: 10px 6px;
  font-size: 12px;
  color: #ffd705;
}
.att-table .table-add-new .add-circle-table {
  color: #ffd705 !important;
}
.att-table .mins {
  font-size: 12px;
  padding-left: 5px;
}
.att-table .area-wrap {
  background: #f6f6f6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.att-table .area-wrap .area {
  font-weight: 600;
  padding: 12px 20px;
  border-bottom: 1px solid #e7eaec !important;
  width: 32%;
}

.price-table-wrap {
  border: 1px solid #ffd705;
  border-radius: 8px;
  background: white;
}
.price-table-wrap .delete-field {
  cursor: pointer;
  position: absolute;
  right: -30px;
  font-size: 25px;
}
.price-table-wrap .table-top-select {
  color: black !important;
}
.price-table-wrap .table-cell {
  width: 20px;
}
.price-table-wrap .table-select {
  border: none !important;
}
.price-table-wrap .table {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.price-table-wrap .table thead,
.price-table-wrap .table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.price-table-wrap .table thead th {
  background: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
}
.price-table-wrap .table tbody {
  max-height: 253px;
  overflow: auto;
  display: block;
  border: 0 8px 8px 0;
}
.price-table-wrap .table tr,
.price-table-wrap .table td,
.price-table-wrap .table th {
  border: none !important;
  text-align: left !important;
}
.price-table-wrap .table tr {
  border-bottom: 1px solid #f6f6f6 !important;
}
.price-table-wrap .table tbody .tr:last-child {
  border-bottom: 0 !important;
}
.price-table-wrap .table th {
  font-size: 12px;
  font-weight: 500;
  cursor: default;
}
.price-table-wrap .table td {
  font-size: 14px;
  color: #676464;
  cursor: default;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.price-table-wrap .cell-currency,
.price-table-wrap .cell-time {
  background-color: #f4f4f4;
  color: #c3c3c3;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
}
.price-table-wrap .price-cell {
  width: 170px;
}
.price-table-wrap .price-cell path {
  fill: #ffd705;
}
.price-table-wrap .duration-cell {
  width: 100px;
}
.price-table-wrap .sku-cell {
  width: 110px;
}
.price-table-wrap .down-arrow {
  font-size: 16px;
  color: #ffd705;
}
.price-table-wrap .price-type-cell {
  width: 136px;
  padding-right: 0;
  padding-left: 10px;
}

.publish-status-wrapper {
  margin-top: 1px !important;
  position: relative;
}
.publish-status-wrapper .publish-label {
  font-size: 11px;
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 1;
}
.publish-status-wrapper .green-border div:first-child {
  color: #14c284 !important;
}
.publish-status-wrapper .red-border div:first-child {
  color: #e8003f !important;
}
.publish-status-wrapper .publish-status {
  padding-top: 11px;
  padding-bottom: 11px;
  background: white;
}
.publish-status-wrapper .publish-status input[value="10"] ~ .MuiOutlinedInput-notchedOutline {
  border: 2px solid #14c284 !important;
}
.publish-status-wrapper .publish-status input[value="20"] ~ .MuiOutlinedInput-notchedOutline {
  border: 2px solid #e8003f !important;
}
.publish-status-wrapper .publish-status .MuiOutlinedInput-notchedOutline {
  border: 1px solid #e7eaec !important;
}
.publish-status-wrapper .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
  color: black !important;
  padding-left: 2px;
  border-radius: 8px;
}
.publish-status-wrapper .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  position: relative;
  top: 10px;
  font-size: 14px;
}
.publish-status-wrapper svg {
  position: relative;
  top: 10px;
}

.service-group-wrap .cards-wrap {
  max-height: 365px;
  overflow: auto;
  width: 100%;
  background: transparent;
  border: none;
}
.service-group-wrap .cards-wrap .group-card {
  border-radius: 5px !important;
  margin-bottom: 12px;
}
.service-group-wrap .cards-wrap .group-card .group-service-card {
  width: 50px;
  height: 50px;
  background: lightgray;
  border-radius: 100%;
  position: relative;
}
.service-group-wrap .cards-wrap .group-card:last-child {
  margin-bottom: 0;
}
.service-group-wrap .add-new {
  width: fit-content;
  border: 1px solid #ffd705;
  background: #fdf8e6;
  border-radius: 8px;
  padding: 10px 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 80px;
  cursor: pointer;
}
.service-group-wrap .add-new .plus {
  padding: 0 7px;
  background: #ffd705;
  border-radius: 6px;
  color: white;
}

.offcanvas {
  --bs-offcanvas-width: 50vw !important;
}

.offcanvas-end {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.offcanvas-title {
  font-size: 24px !important;
  font-weight: 400 !important;
}

.pricing-select {
  position: relative;
}
.pricing-select .select-label {
  font-size: 11px;
  position: absolute;
  top: 7px;
  left: 17px;
  z-index: 1;
}
.pricing-select .pricing-dropdown {
  padding: 21px 0px 2px 3px;
  border-radius: 8px;
  background: white;
  margin-top: 3px;
}
.pricing-select .pricing-dropdown .MuiOutlinedInput-notchedOutline {
  border: 1px solid #e7eaec !important;
}
.pricing-select .pricing-dropdown div:first-child {
  font-size: 14px;
  position: relative;
  bottom: -2px;
  color: black;
}
.pricing-select div svg {
  margin-top: -17px;
}

.pricing-table-select div:first-child {
  font-size: 14px;
  color: #676464 !important;
}

.pricing-table-select .MuiOutlinedInput-notchedOutline {
  border: none;
}

.pricing-table .price-cell {
  width: 155px;
}
.pricing-table .desc-cell {
  width: 85px;
}
.pricing-table tbody {
  overflow-x: hidden !important;
  max-height: 325px !important;
}
.pricing-table tbody tr td {
  background: transparent !important;
}
.pricing-table .table-cell {
  border-top-left-radius: 8px;
}
.pricing-table .price-cell {
  border-top-right-radius: 8px;
}

.variable-price-table-wrap {
  margin-right: -11px;
  border: 1px solid #c6c4bc !important;
  background: white;
  border-radius: 8px !important;
}
.variable-price-table-wrap .table {
  background: transparent;
}
.variable-price-table-wrap .table tbody tr {
  margin-bottom: 1px solid #f6f6f6;
}
.variable-price-table-wrap .table tr td:first-child {
  border-bottom-left-radius: 8px;
}
.variable-price-table-wrap .table tr td div {
  border-right: 1px solid #eeeff0 !important;
}
.variable-price-table-wrap .table tr td:last-child {
  border-bottom-right-radius: 8px;
}
.variable-price-table-wrap .table tr td:last-child div {
  border-right: none !important;
}
.variable-price-table-wrap .variable-prices-table th {
  background: #ffd705 !important;
  color: white;
  font-size: 12px;
  font-weight: 400;
}
.variable-price-table-wrap .variable-prices-table td {
  font-size: 12px;
}
.variable-price-table-wrap .variable-prices-table th:first-child {
  border-top-left-radius: 8px;
}
.variable-price-table-wrap .variable-prices-table th:last-child {
  border-top-right-radius: 8px;
}

.service-pricing-wrap .pricing-table {
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.service-pricing-wrap .pricing-table .tr {
  border-bottom: none !important;
}
.service-pricing-wrap .pricing-table .variable-child {
  padding: 0 23px !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.service-pricing-wrap .add-new {
  background: white;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-left: 10px;
  cursor: pointer;
}
.service-pricing-wrap .add-new .add-icon {
  color: #ffd705 !important;
}
.service-pricing-wrap .add-new .add-icon + span {
  color: #ffd705;
  font-size: 11px;
}

.service-cost-wrap .table {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.service-cost-wrap .table .duration-cell {
  width: 140px;
}
.service-cost-wrap .table .price-cell {
  width: 120px;
  padding-left: 13px;
}
.service-cost-wrap .table .price-cell path {
  fill: #b1b4b7 !important;
}
.service-cost-wrap .add-service-table {
  color: #ffd705;
}
.service-cost-wrap thead tr th:first-child {
  border-top-left-radius: 8px;
}
.service-cost-wrap thead tr th:last-child {
  border-top-right-radius: 8px;
}

.service-settings .color-card {
  background: white;
}
.service-settings .color-card .color-wrap {
  position: relative;
}
.service-settings .color-card .color-wrap .color-picker {
  position: absolute;
  left: 0;
}
.service-settings .color-card ul {
  padding: 0;
  margin: 0;
}
.service-settings .color-card ul .color-list {
  font-size: 12px;
  position: relative;
}
.service-settings .color-card ul .color-list .color-picker {
  position: absolute;
  z-index: 1;
  right: 34px;
}
.service-settings .color-card ul .color-list .color-circle {
  height: 25px;
  width: 25px;
  border-radius: 100%;
  border: 1px solid black;
}

.cost-offcanvas .table-cell {
  border-top-left-radius: 8px !important;
}
.cost-offcanvas .price-cell {
  border-top-right-radius: 8px !important;
}
.cost-offcanvas thead {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.cost-offcanvas tbody tr .price-cell path {
  fill: #b1b4b7 !important;
}

.css-13i4rnv-MuiGrid-root {
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}

.dynamic-table-main-grid {
  border: 1px solid #dcdcdc !important;
  border-radius: 8px !important;
}

.dynamic-table-wrapper {
  background: white;
  height: 100%;
}

.dynamic-table {
  table-layout: fixed;
  width: 100%;
  border-radius: 8px;
}
.dynamic-table thead {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 999 !important;
}
.dynamic-table thead .col1-th-sticky {
  background: #fbfbfb;
  width: 45px;
  border-bottom: 1px solid #efefef;
  position: sticky;
  left: 0;
  top: 0;
  padding: 8px 0;
}
.dynamic-table thead .col1-th-sticky::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-top: 5px solid #f5bf00;
  border-top-left-radius: 8px;
}
.dynamic-table thead .th-sticky {
  padding: 8px 0;
}
.dynamic-table thead .th-sticky::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-top: 5px solid #f5bf00;
}
.dynamic-table thead th {
  border-right: 1px solid #efefef;
  color: #9f9e9e;
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 400;
  cursor: default;
}
.dynamic-table thead tr th:first-child {
  border-top-left-radius: 8px;
}
.dynamic-table thead tr th:last-child {
  border-top-right-radius: 8px;
}
.dynamic-table tbody tr td {
  background: white;
  color: #434343;
  font-size: 14px;
  cursor: default;
}
.dynamic-table tbody tr .col1-td {
  width: 45px;
  text-align: center;
  border-bottom: 1px solid #efefef;
  position: sticky;
  left: 0;
  padding: 10px 0;
}
.dynamic-table tbody tr .td-dynamic {
  border: 1px solid #efefef;
  padding: 10px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dynamic-table .table-th-bg {
  background: #fbfbfb;
}
.dynamic-table .col1-rec {
  border: 1px solid #b2b2b2;
  padding: 0 3.6px;
  height: 16px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.dynamic-table .col1-plus {
  color: #b2b2b2;
  font-size: 8px;
  margin-left: 2px;
}

.service_header {
  height: 60px;
  background-color: white;
  border-bottom: 1px solid lightgray;
}

.service_header_mobile {
  height: 60px;
  background-color: white;
}

.tab_menu {
  width: auto;
}

.tab_menu button {
  background-color: transparent;
  border: none !important;
  color: gray;
  font-size: 14px;
  border-radius: 5px !important;
}

.tab_menu button:hover {
  background-color: #f5bf00 !important;
  color: white;
}

.tab_menu_mobile {
  margin-bottom: 20px;
  border-bottom: 1px solid lightgray !important;
  border-radius: 0px !important;
}

.tab_menu_mobile button {
  border-radius: 0px;
}

.tab_menu_mobile button {
  font-size: 11px;
  padding: 4px 8px;
}

.active_tab_mobile {
  background-color: transparent;
  border-bottom: 2px solid #f5bf00 !important;
  color: #f5bf00 !important;
  font-size: 14px;
}

.search_btn,
.filter_btn {
  height: 35px;
  font-size: 14px !important;
  background-color: lightgray !important;
}

.search_btn:hover,
.filter_btn:hover {
  color: rgb(53, 52, 52) !important;
}

.form-check-input2[type=checkbox] {
  border: 1px solid lightgray !important;
}

.checkbox_btn2[type=checkbox] {
  height: 18px;
  width: 18px;
}

.form-check-input2[type=checkbox]:checked {
  background-color: #5599ff !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.theme_btn_color {
  background-color: #f5bf00 !important;
  color: white !important;
  border: none !important;
}

.theme_icon_color {
  color: #f5bf00 !important;
}

.small_btn {
  height: 30px !important;
  font-size: 12px !important;
  background-color: #f5bf00 !important;
  color: white !important;
  border-radius: 5px !important;
}

.inventory_service {
  max-height: 92vh !important;
  overflow-y: scroll !important;
  padding-bottom: 100px !important;
}

.checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.blue_theme_checkbox .form-check-input[type=checkbox]:checked {
  background-color: #548dff !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.MuiPagination-ul {
  margin-left: 45px !important;
  display: flex !important;
  margin-top: 20px !important;
}

button[aria-label="Go to previous page"] {
  margin-left: -120px !important;
}

.MuiPagination-ul li:last-child {
  order: -1 !important;
  margin-right: 45px !important;
}

.css-lqq3n7-MuiButtonBase-root-MuiPaginationItem-root.Mui-disabled {
  opacity: 1 !important;
}

.css-9nek4c-MuiPagination-root .css-lqq3n7-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {
  color: #6a6a6a !important;
}

.css-g2z002-MuiSvgIcon-root-MuiPaginationItem-icon {
  color: #ffd705 !important;
}

.items_per_page_select {
  margin-top: 20px !important;
}

.table-container {
  border-radius: 7px !important;
}

.sticky_header {
  position: sticky;
  left: 0;
}

.sticky_row {
  position: sticky;
  bottom: 0;
  z-index: 4;
  margin: 0;
  padding: 0;
}

.sticky_row td {
  margin: 0 !important;
  padding: 7px !important;
}

.sticky_row input,
.sticky_row select {
  background-color: #f5f5f5;
  color: black;
  height: 35px;
  width: 100%;
}

.hide_scrollbar::-webkit-scrollbar,
.inv_list_container::-webkit-scrollbar,
.price_list_container::-webkit-scrollbar,
.group_list_container::-webkit-scrollbar,
.packages_table_container::-webkit-scrollbar,
.gp_pkg_list_container::-webkit-scrollbar,
.package_list_container::-webkit-scrollbar,
.package_list_container_mobile::-webkit-scrollbar,
.form_main_container::-webkit-scrollbar {
  display: none !important;
}

.form_main_container {
  max-height: 95vh;
  overflow: scroll;
  padding-bottom: 100px;
}

.table {
  table-layout: fixed;
  border-collapse: collapse;
  background-color: white;
  border-top-left-radius: 9px !important;
}

.table th,
.table td {
  border: 1px solid #ccc;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  vertical-align: middle;
}

#table_form_row td,
#table_form_row td,
#table_form_row td input,
#table_form_row td select {
  font-weight: bold !important;
  color: gray !important;
  background-color: rgb(252, 250, 250);
}

.list_wrapper {
  padding: 20px;
  font-size: 14px;
}

.list_wrapper .row:hover {
  background-color: #f8fafc;
}

.list_wrapper .row .col,
.list_wrapper .row .check_col {
  border-bottom: 1px solid #e7e8ea;
  background-color: transparent;
  color: gray;
}

.switch_btn_div {
  display: flex;
  justify-content: center;
  align-items: center;
}

/*List style for PC */
.table_main_list thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.table_main_list th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -12px;
  z-index: 4;
}

.table_main_list th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 58px;
  z-index: 4;
  cursor: pointer;
}

.table_main_list td:nth-child(1) {
  position: sticky;
  left: -12px;
  z-index: 2;
}

.table_main_list td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.table_main_list td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.table_main_list #sticky_col0 {
  position: sticky;
  left: 58px;
  z-index: 2;
}

.table_main_list th:last-child {
  width: 60px;
}

.table_main_list th,
.table_main_list td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* List style for Mobile */
.table_main_list_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.table_main_list_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.table_main_list_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.table_main_list_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.table_main_list_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.table_main_list_mobile th:last-child,
.table_main_list_mobile td:last-child {
  width: 60px;
  position: sticky;
  background-color: rgb(245, 241, 241);
}

.table_main_list_mobile th,
.table_main_list_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Inventory Services List style for PC */
.inv_list_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
}

.inv_list_container th:nth-child(1) {
  width: 60px;
  border-top: 7px solid #ff9669;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.inv_list_container th:nth-child(2) {
  width: 250px !important;
  border-top: 7px solid #ff9669;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.inv_list_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.inv_list_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.inv_list_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.inv_list_container #sticky_col0 {
  left: 0px;
  z-index: 2;
  cursor: pointer;
}

.inv_list_container #sticky_col0:hover {
  color: #f5bf00 !important;
}

.inv_list_container th:last-child {
  width: 60px;
}

.inv_list_container th,
.inv_list_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Inventory Services List style for Mobile */
.inv_list_container_mobile thead {
  top: -4px;
  z-index: 3;
  background-color: white;
}

.inv_list_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.inv_list_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.inv_list_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.inv_list_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.inv_list_container_mobile #sticky_col0:hover {
  color: #f5bf00 !important;
}

.inv_list_container_mobile th:last-child,
.inv_list_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.inv_list_container_mobile th,
.inv_list_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Pricing Form style for PC */
.pricing_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_form_container th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.pricing_form_container th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.pricing_form_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.pricing_form_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.pricing_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.pricing_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.pricing_form_container th:last-child {
  width: 60px;
}

.pricing_form_container th,
.pricing_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Pricing form style for Mobile */
.pricing_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_form_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.pricing_form_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.pricing_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.pricing_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.pricing_form_container_mobile th:last-child,
.pricing_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.pricing_form_container_mobile th,
.pricing_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Pricing list style for PC */
.pricing_list_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_list_container th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: -2px;
  z-index: 4;
}

.pricing_list_container th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: 67px;
  z-index: 4;
}

.pricing_list_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.pricing_list_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.pricing_list_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.pricing_list_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.pricing_list_container th:last-child {
  width: 60px;
}

.pricing_list_container th,
.pricing_list_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Pricing list style for Mobile */
.pricing_list_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.pricing_list_container_mobile th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: -2px; */
}

.pricing_list_container_mobile th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: 67px; */
}

.pricing_list_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.pricing_list_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.pricing_list_container_mobile th:last-child,
.pricing_list_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.pricing_list_container_mobile th,
.pricing_list_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Cost Form style for PC */
.cost_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.cost_form_container th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.cost_form_container th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.cost_form_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.cost_form_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.cost_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.cost_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.cost_form_container th:last-child {
  width: 60px;
}

.cost_form_container th,
.cost_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Cost form style for Mobile */
.cost_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.cost_form_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.cost_form_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.cost_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.cost_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.cost_form_container_mobile th:last-child,
.cost_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.cost_form_container_mobile th,
.cost_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Attribute Form style for PC */
.attribute_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.attribute_form_container th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.attribute_form_container th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.attribute_form_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.attribute_form_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.attribute_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.attribute_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.attribute_form_container th:last-child {
  width: 60px;
}

.attribute_form_container th,
.attribute_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Attribute form style for Mobile */
.attribute_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.attribute_form_container_mobile th:nth-child(1) {
  width: 70px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: -2px; */
}

.attribute_form_container_mobile th:nth-child(2) {
  width: 250px;
  border-top: 7px solid #f5bf00;
  /* position: sticky;
    left: 67px; */
}

.attribute_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.attribute_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.attribute_form_container_mobile th:last-child,
.attribute_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.attribute_form_container_mobile th,
.attribute_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Package Form style for PC */
.package_list_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.package_list_container th:nth-child(1) {
  width: 70px;
  position: sticky;
  left: -2px;
  z-index: 4;
}

.package_list_container th:nth-child(2) {
  width: 250px;
  position: sticky;
  left: 67px;
  z-index: 4;
}

.package_list_container td:nth-child(1) .checkbox_btn[type=checkbox] {
  margin-top: -4px;
  margin-left: -20px;
  height: 18px;
  width: 18px;
}

.package_list_container td:nth-child(1) .checkbox_btn[type=checkbox]:checked {
  background-color: #f5bf00 !important;
}

.package_list_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.package_list_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.package_list_container th:last-child {
  width: 60px;
}

.package_list_container th,
.package_list_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Package form style for Mobile */
.package_list_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.package_list_container_mobile th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: -2px; */
}

.package_list_container_mobile th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: 67px; */
}

.package_list_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.package_list_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.package_list_container_mobile th:last-child,
.package_list_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.package_list_container_mobile th,
.package_list_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Group Form style for PC */
.group_form_container thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.group_form_container th:nth-child(1) {
  width: 35px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: -2px;
  z-index: 4;
}

.group_form_container th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  position: sticky;
  left: 67px;
  z-index: 4;
}

.group_form_container td:nth-child(1) {
  position: sticky;
  left: -2px;
  z-index: 2;
}

.group_form_container #sticky_col0 {
  position: sticky;
  left: 67px;
  z-index: 2;
}

.group_form_container th:last-child {
  width: 35px !important;
}

.group_form_container th,
.group_form_container td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/*  Cost form style for Mobile */
.group_form_container_mobile thead {
  position: sticky;
  top: -4px;
  z-index: 3;
  background-color: white;
}

.group_form_container_mobile th:nth-child(1) {
  width: 70px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: -2px; */
}

.group_form_container_mobile th:nth-child(2) {
  width: 250px;
  /* border-top: 7px solid #f5bf00; */
  /* position: sticky;
    left: 67px; */
}

.group_form_container_mobile td:nth-child(1) {
  /* position: sticky;;
    left: -2px;
    z-index: 2; */
}

.group_form_container_mobile #sticky_col0 {
  /* position: sticky;
    left: 67px;
    z-index: 2; */
}

.group_form_container_mobile th:last-child,
.group_form_container_mobile td:last-child {
  width: 60px;
  position: sticky;
  right: -2px;
  background-color: rgb(245, 241, 241);
}

.group_form_container_mobile th,
.group_form_container_mobile td {
  width: 120px;
  font-size: 12px;
  color: gray !important;
}

/* Create Service */
.create_service {
  height: 100vh;
  overflow-y: scroll;
  padding-bottom: 180px;
  width: 100%;
}

.detail_form input,
.detail_form select {
  border: none;
  font-size: 14px;
}

.detail_form input:focus,
.detail_form select:focus {
  box-shadow: none;
  outline: none;
  border: none;
}

.detail_form input,
.detail_form select {
  border: none;
  font-size: 14px;
}

.detail_form input:focus,
.detail_form select:focus {
  box-shadow: none;
  outline: none;
  border: none;
}

.create_form_row input {
  border-left: none;
  border-top: none;
  border-right: none;
  border-bottom: 2px solid white;
  border-radius: 0px;
  font-size: 14px;
  color: gray;
}

.create_form_row input:focus {
  box-shadow: none;
  font-size: 14px;
  border-bottom: 2px solid #f5bf00;
}

.create_form_row .input_wrapper input,
.create_form_row .input_wrapper textarea {
  border-left: none;
  border-top: none;
  border-right: none;
  border-bottom: 2px solid white !important;
  border-radius: 0px;
  font-size: 14px;
  color: gray;
}

.create_form_row .input_wrapper input:focus,
.create_form_row .input_wrapper textarea:focus {
  border-bottom: 2px solid #f5bf00 !important;
}

.add-btn {
  margin-left: 10px;
  border-radius: 20px;
  background-color: transparent;
}

.addcol_btn_th {
  text-align: center;
  width: 40 !important;
}

.delete-btn {
  padding: 2px 5px;
  margin-left: 5px;
  background-color: #f44336;
  color: #fff;
  border: none;
  cursor: pointer;
}

.add-row-btn {
  margin-top: 10px;
}

.delete-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

td input,
td select {
  background-color: transparent;
  border: none;
  width: 100%;
}

.tbl_footer_main {
  border-radius: 8px;
  opacity: 1;
  padding: 0;
}

.small_col {
  width: 70px !important;
}

.gp_package_list_container #sticky_cell_top_border {
  width: 70px !important;
  /* border-top: 7px solid #f5bf00 !important; */
  position: sticky !important;
  left: 0px !important;
}

.gp_package_list_container #sticky_col1 {
  width: 250px;
  /* border-top: 7px solid #f5bf00 !important; */
  position: sticky !important;
  left: 70px !important;
}

.group_list_container #sticky_cell_top_border {
  width: 40px;
  position: sticky !important;
  left: 0px !important;
}

.group_list_container #sticky_col1 {
  width: 250px;
  position: sticky !important;
  left: 70px !important;
}

.price_list_container #sticky_cell_top_border {
  width: 70px;
  position: sticky !important;
  left: 0px !important;
}

.price_list_container #sticky_col1 {
  width: 250px;
  position: sticky !important;
  left: 70px !important;
}

.disable_area {
  pointer-events: none;
  background-color: rgb(251, 248, 248) !important;
}

.pricing_table thead {
  position: sticky;
  background-color: white;
}

.pricing_table thead th:first-child {
  width: 70px;
  border-top: 7px solid #f5bf00 !important;
  position: sticky !important;
  left: 0 !important;
}

.pricing_table thead th:nth-child(2) {
  width: 200px;
  border-top: 7px solid #f5bf00 !important;
  position: sticky !important;
  left: 70px !important;
}

.pricing_table tbody td:first-child {
  position: sticky !important;
  left: 0 !important;
}

.pricing_table thead {
  z-index: 9999 !important;
}

.pricing_table tbody {
  position: relative;
  z-index: 999;
}

.media_menu_listing {
  font-size: 11px;
  color: rgb(158, 158, 158);
}

/* Responsive Style */
.pc_display {
  display: block !important;
}

.mobile_display {
  display: none !important;
}

.dragging-row {
  background-color: rgb(168, 77, 77) !important;
  cursor: move !important;
  color: blue !important;
}

.table {
  width: auto;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: white;
}

.table th,
.table td {
  border: 1px solid #ccc;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dragging-row {
  border: 2px dotted #f5bf00 !important;
  background-color: transparent !important;
  cursor: move;
  background-color: #a48204 !important;
  color: white !important;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.dragging-row td:nth-child(1) {
  background-color: lightgray !important;
}

.dragtr {
  cursor: move;
}

.over {
  border: 2px dotted #f5bf00 !important;
  opacity: 1 !important;
  background-color: #a48204 !important;
}

.hb {
  background-color: black !important;
}

.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none;
}

.selected_service_list {
  background-color: white;
  border: 1px solid lightgray;
  border-radius: 8px;
  padding: 10px;
  color: gray;
  font-size: 90%;
}

.selected_service_list .selected_row {
  cursor: pointer;
  border-bottom: 1px solid lightgray;
}

.selected_service_list .selected_row:hover {
  background-color: rgb(252, 253, 252);
}

.add_service_btn {
  background-color: white;
  border: 1px solid lightgray !important;
  color: gray;
  border-radius: 8px;
  font-size: 80%;
  height: 35px;
}

.add_service_btn .addbox_icon {
  color: #f5bf00 !important;
  height: auto !important;
}

.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-outlined {
  color: gray;
  /* Replace 'red' with your desired label color */
}

/* Contact US Form */
.contact {
  max-height: 100vh;
  overflow: scroll;
  padding-bottom: 100px;
}

.contact p {
  font-size: 13px;
}

.contact input,
.contact label,
.contact textarea {
  font-size: 12px;
}

.contact textarea {
  border-radius: 0px !important;
  border: none;
}

.contact textarea:focus {
  box-shadow: none;
}

.contact_row .contact_sec1 {
  padding-top: 50px;
}

.contact_row .contact_sec2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.contact_row .text_line {
  height: 5px;
  width: auto;
  margin-top: -25px;
}

.contact_row .input_wrapper {
  overflow: hidden;
}

.textarea_wrapper {
  border: 1px solid lightgray;
  width: 100%;
  background-color: white;
}

.textarea_wrapper label {
  padding-left: 10px;
  font-size: 12px;
  color: gray;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.contact_row .contact_btn {
  width: 40%;
  font-size: 12px;
  background-color: #6188fe;
}

.media_links .media_gp {
  border-radius: 12px;
  color: white;
  font-size: 12px;
  background-color: #6188fe;
}

.media_links {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media_links .icon_name {
  font-size: 10px;
  margin-top: 4px;
  margin-left: 3px;
}

.list_publish_btn {
  font-size: 10px !important;
}

/* Create category Form*/
.cat_textarea_wrapper {
  border-radius: 8px;
  border: 1px solid lightgray;
  width: 100%;
  background-color: white;
}

.cat_textarea_wrapper label {
  padding-left: 10px;
  font-size: 12px;
  color: gray;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.create_form_row textarea {
  border: none;
}

.create_form_row textarea:focus {
  box-shadow: none;
}

.create_category {
  height: 85vh;
}

.create_category .fixed_btn_gp {
  position: absolute;
  right: 5%;
  bottom: 5%;
}

.fixed_btn_gp .cancel_btn {
  color: gray !important;
  background-color: #edf0f5 !important;
}

.category_form input,
.category_form textarea,
.category_form select {
  font-size: 12px !important;
}

/* Sub category Form */
.create_scategory {
  height: 85vh;
}

.create_scategory .fixed_btn_gp {
  position: absolute;
  right: 5%;
  bottom: 5%;
}

.scategory_form input,
.scategory_form textarea,
.scategory_form select {
  font-size: 12px !important;
}

.switch_input_wrapper {
  border: 1px solid lightgray;
  border-radius: 8px;
  width: 100%;
  background-color: white;
  overflow: hidden;
}

.detail_view_img {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 75px;
  width: 75px;
  border-radius: 50px;
  border: 1px solid lightgray;
}

.detail_view_img img {
  height: 75px;
  width: 75px;
  border-radius: 50px;
  border: 1px solid lightgray;
  object-fit: cover;
}

.detail_view_img .img_upload_label {
  position: absolute;
  right: 0;
  bottom: -5px;
  padding: 2px;
  border-radius: 50px;
  background-color: #f5bf00;
}

.add_attrib_value {
  background-color: azure !important;
}

.select_business {
  color: gray !important;
}

.enable_validation {
  border: 2px solid red !important;
  background-color: rgb(253, 244, 246) !important;
  border-radius: 4px;
}

.items_per_page_select {
  border: 1px solid #aeaeae;
  padding: 3px 5px 3px 5px;
  width: 29px;
  -webkit-appearance: none;
  text-align: center;
  border-radius: 6px;
  color: #f5bf00 !important;
  font-size: 14px;
}

.items_per_page_select::-webkit-appearance {
  display: none;
}

.per-page-text {
  font-size: 16px;
  color: #969696;
}

.items_per_page_select:focus {
  border: none;
  outline: none;
}

.items_per_page_select option:hover {
  background-color: #f5bf00 !important;
  color: white !important;
}

.column_main_wrapper {
  max-height: 70vh;
  overflow-y: scroll;
}

.col_btn_div {
  height: 60px;
  width: 300px;
}

.col_btn_div button {
  border: 2px solid #f5bf00 !important;
}

.col_btn_div button:hover {
  background-color: #facf35;
  border: 2px solid #facf35 !important;
}

.list_col_container {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 95vh;
  padding-bottom: 100px;
}

.selectedColumn {
  background-color: #f5bf00;
}

.col_blue_btn_div {
  height: 60px;
  width: 300px;
}

.selectedColumnBlue {
  background-color: #548dff;
}

.col_blue_btn_div button {
  border: 2px solid #548dff !important;
}

.col_blue_btn_div button:hover {
  background-color: #548dff;
}

.add_blue_btn {
  background-color: white;
  border: 1px solid lightgray !important;
  color: gray;
  border-radius: 8px;
  font-size: 80%;
  height: 35px;
}

.add_blue_btn .addbox_blue_icon {
  color: #548dff !important;
  height: auto !important;
}

.add_yellow_btn {
  background-color: white;
  border: 1px solid lightgray !important;
  color: gray;
  border-radius: 8px;
  font-size: 80%;
  height: 35px;
}

.add_yellow_btn .addbox_yellow_icon {
  color: #f5bf00 !important;
  height: auto !important;
}

.selectedColumnyellow {
  background-color: #f5bf00;
}

.scrollable_col_list {
  display: flex;
  list-style: none;
  max-width: 88vw;
  overflow-x: scroll;
  border: 2px dotted #f5bf00;
  height: 40px;
  width: 100%;
}

.scrollable_col_list::-webkit-scrollbar {
  display: none;
}

.scrollable_div {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

@media screen and (max-width: 576px) {
  .pc_display {
    display: none !important;
  }
  .mobile_display {
    display: block !important;
  }
  .service_header_mobile p {
    font-size: 12px;
    margin-top: -10px;
  }
  .service_header_mobile button {
    font-size: 12px !important;
    padding: 2px 12px !important;
  }
}
.overflow_main_dashboard {
  overflow-x: auto !important;
  background-color: #f8fafc;
}

.link-active {
  color: red;
  background-color: #ffd705;
}

.link-active:hover {
  color: white;
  background-color: #ffd705;
}

.link-white {
  color: #ffd705;
}

.link-white:hover {
  color: #ffd705;
}

.background_nav1_header {
  background-color: #548dff;
  height: 2.5rem;
}

.margin_left_m3 {
  margin-left: -60px;
}

.col6section {
  color: white;
}

.background_sidenav_one {
  background-color: rgb(248, 250, 252);
  height: 96vh;
  overflow: hidden !important;
  padding-left: 2%;
}

.background_sidenav_two {
  background-color: white;
  padding-top: 5%;
  padding-bottom: 5%;
  border-radius: 6px;
}

.background_sidenav_two_t {
  background-color: white;
  padding-top: 3%;
  padding-bottom: 3%;
  border-radius: 6px;
}

@media (max-width: 1200px) {
  .background_sidenav_one {
    padding-left: 0;
  }
}
.calendar {
  font-family: sans-serif;
  padding: 100px;
}
.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px;
  width: 100%;
}
.calendar-header h2 {
  margin: 0;
}
.calendar-header button {
  border: none;
  background-color: white;
  font-size: 16px;
  cursor: pointer;
}
.calendar-table {
  border-collapse: collapse;
  margin: 16px;
}
.calendar-table th {
  border: 1px solid black;
  padding: 8px;
  text-align: center;
}
.calendar-table td {
  border: none !important;
  cursor: pointer;
  display: flex;
  justify-content: end;
  align-items: end;
  height: 100%;
  color: black;
  font-weight: bold;
  font-size: 10pxß;
  padding: 10px 10px;
}
.calendar-table td.selected {
  background-color: #0074d9;
  color: white;
}
.calendar table tbody tr td {
  background-color: #fff;
  border: 10px solid #EDF0F6;
}
.calendar table tbody tr td div {
  cursor: pointer;
  display: flex;
  justify-content: end;
  align-items: end;
  height: 100%;
  color: black;
  font-weight: bold;
  font-size: 12px;
  padding: 10px 10px;
}
.calendar .tool-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-top: 20px;
  border-radius: 25px;
  background-color: #b5d5ff;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
}
.calendar .tool-tip:hover {
  cursor: pointer;
}
.calendar tool-tip::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 50%;
  background-color: #b5d5ff;
  transform: scale(0);
  transition: transform 0.2s;
}

.overflow_main_dashboard {
  overflow-x: auto !important;
  background-color: #F8FAFC;
}

.link-active {
  color: red;
  background-color: #FFD705;
}

.link-active:hover {
  color: white;
  background-color: #FFD705;
}

.link-white {
  color: #FFD705;
}

.link-white:hover {
  color: #FFD705;
}

.height_fiz_menu_active {
  height: 2%;
  background-color: #FFD705;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  color: white;
  margin-top: 10%;
}

.height_fiz_menu {
  color: #FFD705;
  font-size: 100%;
  margin-right: 10px;
}

.sidebar-title {
  font-size: 12px;
  font-family: "Roboto";
  margin: 2px 2px 2px 10px;
  color: #5C5C5C;
}

.background_nav1_header {
  background-color: #548DFF;
}

.side_nav_1_right {
  width: 100%;
  height: 87.5vh;
  overflow: auto;
}

.margin_left_m3 {
  margin-left: -60px;
}

.col6section {
  color: white;
}

.background_sidenav_two {
  background-color: white;
  padding-top: 5%;
  padding-bottom: 5%;
  border-radius: 6px;
}

.background_sidenav_two_t {
  background-color: white;
  padding-top: 3%;
  padding-bottom: 3%;
  border-radius: 6px;
}

.height_fiz_menu a {
  text-decoration: none !important;
  color: #000 !important;
}

.inv_active_menu {
  background-color: #FFD705 !important;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  color: black;
  padding-left: 10px;
}

.inv_inactive_menu {
  padding-left: 10px;
}

/* -------------------------------------------------------------------------- */
/*                        Selected Business From Header                       */
/* -------------------------------------------------------------------------- */
.makeRelative {
  position: relative;
}

.marginFromSearch {
  margin: "4% 0 0 0";
}

.searchDivPadding {
  padding: "3.6% 0";
}

.searchDiv {
  border: "1px solid #59F";
  background-color: "#FFFFFF";
  border-radius: "0.375rem";
  margin: "0 4.12% 0 4.12%";
  padding: "0 0.188rem 0 0.75rem";
}

.searchInput {
  border: "none";
  font-size: "0.625rem";
  color: "#AAA";
  font-style: "normal";
  font-weight: 400;
  line-height: "1.8rem";
}

.addBusinessButton {
  border: "1px solid #D9DEEC";
  border-radius: "0.938rem";
  margin-top: "2.6%";
  height: "4.9%";
  padding: "1.5rem 1.25rem ";
}

.addBusinessButtonFont {
  color: "#000";
  font-size: "1rem";
  font-style: "normal";
  font-weight: 400;
  line-height: "1.8rem";
}

.absoluteToCross {
  position: "absolute";
  top: "0";
  right: "0";
  cursor: "pointer";
}

.selectedBusinessIdFont {
  color: "#FFF";
  font-size: "16px";
  font-style: "normal";
  font-weight: 400;
  line-height: "normal";
}

.selectedBusinessNameFont {
  color: "#FFF";
  font-size: "20px";
  font-style: "normal";
  font-weight: 600;
  line-height: "normal";
}

.selectedBusinessBack {
  height: "9.6%";
  background-color: "#5599FF";
  border-radius: "0.938rem";
  display: "flex";
  align-items: "center";
}

.allBusiness {
  height: "89.5%";
  border: "1px solid #5599FF";
  border-radius: "0.938rem";
}

.buttonInHeader {
  position: "absolute";
  top: "90%";
  right: "-70%";
  z-index: 10000000000000;
  height: "95.8vh";
  width: "26.3vw";
  overflow: "auto";
  background-color: "white";
  border-radius: 0;
}

.businessNameFont {
  color: "#000";
  font-size: "1.125rem";
  font-style: "normal";
  font-weight: 500;
  line-height: "1.8rem";
}

.businessDesignationFont {
  color: "#838383";
  font-size: "0.75rem";
  font-style: "normal";
  font-weight: 400;
  line-height: "0.8rem";
}

.businessBack {
  background-color: white;
  margin-bottom: "0.5rem";
  padding-top: "0.5rem";
  padding-bottom: "0.5rem";
  padding-right: "1rem";
}

.selectedBusinessBackColor {
  background-color: #E0EDFF !important;
}

.border_bottom_header {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid lightgray;
  border-style: dashed;
  background-color: white;
}

.font_header_admin {
  font-size: 80%;
  font-weight: 800;
}

.font_header_admin1 {
  font-size: 80%;
  font-weight: 800;
  color: #0575E6 !important;
}

.button_profile {
  background-color: #EDECFF;
  color: #3E50F7;
  border-color: #EDECFF;
}

.dropdown_style {
  box-shadow: 1px 1px 7px 7px rgba(211, 211, 211, 0.263);
  border-radius: 10px;
  border: 1px dashed #0575E6;
}

.btn_style_dash {
  border: 1px dashed #0575E6 !important;
}

.btn_style_dash:hover {
  border: 1px dashed #0575E6 !important;
  color: #0575E6 !important;
}

.btn_style_dash:focus {
  border: 1px dashed #0575E6 !important;
  color: #0575E6 !important;
}

@media screen and (max-width: 980px) {
  .img_width {
    width: 30%;
  }
}
.dropdow {
  /* bottom: 36.03%; */
  color: #FF9669;
}

.img, svg {
  vertical-align: none;
}

.name {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 29px;
  /* identical to box height, or 180% */
  text-align: center;
  color: #6B6B6B;
}

.check {
  width: 40px;
}

.delete {
  width: 12px;
}

.greater {
  width: 1%;
  font-Size: 25px;
}

.gent {
  width: 145px;
}

.namestyle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 29px;
  color: #A4A4A4;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.table {
  max-width: 100%;
  background: #FFFFFF;
  border: 0 solid #DCDCDC;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.02);
  border-radius: 6px 0px 0px 0px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App {
  background-color: #fbfcff;
  height: 100vh;
  overflow: auto;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.selected-service-amount {
  color: #4D4D4D;
  text-align: center;
  font-family: "Roboto";
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
}

.selected-services {
  color: #443F3F;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.portal-heading {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  color: #8E8E8E;
}

.portal-card-add-booking {
  cursor: pointer;
  border-radius: 10px;
  border: 0.5px solid rgb(220, 220, 220);
  background-color: white;
  padding: 18px 38px !important;
  gap: 15px;
  width: 100px;
  box-shadow: 0px 5px 9px 0px rgba(176, 176, 176, 0.25);
}

.payment-choice-bottom-arrow:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 10px solid #FFD705;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.pos-relative {
  position: relative;
}

.payment-for-customer-heading {
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #FFD705;
}

.add-booking-custom-dropdown-header {
  border-radius: 6px;
  border: 1px solid #D7D7D7;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  cursor: pointer;
  height: 40px;
}

@media (max-width: 799px) {
  .column-state {
    margin-bottom: 1em;
  }
}
.wrapper {
  height: 100vh !important;
  padding-left: 5%;
}

.card {
  width: 100% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 8px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  padding: 10px !important;
  border: 0.5px solid #dcdcdc;
}

.card-mobile {
  width: 100% !important;
  min-width: 100px;
  padding: 9px !important;
  height: max-content !important;
  border-radius: 8px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  border: 0.5px solid #dcdcdc;
}

.card_selector {
  width: 100% !important;
  padding: 20px !important;
  height: 50px;
  border-radius: 8px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  padding: 4px 10px 20px 3px !important;
  border: 0.5px solid #dcdcdc;
}

.card-grey-provider {
  width: 70% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 9px 0px 0px 9px !important;
  color: #AFAFAF !important;
  background-color: #F8FAFC !important;
  padding: 5px !important;
}

.provider-content {
  position: fixed;
  top: "50%";
  left: "50%";
  transform: "translate(-50%, -50%)";
  background-color: "white";
  box-shadow: "rgb(0 0 0 / 58%) 0px 4px 16px";
  padding: "1rem";
  border-radius: "8px";
  z-index: "999";
}

.card2 {
  width: 100% !important;
  height: max-content !important;
  border-radius: 20px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  padding: 2px !important;
  border: 0.5px solid #dcdcdc;
}

.schedular-button {
  background-color: #337ab7;
  padding: 10px;
  border-radius: 10px;
  color: white;
}

.chat-card {
  width: 93% !important;
  padding: 6px !important;
  height: max-content !important;
  border-bottom: 1px solid #c4c4c4;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
}

.card_mobile {
  width: 100% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 20px !important;
  color: black !important;
  background-color: #f4f7fc !important;
  padding: 10px !important;
  border: 0.5px solid #DCDCDC;
}

.card-text {
  width: 48%;
  min-width: 550px;
  max-width: auto;
  height: max-content !important;
  border-radius: 8px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  padding: 3px !important;
  border: 0.5px solid #dcdcdc;
}

.card-text-mobile {
  width: 10%;
  min-width: 130px;
  height: max-content !important;
  border-radius: 5px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  border: 0.5px solid #dcdcdc;
}

.schedule_text {
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.schedule_text2 {
  color: #838383;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.schedule_text_mobile {
  color: #000;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.upload {
  width: 70;
  height: 15;
  padding: 2px 8px 2px 8px;
  background-color: #548DFF;
  border-radius: 8px;
  font-size: 12px;
  color: #ffffff;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
}

.subtype {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: #a9a9a9;
}

.product-name {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
}

.version {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #B5B6BA;
}

.subtype2 {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #b5b6ba;
}

.card-black {
  width: 100% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 9px !important;
  color: black !important;
  background-color: #d9d9d9 !important;
  padding: 10px !important;
}

.card-grey {
  width: 100% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 9px !important;
  color: #AFAFAF !important;
  background-color: #F1F6FE !important;
  padding: 5px !important;
}

.card-blue {
  width: 100% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 9px !important;
  color: white !important;
  background-color: #548DFF !important;
  padding: 10px !important;
}

.spanText {
  font-size: 14;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
}

.scroll {
  height: 100vh;
}

.arrows {
  display: flex;
  flex-direction: row;
  padding: 40px;
  height: 100%;
  overflow: hidden;
}

.form {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}

.add {
  display: flex;
  align-content: space-between;
  justify-content: center;
  align-items: baseline;
  justify-items: stretch;
  flex-direction: row;
}

.content {
  display: flex;
  align-content: center;
  justify-content: flex-start;
  align-items: stretch;
  margin-bottom: 20px;
}

.text {
  font-size: medium;
  font-weight: bold;
}

.text2 {
  padding-right: 50%;
}

.business_profile {
  color: #FFF;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.business_role {
  color: #FFF;
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
}

.vl {
  border-left: 0.7px solid white;
  height: 39px;
  opacity: 0.3;
}

.form-check-input[type=radio] {
  border: 1px solid #5599ff;
}

.span {
  color: #aaaaaa;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.spanDate {
  font-size: 16px;
  font-weight: bold;
  color: #8d8b8b;
}

.round-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #337ab7;
}

.span2 {
  font-size: large;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
  color: #212121;
  margin-top: 200px;
}

.date {
  font-size: medium;
  font-weight: bold;
  color: #559fff;
}
.date .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {
  width: 200px;
}

.check-box {
  display: flex;
  flex-direction: row;
}
.check-box .css-1qwvv1b-MuiTypography-root {
  color: #8d8b8b !important;
  font-size: 13px !important;
  font-weight: bold !important;
  font-family: "Times New Roman", Times, serif !important;
}

.card-cont {
  max-height: 92vh;
}

.card-header {
  background-color: #fff; /* replace with your desired color */
}

.card-footer {
  background-color: #fff; /* replace with your desired color */
}

.card-body-cont {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.button_schedular {
  margin-top: 5px;
  margin-left: 20px;
}

.checkbox {
  display: flex;
  width: 60px;
}

.checkboxes {
  display: flex;
}

.format3 {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  color: #8d8b8b;
  font-weight: bold;
  margin-left: 40px;
  margin-bottom: 10px;
}

.row {
  display: flex;
}

.dates {
  display: flex !important;
  justify-content: space-between !important;
  font-weight: bold !important;
  color: #8d8b8b !important;
}
.dates .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input {
  height: 15px !important;
  width: 150px !important;
  background-color: hsl(187, 62.962962963%, 86.5%) !important;
  border: 0 !important;
  border-radius: 2px !important;
}
.dates .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {
  background-color: hsl(187, 62.962962963%, 86.5%) !important;
  width: 180px !important;
}

.form-error {
  font-size: 12px;
  font-weight: normal;
  color: red;
  text-align: initial;
}

.autocomplete {
  display: flex;
  margin: 0px 0px 20px 0px;
}
.autocomplete .css-l3ln04-MuiAutocomplete-root {
  width: 250px !important;
  height: -50px !important;
}
.autocomplete .MuiAutocomplete-input {
  padding: 10px 4px 0px 5px !important;
  font-size: 12px;
  margin-top: -12px;
}

.format {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-left: 10px;
  font-weight: bold;
  color: #8d8b8b;
}
.format .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {
  background: #c8eef3 !important;
  width: 150px !important;
}

.format_mobile {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  font-weight: bold;
  color: #8d8b8b;
}
.format_mobile .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {
  background: #c8eef3 !important;
  width: 150px !important;
}

.formatFlex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin-left: 10px;
  font-weight: bold;
  color: #8d8b8b;
}
.formatFlex .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {
  background: #c8eef3 !important;
  width: 150px !important;
}

.format2 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: baseline;
  align-content: baseline;
  margin-left: 20px;
}

.time {
  color: #a3a3a3;
  font-family: "Roboto";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.padding {
  margin-left: 20px;
}

.week-wrapper {
  display: flex;
  justify-content: baseline;
  align-content: baseline;
}

.load-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  margin-top: 20px;
  border-radius: 1825px;
  background-color: #b5d5ff;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  border: none;
}

.buttons .css-sghohy-MuiButtonBase-root-MuiButton-root {
  height: 30px;
  margin-left: 300%;
}

.footer {
  display: flex;
  flex-direction: row;
  align-content: stretch;
  justify-content: space-between;
  align-items: baseline;
  padding: 6px 12px;
}

.business_role {
  color: rgb(255, 255, 255);
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
}

.business_profile {
  color: rgb(255, 255, 255);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
}

.load-more-button:hover {
  background-color: #b5d5ff;
  cursor: pointer;
}

.checkboxs {
  margin-right: 20px;
}

.arrow {
  position: absolute;
  right: 20px;
  font-size: 24px;
  transition: transform 0.2s;
  color: white;
}

.edit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-top: 20px;
  border-radius: 25px;
  background-color: #b5d5ff;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
}

.edit:hover {
  cursor: pointer;
}

.arrow {
  position: absolute;
  right: 20px;
  font-size: 24px;
  transition: transform 0.2s;
}

.edit:hover .arrow {
  transform: translateY(10px);
}

.edit::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 50%;
  background-color: #b5d5ff;
  transform: scale(0);
  transition: transform 0.2s;
}

.show-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-top: 20px;
  border-radius: 25px;
  background-color: #ffb5b5;
  color: white;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
}

.show-more-button:hover {
  cursor: pointer;
}

.arrow {
  position: absolute;
  right: 20px;
  font-size: 24px;
  transition: transform 0.2s;
}

.show-more-button:hover .arrow {
  transform: translateY(10px);
}

.border_schedule {
  border: 1px solid rgb(223, 222, 222);
  border-radius: 5px;
  padding-top: 8px;
  padding-bottom: 3px;
}

.new_font {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
}

.show-more-button::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 50%;
  background-color: #b5d5ff;
  transform: scale(0);
  transition: transform 0.2s;
}

.dx-scheduler-header {
  height: "0px";
  background-color: "transparent";
  border: "0px";
}

.dx-menu {
  font-size: 12px;
}

.dx-menu:hover {
  color: white;
}

@media (max-width: 799px) {
  .card,
  .card-schedular,
  .card-header,
  .check-box.content {
    width: 80%;
    padding: auto;
  }
}
@media (max-width: 500px) {
  .card,
  .card-schedular,
  .card-header,
  .check-box,
  .content {
    width: 75%;
    padding: auto;
  }
  .wrapper {
    overflow: auto;
  }
}
.slide-in {
  box-shadow: rgba(0, 0, 0, 0.58) 0px 4px 16px;
  z-index: 999;
  transition: right 0.8s ease-in-out;
  position: fixed;
  top: 50%;
}

.slide-in.active {
  transform: translate(72%, -50%); /* Move the content into view */
  width: 50vw !important;
  height: 100vh !important;
}

.cancel-creating-schedule {
  text-transform: capitalize;
  padding: 8px 30px;
  border-radius: 5px;
  margin-top: 20px;
  border: none;
  color: #999797;
  background: #E9E9E9;
  margin-right: 1em;
}

.save-creating-schedule {
  text-transform: capitalize;
  padding: 8px 30px;
  border-radius: 5px;
  margin-top: 20px;
  border: none;
  color: white;
  background: #5599FF;
}

.edit-creating-schedule {
  text-transform: capitalize;
  padding: 8px 30px;
  border-radius: 5px;
  margin-top: 20px;
  border: none;
  color: white;
  background: rgb(221, 75, 75);
}

.col-black {
  color: #1D1D1B !important;
}

.card1 {
  left: calc(50% - 753.5px - 0.5px);
  background: #FFFFFF;
  border: 0.8px solid #DCDCDC;
  border-radius: 8px;
  width: 20%;
}

.calander {
  left: calc(50% - 130px - 522px);
  top: 160px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  color: #414141;
}

.text {
  left: 16.04%;
  right: 58.85%;
  top: calc(50% - 37px - 531px);
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 38px;
  /* or 192% */
  letter-spacing: 0.2px;
  color: #414141;
}

.see {
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  line-height: 38px;
  letter-spacing: 0.2px;
  color: #5599FF;
}

.see:hover {
  cursor: pointer;
}

.image {
  width: 58.4px;
  height: 58.4px;
  left: calc(50% - 29.2px - 708.8px);
  top: 145px;
  background: #FBFCFF;
  border-radius: 8px;
}

.image2 {
  width: 644px;
  height: 397px;
  left: 1014px;
  top: 172px;
}

.bold-text {
  left: calc(50% - 338px);
  top: calc(50% - 28px - 130px);
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 35px;
  line-height: 56px;
  text-align: center;
  color: #414141;
  /* Change the color to your desired value */
}

.bold-text1 {
  left: 42.92%;
  right: 43.02%;
  top: calc(50% - 14px - 79px);
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */
  text-align: center;
  letter-spacing: 0.2px;
  color: #414141;
}

.image4 {
  width: 100%;
  top: 57.21%;
  bottom: 39.47%;
  background: #E8F0FD;
}

.hr {
  width: 93%;
  height: 0px;
  border: 0.6px solid #E5E9EE;
  transform: rotate(-180deg);
  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}

.dropdown {
  /* bottom: 36.03%; */
  border-radius: 6px;
}

.dropdow {
  color: #3C89FF;
}

.use {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #414141;
}

.dol {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;
  /* identical to box height */
  text-align: center;
  letter-spacing: 0.6px;
  color: #414141;
}

.month {
  height: 30px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.6px;
  color: #BCBCBC;
}

.calander {
  left: calc(50% - 130px - 522px);
  top: 160px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  color: #414141;
}

.text {
  left: 16.04%;
  right: 58.85%;
  top: calc(50% - 37px - 531px);
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 38px;
  /* or 192% */
  letter-spacing: 0.2px;
  color: #414141;
}

.see {
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  line-height: 38px;
  letter-spacing: 0.2px;
  color: #5599FF;
}

.see:hover {
  cursor: pointer;
}

.image {
  width: 58.4px;
  height: 58.4px;
  left: calc(50% - 29.2px - 708.8px);
  top: 145px;
  background: #FBFCFF;
  border-radius: 8px;
}

.image2 {
  width: 644px;
  height: 397px;
  left: 1014px;
  top: 172px;
}

.bold-text {
  left: calc(50% - 338px);
  top: calc(50% - 28px - 130px);
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 35px;
  line-height: 56px;
  text-align: center;
  color: #414141;
  /* Change the color to your desired value */
}

.bold-text1 {
  left: 42.92%;
  right: 43.02%;
  top: calc(50% - 14px - 79px);
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  /* identical to box height, or 156% */
  text-align: center;
  letter-spacing: 0.2px;
  color: #414141;
}

.image4 {
  width: 100%;
  top: 57.21%;
  bottom: 39.47%;
  background: #E8F0FD;
}

.hr {
  width: 93%;
  height: 0px;
  border: 0.6px solid #E5E9EE;
  transform: rotate(-180deg);
  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}

.dropdown {
  /* bottom: 36.03%; */
  border-radius: 6px;
}

.dropdow {
  color: #3C89FF;
}

.use {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #414141;
}

.dol {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 44px;
  /* identical to box height */
  text-align: center;
  letter-spacing: 0.6px;
  color: #414141;
}

.month {
  height: 30px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.6px;
  color: #BCBCBC;
}

.btns {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */
  text-align: center;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */
  text-align: center;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #AEB9D3;
}

.ba {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */
  text-align: center;
  color: #414141;
}

.form-check-input {
  left: 0px;
  top: 0px;
  border-radius: 6px;
}

.tick {
  box-sizing: border-box;
  width: 19px;
  height: 19px;
  background: #FFFFFF;
  border: 1px solid #DCDCDC;
  border-radius: 6px;
}

.spans {
  width: 70%;
  /* box-sizing: border-box; */
  background: #5599FF;
  border: 0.8px solid #5599FF;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  /* line-height: 15px; */
  /* identical to box height */
  text-align: center;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  align-items: center;
}

.cards {
  box-sizing: border-box;
  width: 330px;
  height: 188px;
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  border: 0.8px solid #DCDCDC;
  border-radius: 8px;
}

.box-height {
  height: 75vh;
  overflow-y: scroll;
}

.subs {
  width: 91px;
  height: 29px;
  left: 209px;
  top: 190px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  /* identical to box height, or 180% */
  color: #484848;
}

.record {
  color: #616161;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28.8px;
}

.subscribe {
  color: #484848;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28.8px;
}

.form-check-input {
  left: 0px;
  top: 0px;
  border-radius: 6px;
}

.select {
  color: #616161;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28.8px;
}

.position {
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
}

.pro {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 11px;
  color: #313131;
}

.twinty {
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 11px;
  font-family: "Roboto", sans-serif;
  text-align: right;
  color: #5599FF;
}

.chat {
  /* font-family: roboto, Heebo Medium; */
  font-style: normal;
  font-weight: 600;
  font-style: normal;
  font-size: 15px;
  /* identical to box height, or 180% */
}

.four {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  /* line-height: 16px; */
  /* or 132% */
  color: #5599FF;
}

.vector {
  right: 97.83%;
  /* top: 81.25%; */
  bottom: 10.03%;
  /* border: 1.2px solid #D5D5D5; */
}

.vector1 {
  left: 1.05%;
  right: 95.82%;
  /* top: 81.4%; */
  bottom: 9.88%;
  size: 7rem;
}

.button {
  /* height: 34px; */
  border-radius: 6px;
}

.button1 {
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  /* left: 556px; */
  border: 1px solid #A9A9A9;
  border-radius: 6px;
}

.h1 {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  /* line-height: 29px; */
  /* identical to box height, or 240% */
  text-align: center;
  color: #A9A9A9;
}

.img_profile_shape {
  height: 100px;
  width: 100px;
  object-fit: fill;
  border: 1px solid;
  border-radius: 50px;
}

.text_color_account {
  color: gray;
  font-size: 90%;
}

.sub_text_color_account {
  color: rgb(194, 194, 194);
  font-size: 80%;
}

.complete {
  background-color: #1ce0a3;
  opacity: 0.1;
  color: #1ce0a3;
  width: 74px;
  height: 20px;
  color: red;
  border-radius: 50px;
}

.complete-text {
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-div {
  background-color: #e8fcf6;
  width: 80px;
  height: 30px;
  border-radius: 50px;
  /* Add padding as desired */
}

.green-text {
  color: #1ce0a3;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* Additional styling for the <p> element */
}

.custom-div2 {
  background-color: rgb(118, 164, 255);
  width: 80px;
  height: 30px;
  border-radius: 50px;
  /* Add padding as desired */
}

.white-text {
  color: white;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* Additional styling for the <p> element */
}

.sub_text_color_account_alltext {
  color: #aaa;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.background_color_showboxes {
  background-color: #fff;
  padding-top: 1%;
  padding-bottom: 1%;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  cursor: pointer;
}

.sub_text_color_account_alltext_show {
  color: #aaa;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub_text_color_account_alltext_show_actual {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub_text_color_account_alltext_show_grey {
  color: #AFAFAF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

#color_icon_right {
  color: #a9a9a9;
}

.box_height_profile {
  height: 75vh;
  overflow-y: scroll;
}

.box_height_profile1 {
  height: 75vh;
  overflow-y: scroll;
}

.box_height_profile1::-webkit-scrollbar {
  display: none;
}

.background_color_line {
  background-color: #f1f1f1 !important;
  color: white !important;
  border: 2px solid #f1f1f1 !important;
}

.img_verified_size {
  width: 8%;
  padding-right: 3%;
}

#style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#style-2::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

#style-2::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #548dff;
}

.disabled_button {
  background-color: #548dff !important;
  cursor: no-drop !important;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
}

.btnn {
  border: 2px solid #0069d9;
  color: #0069d9;
  background-color: white;
  padding: 2px 5px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer !important;
}

.margin_neg_button {
  top: 80px;
  position: absolute;
  left: 90px;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.padding_left_right {
  padding-left: 20%;
  padding-right: 20%;
  overflow-y: scroll;
}

.border_rad_new {
  border: 0.8px solid #dcdcdc;
  border-radius: 10px;
  background-color: white;
  padding-bottom: 9px;
}

.border_rad_new1 {
  border: 0.8px solid #dcdcdc;
  border-radius: 10px;
  background-color: white;
}

.card-link {
  width: 100% !important;
  padding: 20px !important;
  height: max-content !important;
  border-radius: 8px !important;
  color: black !important;
  background-color: rgb(255, 255, 255) !important;
  padding: 5px !important;
  border: 0.5px solid #DCDCDC;
  box-shadow: 2px 2px #DCDCDC;
}

.button_color_primary {
  background-color: #548dff !important;
  border-radius: 6px !important;
}

.label_text_business {
  color: #dcdcdc;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
}

.input_style_fix {
  border: 0px solid white;
  outline: none;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.input_style_fix::placeholder {
  color: #aaaaaa;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.padding_left_right::-webkit-scrollbar {
  display: none;
}

.padding_next_primary_button {
  padding-left: 10%;
  padding-right: 10%;
  background-color: #548dff !important;
  border-radius: 6px !important;
}

.padding_next_secondary_button {
  padding-left: 10%;
  padding-right: 10%;
  border-radius: 6px;
  background: #edf0f5 !important;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.16) !important;
  color: rgb(179, 179, 179) !important;
}

.height_width_fix {
  height: 70px;
  width: 70px;
}

.text_heading_owner {
  color: #548dff;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.text_heading_customer {
  color: #0f0f10;
  font-family: "Roboto";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.padding_set_new {
  padding-left: 22px !important;
}

.owner-text {
  color: #dcdcdc;
}

.greenText {
  background-color: 255;
  color: white;
}

.label_text_department {
  font-size: 12px;
  color: #dcdcdc;
}

.form-control1 {
  display: block;
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding: 2px;
  appearance: auto;
  /* line-height: 29px; */
  /* identical to box height, or 160% */
  color: #232323;
  border: none !important;
}

.text-size {
  font-size: 14px;
}

.search-bar-textfield {
  display: block;
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding: 2px;
  appearance: auto;
  /* line-height: 29px; */
  /* identical to box height, or 160% */
  color: #232323;
  border: 1px solid grey !important;
}

.form-control:focus {
  border: 0;
  box-shadow: none;
  font-size: 12px;
}

.form-control::placeholder {
  color: "#AAAAAA";
  font-size: 12px;
}

.custom-dropdown {
  display: block;
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding: 2px;
  appearance: auto;
  /* line-height: 29px; */
  /* identical to box height, or 160% */
  border: none !important;
}

.custom-select option:nth-child(1) {
  color: red; /* Set the color for disabled options */
}

.hide_input_border:focus {
  border: none !important;
}

.padding_Set_add {
  padding-left: 10px;
  padding-right: 10px;
}

.img_height_w {
  height: 40px;
  width: 40px;
  object-fit: cover;
}

.heaing_it_sol {
  color: #616161;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.heaing_it_sol1 {
  color: #8a8a8a;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.heaing_it_sol2 {
  color: #8a8a8a;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.img_profile_shape {
  height: 100px;
  width: 100px;
  object-fit: fill;
  border-radius: 50px;
  border: 1px solid;
}

.text_color_account {
  color: gray;
  font-size: 90%;
}

.sub_text_color_account {
  color: rgb(194, 194, 194);
  font-size: 80%;
}

.sub_text_color_account_alltext {
  color: #AAA;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.background_color_showboxes {
  background-color: #fff;
  padding-top: 1%;
  padding-bottom: 1%;
  border-radius: 8px;
  border: 1px solid #DCDCDC;
  cursor: pointer;
}

.sub_text_color_account_alltext_show {
  color: #AAA;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.sub_text_color_account_alltext_show_actual {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

#color_icon_right {
  color: #A9A9A9;
}

.img_profile_shape1 {
  height: 100px;
  width: 100px;
  object-fit: fill;
  border-radius: 10px;
  border: 1px solid;
}

.text_color_account1 {
  color: #808080;
  font-size: 12px;
}

.sub_text_color_account_alltext1 {
  color: #AAAAAA;
  font-size: 13px;
}

.id_text_color {
  color: #B1B4B7;
  font-size: 10px;
}

.box_height_profile {
  height: 75vh;
  overflow-y: scroll;
}

.box_height_profile1 {
  height: 75vh;
  overflow-y: scroll;
}

.box_height_profile1::-webkit-scrollbar {
  display: none;
}

.background_color_line {
  background-color: #F1F1F1 !important;
  color: white !important;
  border: 2px solid #F1F1F1 !important;
}

.img_verified_size {
  width: 8%;
  padding-right: 3%;
}

#style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar {
  width: 5px;
  display: hide !important;
  background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #548DFF;
}

.disabled_button {
  background-color: #548DFF !important;
  cursor: no-drop !important;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  cursor: pointer;
}

.btnn {
  border: 2px solid #0069D9;
  color: #0069D9;
  background-color: white;
  padding: 2px 5px;
  border-radius: 50px;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer !important;
}

.margin_neg_button1 {
  top: 80px;
  position: absolute;
  left: 90px;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.provider-popup-dataview-field {
  color: black !important;
  font-weight: 500;
}

.center-cols {
  width: 96% !important;
  margin: auto !important;
}

.selected-business {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 500px) {
  .padding_left_right {
    padding-left: 12px;
    padding-right: 12px;
  }
  .img_profile_shape1 {
    height: 100px;
    width: 100px;
    object-fit: fill;
    border-radius: 50%;
    border: 1px solid;
  }
  .margin_neg_button1 {
    margin-left: 150px;
    margin-top: 70px;
  }
  .card-link {
    width: 100% !important;
    padding: 20px !important;
    max-width: 90px;
    height: max-content !important;
    border-radius: 8px !important;
    color: black !important;
    background-color: rgb(255, 255, 255) !important;
    padding: 0px !important;
    border: 0.5px solid #DCDCDC;
    box-shadow: 2px 2px #DCDCDC;
  }
}
body {
  font-family: "Roboto", sans-serif !important;
  background-color: #fbfcff;
}

.vh-69 {
  height: 69vh;
}

.break-word {
  overflow-wrap: break-word;
}

.selected-attribute {
  border: 2px solid #FFD705;
  border-radius: 10px;
  padding: 2px 0px 2px 0px;
}

.side_nav_main_1 {
  height: 89vh;
  overflow: auto;
  width: 3%;
  transition: width 0.7s ease; /* Smooth transitions for width and margin */
  border-top: 0.025rem solid #ffd705;
  border-right: 0.025rem solid #ffd705;
  border-top-right-radius: 0.625rem;
  background-color: white;
  cursor: pointer;
  z-index: 99999999 !important;
  position: absolute;
}

.side_nav_main_1.expanded {
  width: 14%;
  margin: auto;
  margin-left: 0; /* Reset margin-left */
  transition: width 0.7s ease;
  z-index: 99999999999999 !important;
  position: absolute;
}

@media (max-width: 500px) {
  .side_nav_main_1.expanded {
    width: 150px;
  }
}
.errorMessage {
  font-size: 12px;
  color: #d41313;
  line-height: 1.125rem;
  text-align: left;
}

.fade-in-text {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  color: #000000 !important;
}

.fade-in-text.visible {
  opacity: 1;
}

.react-tel-input .selected-flag .arrow {
  top: 60% !important;
  left: 5px !important;
}

.css-i4bv87-MuiSvgIcon-root {
  color: grey !important;
  border-radius: 6.25rem !important;
  padding: 0.25rem !important;
}

.css-1db085k-MuiSvgIcon-root {
  color: grey !important;
  background-color: white !important;
  border-radius: 100px !important;
  padding: 4px !important;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-left: 5px;
  text-align: left;
}

/*.rbc-btn-group{
  display: none !important;
} */
.rbc-toolbar-label {
  font-weight: 600;
  text-align: start;
  padding: 2;
  color: #5599ff;
}

.rbc-time-view {
  border: none !important;
}

.rbc-time-header-content {
  border: none !important;
}

.rbc-time-header-content > .rbc-row.rbc-row-resource {
  border-bottom: 0 !important;
  height: 4rem !important;
}

.rbc-time-content > * + * > * {
  border-left: 0 !important;
}

/* .rbc-toolbar{
  display: none !important;
} */
.rbc-timeslot-group {
  min-height: 2.6rem !important;
}

.rbc-time-slot {
  height: 100%;
}

.rbc-event {
  border: 1px solid white !important;
  display: flex;
  flex-direction: column;
  width: 100% !important;
  left: 0 !important;
}

.rbc-label {
  display: flex;
  text-align: center !important;
  min-width: 3.125rem !important;
  font-weight: 500 !important;
  font-size: 0.625rem !important;
  margin-top: -2px !important;
  color: #5b5b5b !important;
}

.rbc-events-container {
  width: 100% !important;
  left: 0 !important;
  margin-right: 2px !important;
  border-right: 0.2px solid #666666 !important;
}

.container-less-more {
  text-align: center;
  margin: auto;
  /* justify-content: space-evenly; */
  max-width: 30rem;
}

.geeks {
  color: green;
}

.audio-container {
  position: relative;
}

.no-preview-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 8px;
  border-radius: 5px;
  display: none;
}

.list-group {
  position: relative;
  display: block;
  padding: 10;
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
}

.audio-container:hover .no-preview-label {
  display: block;
  color: "#000";
}

.text-read-hide-less {
  display: inline;
  width: 90%;
}

.read-or-hide {
  color: rgb(192, 192, 192);
  cursor: pointer;
}

.rbc-header {
  color: #000;
  font-size: 20px !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.rbc-month-header > div:nth-child(1),
.rbc-month-header > div:nth-child(7) { /* Sunday */
  color: red;
}

.rbc-event-label {
  font-weight: 700;
  display: none !important;
}

.rbc-event {
  font-weight: 600;
}

.rbc-time-content > .rbc-day-slot {
  width: 100% !important;
}

.rbc-time-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  border-radius: 10px;
}

.rbc-time-content::-webkit-scrollbar {
  width: 5px;
  display: hide !important;
  height: 5px;
  background-color: #f5f5f5;
}

.rbc-time-content::-webkit-scrollbar-thumb {
  background-color: #ffbf00;
  border-radius: 10px;
  /* background-image: -webkit-linear-gradient(0deg,
                                           rgba(255, 255, 255, 0.8) 25%,
  									  transparent 25%,
  									  transparent 50%,
  									  rgba(255, 255, 255, 0.8) 50%,
  									  rgba(255, 255, 255, 0.8) 75%,
  									  transparent 75%,
  									  transparent) */
}

.rbc-today {
  background-color: transparent !important;
}

.react-datepicker-wrapper {
  width: 40px !important;
  margin-left: -40px !important;
}

.react-datepicker__input-container input {
  text-align: center !important;
}

.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  width: 100% !important;
}

.react-datepicker__triangle {
  left: 40px !important;
}

.rbc-toolbar button {
  border: none !important;
  font-weight: 500 !important;
}

.rbc-active {
  background-color: #5599ff !important;
  color: white !important;
}

.rbc-btn-group button:hover {
  background-color: rgb(107, 107, 107);
}

.react-datepicker-popper {
  z-index: 99 !important;
  inset: 0px auto auto -51px !important;
}

.rbc-month-view {
  height: 100vh !important;
}

.rbc-current-time-indicator {
  display: none !important;
}

.css-bdhsul-MuiTypography-root-MuiDialogTitle-root {
  padding: 0 !important;
}

.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: #5599ff !important;
}

.css-1aquho2-MuiTabs-indicator {
  background-color: #5599ff !important;
}

.css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {
  display: none !important;
}

.css-74e2me-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {
  border: none !important;
}

.css-13xfq8m-MuiTabPanel-root {
  padding: 0px !important;
}

.css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input {
  display: flex;
  align-items: center;
}

.css-19khbc0-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {
  display: none !important;
}

/* .css-l4u8b9-MuiInputBase-root-MuiInput-root:before{
  display: none !important;
} */
.rbc-time-header .rbc-overflowing {
  border: none !important;
}

.rbc-time-view-resources .rbc-time-gutter,
.rbc-time-view-resources .rbc-time-header-gutter {
  border: none !important;
}

.rbc-time-content {
  border-top: 2px solid darkgray !important;
  border-bottom: 2px solid darkgray !important;
  padding-top: 5px;
}

.rbc-time-view .rbc-time-header {
  height: 3.6rem !important;
  padding: 0 !important;
  margin: 0 !important;
}

.rbc-time-content > .rbc-time-gutter {
  border-right: 1px solid #ddd !important;
}

.rbc-event {
  border-radius: 5px !important;
  padding: 0 !important;
  border-width: 1px !important;
  min-height: 1rem !important;
  width: 100% !important;
  margin-left: 0px !important;
  margin-top: 0.03rem !important;
}

textarea:focus {
  outline: none;
}

.rbc-timeslot-group {
  border: none !important;
}

.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid #e3e3e3 !important;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  display: none !important;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  display: none !important;
}

.pt1 {
  background-color: #343a40 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), linear-gradient(to right top, #343a40, #2b2c31, #211f22, #151314, #000000) !important;
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 3.2px 8px !important;
}

ul.dropdown-menu::-webkit-scrollbar {
  width: 0.313rem; /* Width of the scrollbar */
}

ul.dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1; /* Track color (gray by default) */
}

ul.dropdown-menu::-webkit-scrollbar-thumb {
  background: #ffbf00; /* Thumb color (gray by default) */
  border-radius: 0.125rem; /* Rounded corners for the thumb */
}

/* Customize the scrollbar for Firefox */
ul.dropdown-menu {
  scrollbar-width: thin; /* Thin scrollbar for Firefox */
  scrollbar-color: #ffbf00 #f1f1f1; /* Thumb and track colors */
}

.ellipsis {
  width: 100px;
  text-overflow: ellipsis; /* enables ellipsis */
  white-space: nowrap; /* keeps the text in a single line */
  overflow: hidden; /* keeps the element from overflowing its parent */
}

.booking_customer_name {
  font-size: 12px;
  text-transform: capitalize;
  margin: 0px;
}

.booking_service_name {
  font-size: 12px;
  font-weight: 400;
  margin: 7px 0px;
}

.booking_time {
  font-size: 10px;
  margin: 0px;
  font-weight: normal;
}

.input-container input {
  border: none;
  box-sizing: border-box;
  outline: 0;
  position: relative;
  width: 100%;
}

input[type=date]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

::-webkit-scrollbar {
  width: 1px;
  display: block !important;
  height: 2px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #ffbf00;
  border-radius: 10px; /* rounded corners */
}

::-webkit-scrollbar-thumb:hover {
  background: #555; /* color of the thumb on hover */
}

.rbc-calendar {
  height: 99.7% !important;
}

@media (max-width: 700px) {
  .rbc-time-view-resources .rbc-header,
  .rbc-time-view-resources .rbc-day-bg {
    width: 70px !important;
  }
  .rbc-time-content > .rbc-day-slot {
    min-width: 70px !important;
  }
  .rbc-events-container {
    min-width: 70px !important;
  }
  .booking_customer_name {
    font-size: 9px;
  }
  .booking_service_name {
    font-size: 8px;
  }
  .booking_time {
    font-size: 7px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Assets/Scss/globalStyleSheet.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss","webpack://./src/Assets/components/businessProfile/style.scss","webpack://./src/Assets/components/App.scss","webpack://./src/Assets/components/calender.scss","webpack://./src/Assets/components/serviceInventory/create.scss","webpack://./src/Assets/components/serviceInventory/global.scss","webpack://./src/Assets/components/serviceInventory/services.scss","webpack://./src/Assets/components/serviceInventory/dashboard.scss","webpack://./src/Assets/components/calenderstyle.scss","webpack://./src/Assets/components/sidebar/style.scss","webpack://./src/Assets/components/HeaderAdmin.scss","webpack://./src/Assets/components/Stafflist.scss","webpack://./src/Assets/components/AddBookings.scss","webpack://./src/Assets/components/style.scss","webpack://./src/Assets/components/mediaQueries.scss","webpack://./src/Assets/components/businessProfile/Calendar.scss","webpack://./src/Assets/components/subscribe/subscribed.scss","webpack://./src/Assets/components/dashboardpages.scss","webpack://./src/Assets/components/AddBusiness.scss","webpack://./src/Assets/Scss/veriables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE;IAKE,uBAAA;EDAF;ECGA;IACE,wBAAA;EDDF;ECIA;IACE,yBAAA;EDFF;ECKA;IACE,uBAAA;EDHF;ECMA;IACE,wBAAA;EDJF;AACF;AEOA;EACE,cC1Bc;ED2Bd,YAAA;EACA,YC3Bc;ED4Bd,gBC5Bc;ED6Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;AFLF;AEME;EACE,mBCpCe;EDqCf,YAAA;EACA,kBAAA;EACA,YAAA;AFJJ;AEMI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AFJN;AEOI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AFLN;AEOM;EACE,iDAAA;AFLR;AEOM;EACE,YAAA;AFLR;AEOM;EACE,8CAAA;AFLR;AEOM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AFLR;AEUE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;AFRJ;AEWE;EACE,WCxFsB;EDyFtB,eCzFsB;AHgF1B;AEYE;EACE,iBAAA;EACA,cAAA;AFVJ;AEcI;EADF;IAnGA,eAAA;IACA,YAAA;EF0FA;EEzFA;IACE,WAAA;EF2FF;EEzFA;IACE,OAAA;EF2FF;EE1FE;IACE,cAAA;EF4FJ;EEzFA;IACE,UAAA;IACA,aAAA;EF2FF;EE1FE;IACE,UAAA;IACA,YAAA;EF4FJ;EE1FE;IACE,UAAA;IACA,QAAA;EF4FJ;AACF;AERI;EADF;IAxGA,eAAA;IACA,YAAA;EFqHA;EEpHA;IACE,WAAA;EFsHF;EEpHA;IACE,OAAA;EFsHF;EErHE;IACE,cAAA;EFuHJ;EEpHA;IACE,UAAA;IACA,aAAA;EFsHF;EErHE;IACE,UAAA;IACA,YAAA;EFuHJ;EErHE;IACE,UAAA;IACA,QAAA;EFuHJ;AACF;AE9BI;EADF;IA7GA,eAAA;IACA,YAAA;EFgJA;EE/IA;IACE,WAAA;EFiJF;EE/IA;IACE,OAAA;EFiJF;EEhJE;IACE,cAAA;EFkJJ;EE/IA;IACE,UAAA;IACA,aAAA;EFiJF;EEhJE;IACE,UAAA;IACA,YAAA;EFkJJ;EEhJE;IACE,UAAA;IACA,QAAA;EFkJJ;AACF;AEpDI;EADF;IAlHA,eAAA;IACA,YAAA;EF2KA;EE1KA;IACE,WAAA;EF4KF;EE1KA;IACE,OAAA;EF4KF;EE3KE;IACE,cAAA;EF6KJ;EE1KA;IACE,UAAA;IACA,aAAA;EF4KF;EE3KE;IACE,UAAA;IACA,YAAA;EF6KJ;EE3KE;IACE,UAAA;IACA,QAAA;EF6KJ;AACF;AE1EI;EADF;IAvHA,eAAA;IACA,YAAA;EFsMA;EErMA;IACE,WAAA;EFuMF;EErMA;IACE,OAAA;EFuMF;EEtME;IACE,cAAA;EFwMJ;EErMA;IACE,UAAA;IACA,aAAA;EFuMF;EEtME;IACE,UAAA;IACA,YAAA;EFwMJ;EEtME;IACE,UAAA;IACA,QAAA;EFwMJ;AACF;AEhGI;EADF;IA5HA,eAAA;IACA,YAAA;EFiOA;EEhOA;IACE,WAAA;EFkOF;EEhOA;IACE,OAAA;EFkOF;EEjOE;IACE,cAAA;EFmOJ;EEhOA;IACE,UAAA;IACA,aAAA;EFkOF;EEjOE;IACE,UAAA;IACA,YAAA;EFmOJ;EEjOE;IACE,UAAA;IACA,QAAA;EFmOJ;AACF;;AIxPE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AJ2PJ;;AItPA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AJyPF;;AIrPE;EACE,iBAAA;EACA,oBAAA;AJwPJ;AIpPQ;EACE,kBAAA;EACA,yBD1BS;AHgRnB;AIpPU;EACE,iBAAA;EACA,oBAAA;AJsPZ;AIjPI;EACE,qBAAA;EACA,cDzCU;AH4RhB;AIlPM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AJoPR;AIlPM;EACE,cDjDU;AHqSlB;AIjPI;EACE,eAAA;AJmPN;AIlPM;EACE,cDvDU;AH2SlB;AIjPM;EACE,UAAA;EACA,wBAAA;AJmPR;AIjPM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AJmPR;AIhPM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AJkPR;AIhPQ;EACE,aAAA;EACA,cD9EQ;AHgUlB;AIhPQ;EACE,kBAAA;EACA,eAAA;EACA,WD/EE;ECgFF,eDhFE;ECiFF,YDjFE;ECkFF,iBDlFE;ECmFF,kBAAA;EACA,qBAAA;AJkPV;AIhPU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AJkPZ;AI9OQ;EACE,YAAA;EACA,cAAA;AJgPV;AI3OQ;EACE,cD1GQ;AHuVlB;AI3OY;EACE,6CAAA;AJ6Od;AIrOU;EACE,mBDzHI;AHgWhB;AIpOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AJsOZ;AIpOY;EACE,qBAAA;EACA,mBAAA;EACA,qBDrIE;ECsIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AJsOd;AI/NY;EACE,kCAAA;AJiOd;AI9Nc;EACE,wBAAA;AJgOhB;AI1NQ;EACE,kBDrJO;AHiXjB;AI1NU;EACE,0BAAA;AJ4NZ;AI1NY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AJ4Nd;AIpNM;EACE,aAAA;AJsNR;AI1MU;EACE,yBDvLI;AHmYhB;AInMU;EACE,gBAAA;AJqMZ;AI7LU;EACE,kBAAA;AJ+LZ;AIvLU;EACE,kBAAA;AJyLZ;AI7KQ;EAWE,kBAAA;AJqKV;AI9KY;;EAEE,UAAA;AJgLd;AI7KU;EACE,yBDxOiB;ECyOjB,YAAA;AJ+KZ;AI5KU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AJ8KZ;AI5KU;EACE,kBAAA;AJ8KZ;AI5KY;EACE,oBAAA;AJ8Kd;AI5Kc;EACE,aAAA;AJ8KhB;AI3KY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AJ6Kd;AI5Kc;EACE,kBAAA;AJ8KhB;AI5Kc;EACE,iBAAA;EACA,gBAAA;EACA,yBD/Qa;ECgRb,kBAAA;EACA,kBAAA;AJ8KhB;AI1Kc;EACE,sCAAA;EACA,mBAAA;AJ4KhB;AIzKgB;EACE,6CAAA;AJ2KlB;AIrKc;;EAEE,yBAAA;AJuKhB;AI1JQ;EACE,eAAA;EACA,gBAAA;AJ4JV;AI1JQ;EACE,0BAAA;AJ4JV;AI3JU;EACE,eAAA;EACA,iBAAA;AJ6JZ;AIvJY;EACE,WAAA;EACA,UAAA;AJyJd;AIxJc;EACE,yBAAA;AJ0JhB;AInJgB;EACE,wBAAA;AJqJlB;AI/IU;EACE,eAAA;EACA,mBD/UK;AHgejB;AI/IY;EACE,0BAAA;AJiJd;AIhJc;EACE,eAAA;EACA,iBAAA;AJkJhB;AIpIc;EACE,eAAA;EACA,kBAAA;AJsIhB;AIrIgB;EACE,mBAAA;AJuIlB;AIrIgB;EACE,eAAA;EACA,mBAAA;AJuIlB;AIlIgB;;EAEE,yBAAA;AJoIlB;;AK/fA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;ALkgBF;;AK/fA;EACE,QAAA;EACA,+BAAA;ALkgBF;;AK/fA;EACE,OAAA;EACA,8BAAA;ALkgBF;;AMlhBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ANqhBF;;AMlhBA;EACE,kBAAA;ANqhBF;;AMlhBA;EACE,aAAA;ANqhBF;;AOjiBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;APoiBF;;AOliBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;APqiBF;;AOniBA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;APqiBA;;AOniBA;EACE,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,oCAAA;EACA,uBAAA;APsiBF;;AOniBA;EACE,eAAA;EACA,YAAA;EACA,YAAA;APsiBF;;AOpiBA;EACE,SAAA;APuiBF;;AOriBA;EACA,YAAA;EACA,gBAAA;APwiBA;;AOtiBA;EACA,eAAA;APyiBA;;AOtiBA;EACE,cAAA;EACF,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;APyiBA;;AOviBA;EACE,cAAA;EACA,gBAAA;AP0iBF;;AOxiBA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AP2iBF;;AOziBA;EACE,cAAA;AP4iBF;;AOziBA;EACE,eAAA;EACA,YAAA;AP4iBF;;AOviBA;EACE,cAAA;EACF,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AP0iBA;;AOxiBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AP2iBF;;AOziBE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AP4iBJ;;AO1iBE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AP6iBJ;;AO3iBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AP8iBJ;;AO5iBE;EACE,iBAAA;EAAiB,cAAA;EAAc,gBAAA;APijBnC;;AO/iBE;EACF,yBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;APkjBA;;AO/iBC;EACC,yBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;APkjBF;;AOhjBG;EACC,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;APmjBJ;;AOjjBG;EACC,yBAAA;EACA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;APojBJ;;AOljBE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;APqjBJ;;AOnjBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;APsjBF;;AOpjBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;APujBF;;AOpjBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;APujBF;;AOrjBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;APwjBF;;AOpjBA;EACE,gBAAA;EACA,eAAA;APujBF;;AOrjBA;EACE,eAAA;EACA,gBAAA;APwjBF;;AOtjBA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;APyjBF;;AOtjBA;EACE,eAAA;EACA,yBAAA;EACA,YAAA;APyjBF;;AOvjBA;EACE,qBAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AP0jBJ;;AOxjBA;EACE,gCAAA;EACA,qBAAA;AP2jBF;;AOxjBA;EACE,eAAA;AP2jBF;;AOzjBA;EACG,qBAAA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AP4jBJ;;AO1jBA;EACE,yBAAA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AP6jBJ;;AO1jBA;EACE,gBAAA;EACA,gBAAA;AP6jBF;;AO3jBA;EACE,wBAAA;EACA,mBAAA;EAEC,kBAAA;AP6jBH;;AO3jBA;EACE,WAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AP6jBF;;AQzyBA;EACE,cAAA;EACA,oBAAA;AR4yBF;;AQzyBA;EACE;IACE,4CAAA;ER4yBF;AACF;AQ1yBA;EACE,yBAAA;EACC,aAAA;EACC,cAAA;AR4yBJ;;AQxyBA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AR2yBF;;AQxyBA;EACE,cAAA;AR2yBF;;AQxyBA;EACE;IACE,uBAAA;ER2yBF;EQzyBA;IACE,yBAAA;ER2yBF;AACF;AS51BA;EACI,kBAAA;EAEA,qBAAA,EAAA,YAAA;EACF,wBAAA,EAAA,0BAAA;AT61BF;;ASz1BA;EACI,uBAAA;EACA,oCAAA;EACA,mBAAA;AT41BJ;;ASz1BA;EACI,uBAAA;AT41BJ;;ASv1BA;EACI,aAAA,EAAA,kCAAA;AT01BJ;;ASl1BA;EACI,YAAA;EACA,kBAAA;ATq1BJ;;ASl1BA;EACI,oDAAA;EACA,mBAAA;EACA,yBAAA;ATq1BJ;;ASl1BA;EACI,UAAA;EACA,yBAAA;ATq1BJ;;ASl1BA;EACI,mBAAA;EACA,oDAAA;EACA,WAAA;EACA,yBAAA;ATq1BJ;;AUt4BA;;;EAGE,uBAAA;EACA,eAAA;EACA,WAAA;AVy4BF;;AUt4BA;EACE,2BAAA;EACA,wBAAA;AVy4BF;;AUt4BA;;;EAGE,gBAAA;EACA,aAAA;AVy4BF;;AUt4BA;EACE,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AVy4BF;;AUt4BA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AVy4BF;;AUt4BA;EACE,6BAAA;EACA,iBAAA;AVy4BF;;AUt4BA;EACE,0BAAA;EACA,uBAAA;AVy4BF;;AUt4BA;EACE,sCAAA;AVy4BF;;AUt4BA;EACE,2BAAA;EACA,kBAAA;EACA,kCAAA;AVy4BF;;AUt4BA;EACE,YAAA;EACA,0BAAA;AVy4BF;;AUt4BA;EACE,wCAAA;EACA,sCAAA;EACA,0BAAA;EACA,sBAAA;EACA,oCAAA;AVy4BF;;AUt4BA;EACE,sBAAA;AVy4BF;;AUl3BA;EACE,4BAAA;AVq3BF;;AUn3BA;EACE,wBAAA;AVs3BF;;AUn3BA;EACE,gBAAA;AVs3BF;;AUn3BA;EACE,cAAA;AVs3BF;;AUn3BA;EACE,yBAAA;AVs3BF;;AUn3BA;EACE,yBAAA;AVs3BF;;AUn3BA;EACE,yBAAA;AVs3BF;;AUn3BA;EACE,oCAAA;EACA,6BAAA;AVs3BF;;AUn3BA;EACE,0BAAA;AVs3BF;;AUl3BA;EACE,6BAAA;AVq3BF;;AUl3BA;EACE,4BAAA;AVq3BF;;AUl3BA;EACE,2BAAA;AVq3BF;;AUl3BA;EACE,0BAAA;AVq3BF;;AUl3BA;EACE,qBAAA;EACA,2BAAA;AVq3BF;;AUl3BA;EACE,2BAAA;AVq3BF;;AUl3BA;EACE,+BAAA;AVq3BF;;AUl3BA;EAeE,uBAAA;AVu2BF;AUp3BI;EACE,yBAAA;EACA,iBAAA;AVs3BN;AUp3BI;EACE,uBAAA;AVs3BN;AUl3BE;EACE,qBAAA;EACA,6BAAA;AVo3BJ;AUj3BE;EACE,iBAAA;EACA,UAAA;EACA,SAAA;AVm3BJ;AUj3BI;EACE,qBAAA;AVm3BN;AUh3BI;EACE,mBAAA;AVk3BN;AUj3BM;;EAEE,yBAAA;AVm3BR;AU/2BI;EACE,mBAAA;AVi3BN;AUh3BM;;EAEE,yBAAA;AVk3BR;AU92BI;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVg3BN;AU92BM;EACE,cAAA;EACA,eAAA;AVg3BR;AU72BM;EACE,6CAAA;AV+2BR;AU72BM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AV+2BR;AU12BE;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AV42BJ;AU32BI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AV62BN;AUz2BE;EACE,eAAA;EACA,gBAAA;AV22BJ;AUx2BE;EACE,eAAA;AV02BJ;AUv2BE;EACE,kBAAA;EACA,WAAA;AVy2BJ;AUv2BI;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;AVy2BN;AUt2BI;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AVw2BN;AUt2BI;EACE,qCAAA;EACA,mBAAA;AVw2BN;AUr2BI;EACE,0BAAA;AVu2BN;AUn2BE;EACE,uBAAA;AVq2BJ;AUl2BE;EACE,oCAAA;AVo2BJ;AUj2BE;EACE,6BAAA;AVm2BJ;AUh2BE;EACE,0BAAA;AVk2BJ;AU/1BE;EACE,uBAAA;EACA,eAAA;AVi2BJ;AU91BE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,oBAAA;AVg2BJ;AU71BE;EACE,kBAAA;AV+1BJ;AU51BE;EACE,kBAAA;AV81BJ;AU51BE;EACE,8BAAA;AV81BJ;AUv1BE;EACE,mBAAA;EACA,YAAA;AVy1BJ;AUt1BE;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AVw1BJ;AUr1BE;EACE,mBAAA;EACA,cAAA;AVu1BJ;AUp1BE;EACE,8BAAA;AVs1BJ;AUn1BE;EACE,eAAA;EACA,YAAA;AVq1BJ;AUl1BE;EACE,0BAAA;EACA,qCAAA;EACA,wCAAA;AVo1BJ;;AUh1BA;EACE,kBAAA;AVm1BF;AUl1BE;EACE,kBAAA;EACA,MAAA;AVo1BJ;AUl1BE;EACE,2BAAA;EACA,0BAAA;AVo1BJ;AUl1BE;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;AVo1BJ;;AUh1BA;EACE,aAAA;AVm1BF;AUj1BE;EACE,eAAA;AVm1BJ;AUh1BE;EACE,kBAAA;AVk1BJ;AUh1BI;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;AVk1BN;AU90BE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,uBAAA;AVg1BJ;AU70BE;EACE,0BAAA;AV+0BJ;AU50BE;EACE,kBAAA;AV80BJ;;AU10BA;EACE,oCAAA;EACA,uCAAA;EACA,uCAAA;EACA,0CAAA;EACA,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AV60BF;;AU10BA;EACE,uBAAA;EACA,yDAAA;AV60BF;AU30BE;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AV60BJ;;AUz0BA;EACE,oCAAA;EACA,kBAAA;AV40BF;AU10BE;EACE,YAAA;AV40BJ;AUz0BE;EACE,eAAA;EACA,8BAAA;EACA,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AV20BJ;AUz0BI;EACE,yBAAA;AV20BN;AUx0BE;EACE,eAAA;EACA,iBAAA;AV00BJ;AUv0BE;EACE,mBAAA;EACA,2BAAA;EACA,4BAAA;AVy0BJ;AUx0BI;EACE,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,UAAA;AV00BN;;AUr0BA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;AVw0BF;AUt0BE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AVw0BJ;AUr0BE;EACE,uBAAA;AVu0BJ;AUp0BE;EACE,WAAA;AVs0BJ;AUn0BE;EACE,uBAAA;AVq0BJ;AUl0BE;EACE,8BAAA;EACA,+BAAA;AVo0BJ;AUn0BI;;EAEE,cAAA;EACA,WAAA;EACA,mBAAA;AVq0BN;AUl0BM;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;AVo0BR;AUh0BI;EACE,iBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AVk0BN;AU/zBI;;;EAGE,uBAAA;EACA,2BAAA;AVi0BN;AU/zBI;EACE,2CAAA;AVi0BN;AU9zBI;EACE,2BAAA;AVg0BN;AU7zBI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AV+zBN;AU5zBI;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,+BAAA;AV8zBN;AU1zBE;;EAEE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV4zBJ;AUzzBE;EACE,YAAA;AV2zBJ;AU1zBI;EACE,aAAA;AV4zBN;AUxzBE;EACE,YAAA;AV0zBJ;AUvzBE;EACE,YAAA;AVyzBJ;AUtzBE;EACE,eAAA;EACA,cAAA;AVwzBJ;AUrzBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AVuzBJ;;AUnzBA;EACE,0BAAA;EACA,kBAAA;AVszBF;AUpzBE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AVszBJ;AUnzBE;EACE,yBAAA;AVqzBJ;AUnzBE;EACE,yBAAA;AVqzBJ;AUnzBE;EACE,iBAAA;EACA,oBAAA;EACA,iBAAA;AVqzBJ;AUnzBI;EACE,oCAAA;AVqzBN;AUnzBI;EACE,oCAAA;AVqzBN;AUlzBI;EACE,oCAAA;AVozBN;AU/yBE;EACE,uBAAA;EACA,iBAAA;EAGA,kBAAA;AV+yBJ;AU5yBE;EACE,kBAAA;EACA,SAAA;EACA,eAAA;AV8yBJ;AU3yBE;EACE,kBAAA;EACA,SAAA;AV6yBJ;;AUxyBE;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;AV2yBJ;AU1yBI;EACE,6BAAA;EACA,mBAAA;AV4yBN;AU3yBM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AV6yBR;AU1yBI;EACE,gBAAA;AV4yBN;AUzyBE;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AV2yBJ;AUzyBI;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AV2yBN;;AUtyBA;EACE,qCAAA;AVyyBF;;AUtyBA;EACE,4BAAA;EACA,+BAAA;AVyyBF;;AUtyBA;EACE,0BAAA;EACA,2BAAA;AVyyBF;;AUtyBA;EACE,kBAAA;AVyyBF;AUxyBE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AV0yBJ;AUvyBE;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AVyyBJ;AUvyBI;EACE,oCAAA;AVyyBN;AUryBE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AVuyBJ;AUpyBE;EACE,iBAAA;AVsyBJ;;AUlyBA;EACE,eAAA;EACA,yBAAA;AVqyBF;;AUjyBE;EACE,YAAA;AVoyBJ;;AU/xBE;EACE,YAAA;AVkyBJ;AUhyBE;EACE,WAAA;AVkyBJ;AUhyBE;EACE,6BAAA;EAIA,4BAAA;AV+xBJ;AUlyBI;EACE,kCAAA;AVoyBN;AU/xBE;EACE,2BAAA;AViyBJ;AU9xBE;EACE,4BAAA;AVgyBJ;;AU5xBA;EACE,mBAAA;EAyBA,oCAAA;EACA,iBAAA;EACA,6BAAA;AVuwBF;AUjyBE;EACE,uBAAA;AVmyBJ;AUhyBM;EACE,gCAAA;AVkyBR;AU/xBI;EACE,8BAAA;AViyBN;AU9xBI;EACE,0CAAA;AVgyBN;AU9xBI;EACE,+BAAA;AVgyBN;AU7xBI;EACE,6BAAA;AV+xBN;AUvxBI;EACE,8BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AVyxBN;AUtxBI;EACE,eAAA;AVwxBN;AUrxBE;EACE,2BAAA;AVuxBJ;AUpxBE;EACE,4BAAA;AVsxBJ;;AUjxBE;EACE,yCAAA;EACA,0CAAA;AVoxBJ;AUnxBI;EACE,8BAAA;AVqxBN;AUjxBI;EACE,0BAAA;EACA,yCAAA;EACA,0CAAA;AVmxBN;AUhxBE;EACE,iBAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;AVkxBJ;AUjxBI;EACE,yBAAA;AVmxBN;AUhxBI;EACE,cAAA;EACA,eAAA;AVkxBN;;AU5wBE;EACE,2BAAA;EACA,4BAAA;AV+wBJ;AU7wBI;EACE,YAAA;AV+wBN;AU5wBI;EACE,YAAA;EACA,kBAAA;AV8wBN;AU7wBM;EACE,wBAAA;AV+wBR;AU3wBE;EACE,cAAA;AV6wBJ;AUzwBI;EACE,2BAAA;AV2wBN;AUzwBI;EACE,4BAAA;AV2wBN;;AUrwBE;EACE,iBAAA;AVwwBJ;AUtwBI;EACE,kBAAA;AVwwBN;AUvwBM;EACE,kBAAA;EACA,OAAA;AVywBR;AUrwBI;EACE,UAAA;EACA,SAAA;AVuwBN;AUtwBM;EACE,eAAA;EACA,kBAAA;AVwwBR;AUvwBQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AVywBV;AUtwBQ;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AVwwBV;;AUhwBE;EACE,sCAAA;AVmwBJ;AUjwBE;EACE,uCAAA;AVmwBJ;AUjwBE;EACE,4BAAA;EACA,2BAAA;AVmwBJ;AU9vBQ;EACE,wBAAA;AVgwBV;;AUvvBA;EACE,yBAAA;EACA,kBAAA;AV0vBF;;AUvvBA;EACE,oCAAA;EACA,6BAAA;AV0vBF;;AUvvBA;EACE,iBAAA;EACA,YAAA;AV0vBF;;AUvvBA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;AV0vBF;AUzvBE;EACE,gBAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;AV2vBJ;AUzvBI;EACE,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;AV2vBN;AUxvBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,6BAAA;EACA,2BAAA;AV0vBN;AUvvBI;EACE,cAAA;AVyvBN;AUtvBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,6BAAA;AVwvBN;AUrvBI;EACE,+BAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AVuvBN;AUnvBM;EACE,2BAAA;AVqvBR;AUnvBM;EACE,4BAAA;AVqvBR;AU9uBM;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AVgvBR;AU7uBM;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,OAAA;EACA,eAAA;AV+uBR;AU5uBM;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AV8uBR;AUzuBE;EACE,mBAAA;AV2uBJ;AUxuBE;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;AV0uBJ;AUvuBE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;AVyuBJ;;AWtxDA;EACE,YAAA;EACA,uBAAA;EACA,kCAAA;AXyxDF;;AWtxDA;EACE,YAAA;EACA,uBAAA;AXyxDF;;AWtxDA;EACE,WAAA;AXyxDF;;AWtxDA;EACE,6BAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;AXyxDF;;AWtxDA;EACE,oCAAA;EACA,YAAA;AXyxDF;;AWtxDA;EACE,mBAAA;EACA,6CAAA;EACA,6BAAA;AXyxDF;;AWtxDA;EACE,kBAAA;AXyxDF;;AWtxDA;EACE,eAAA;EACA,gBAAA;AXyxDF;;AWtxDA;EACE,6BAAA;EACA,2CAAA;EACA,yBAAA;EACA,eAAA;AXyxDF;;AWtxDA;;EAEE,YAAA;EACA,0BAAA;EACA,sCAAA;AXyxDF;;AWtxDA;;EAEE,iCAAA;AXyxDF;;AW3wDA;EACE,sCAAA;AX8wDF;;AW3wDA;EAGE,YAAA;EACA,WAAA;AX4wDF;;AW1wDA;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AX6wDF;;AW3wDA;EACE,oCAAA;EACA,uBAAA;EACA,uBAAA;AX8wDF;;AW3wDA;EACE,yBAAA;AX8wDF;;AW3wDA;EACE,uBAAA;EACA,0BAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;AX8wDF;;AWrwDA;EACE,2BAAA;EACA,6BAAA;EACA,gCAAA;AXwwDF;;AWrwDA;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AXwwDF;;AWnwDA;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AXswDF;;AWnwDA;EACE,4BAAA;EACA,wBAAA;EACA,2BAAA;AXswDF;;AWnwDA;EACE,8BAAA;AXswDF;;AWnwDA;EACE,oBAAA;EACA,6BAAA;AXswDF;;AWnwDA;EACE,qBAAA;AXswDF;;AWnwDA;EAEE,yBAAA;AXqwDF;;AWlwDA;EACE,yBAAA;AXqwDF;;AWlwDA;EACE,2BAAA;AXqwDF;;AYz6DA;EAGE,6BAAA;AZ06DF;;AYr6DA;EACE,gBAAA;EACA,OAAA;AZw6DF;;AYr6DA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AZw6DF;;AYr6DA;EACE,oBAAA;EACA,uBAAA;AZw6DF;;AYp6DA;;EAEE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AZu6DF;;AYp6DA;;;;;;;;;EASE,wBAAA;AZu6DF;;AYp6DA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AZu6DF;;AYp6DA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sCAAA;AZu6DF;;AYp6DA;;EAEE,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;AZu6DF;;AYp6DA;;;;EAIE,4BAAA;EACA,sBAAA;EACA,oCAAA;AZu6DF;;AYp6DA;EACE,aAAA;EACA,eAAA;AZu6DF;;AYp6DA;EACE,yBAAA;AZu6DF;;AYp6DA;;EAEE,gCAAA;EACA,6BAAA;EACA,WAAA;AZu6DF;;AYp6DA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AZu6DF;;AYp6DA,qBAAA;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AZs6DF;;AYn6DA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AZs6DF;;AYn6DA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;AZs6DF;;AYn6DA;EACE,gBAAA;EACA,WAAA;EACA,UAAA;AZs6DF;;AYn6DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZs6DF;;AYn6DA;EACE,oCAAA;AZs6DF;;AYn6DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZs6DF;;AYn6DA;EACE,WAAA;AZs6DF;;AYn6DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZs6DF;;AYn6DA,0BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZs6DF;;AYn6DA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AZu6DF;;AYn6DA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AZu6DF;;AYn6DA;EACE;;iBAAA;AZw6DF;;AYn6DA;EACE;;iBAAA;AZw6DF;;AYn6DA;;EAEE,WAAA;EACA,gBAAA;EAEA,oCAAA;AZq6DF;;AYl6DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZq6DF;;AYl6DA,yCAAA;AAEA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AZo6DF;;AYj6DA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZo6DF;;AYj6DA;EACE,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZo6DF;;AYj6DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZo6DF;;AYj6DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZo6DF;;AYj6DA;EACE,oCAAA;AZo6DF;;AYj6DA;EAEE,SAAA;EACA,UAAA;EACA,eAAA;AZm6DF;;AYh6DA;EACE,yBAAA;AZm6DF;;AYh6DA;EACE,WAAA;AZm6DF;;AYh6DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZm6DF;;AYh6DA,6CAAA;AACA;EAEE,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;EACE,yBAAA;AZk6DF;;AY/5DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,8BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZk6DF;;AY/5DA;EACE,oCAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,WAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,mCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,8BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZk6DF;;AY/5DA;EACE,oCAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,WAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,mCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,mCAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE,YAAA;EACA,mCAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,2BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZk6DF;;AY/5DA;EACE,oCAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,WAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,gCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AZm6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;EACE;;iBAAA;AZo6DF;;AY/5DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZk6DF;;AY/5DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZk6DF;;AY/5DA,gCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZk6DF;;AY/5DA;EACE,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZk6DF;;AY/5DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZk6DF;;AY/5DA;EAGE,oCAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,WAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZg6DF;;AY75DA,qCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,6BAAA;EACA;iBAAA;AZi6DF;;AY75DA;EACE,YAAA;EACA,6BAAA;EACA;iBAAA;AZi6DF;;AY75DA;EACE;;iBAAA;AZk6DF;;AY75DA;EACE;;iBAAA;AZk6DF;;AY75DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZg6DF;;AY75DA,8BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AZg6DF;;AY75DA;EACE,oCAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,WAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZg6DF;;AY75DA,mCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,mCAAA;EACA;iBAAA;AZi6DF;;AY75DA;EACE,YAAA;EACA,mCAAA;EACA;iBAAA;AZi6DF;;AY75DA;EACE;;iBAAA;AZk6DF;;AY75DA;EACE;;iBAAA;AZk6DF;;AY75DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZg6DF;;AY75DA,4BAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,sBAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZg6DF;;AY75DA,gCAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,mCAAA;EACA;iBAAA;AZi6DF;;AY75DA;EACE,YAAA;EACA,mCAAA;EACA;iBAAA;AZi6DF;;AY75DA;EACE;;iBAAA;AZk6DF;;AY75DA;EACE;;iBAAA;AZk6DF;;AY75DA;;EAEE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oCAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;EACA,sBAAA;AZg6DF;;AY75DA,mBAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;AZg6DF;;AY75DA;;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;AZg6DF;;AY75DA;;EAEE,YAAA;EACA,eAAA;AZg6DF;;AY75DA;;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;AZg6DF;;AY75DA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,eAAA;EACA,gCAAA;AZg6DF;;AY75DA;;EAEE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AZg6DF;;AY75DA;;EAEE,2CAAA;AZg6DF;;AY75DA;EACE,iBAAA;EACA,mBAAA;EACA,6BAAA;AZg6DF;;AY75DA;EACE,kBAAA;EACA,oBAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AZg6DF;;AY75DA;EACE,gBAAA;AZg6DF;;AY75DA;EACE,sBAAA;EACA,mBAAA;AZg6DF;;AY75DA;;EAEE,6BAAA;EACA,YAAA;EACA,WAAA;AZg6DF;;AY75DA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AZg6DF;;AY75DA;EACE,sBAAA;AZg6DF;;AY75DA;EACE,sBAAA;EACA,8CAAA;EACA,2BAAA;EACA,oBAAA;AZg6DF;;AY75DA;EACE,YAAA;EACA,8CAAA;EACA,2BAAA;EACA,qBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,2BAAA;EACA,oBAAA;AZg6DF;;AY75DA;EACE,YAAA;EACA,2BAAA;EACA,qBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,2BAAA;EACA,oBAAA;AZg6DF;;AY75DA;EACE,YAAA;EACA,2BAAA;EACA,qBAAA;AZg6DF;;AY75DA;EACE,oBAAA;EACA,+CAAA;AZg6DF;;AY75DA;EACE,gBAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,wCAAA;EACA,2BAAA;EACA,kBAAA;AZg6DF;;AY75DA;EACE,YAAA;EACA,wCAAA;EACA,2BAAA;EACA,qBAAA;AZg6DF;;AY75DA;EACE,2BAAA;EACA,kBAAA;AZg6DF;;AY75DA;EACE,wBAAA;AZg6DF;;AY75DA;EACE,kBAAA;EACA,YAAA;AZg6DF;;AY75DA;EACE,eAAA;EACA,yBAAA;AZg6DF;;AY75DA,qBAAA;AACA;EACE,yBAAA;AZg6DF;;AY75DA;EACE,wBAAA;AZg6DF;;AY75DA;EACE,6CAAA;EACA,uBAAA;EACA,sBAAA;AZg6DF;;AY75DA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AZg6DF;;AY75DA;;EAEE,sBAAA;EACA,mBAAA;EACA,uBAAA;AZg6DF;;AY75DA;EACE,qCAAA;EACA,wCAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,2CAAA;AZg6DF;;AY75DA;EACE,sCAAA;AZg6DF;;AY75DA;EACE,YAAA;AZg6DF;;AY75DA;EACE,qCAAA;EACA,qBAAA;EACA,oCAAA;AZg6DF;;AY75DA;EACE,kCAAA;AZg6DF;;AY75DA;EAGE,YAAA;AZ85DF;;AY15DA;EAEE,YAAA;AZ45DF;;AYv5DA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AZ05DF;;AYv5DA;EACE,eAAA;EACA,kCAAA;AZ05DF;;AYv5DA;EACE,oCAAA;AZ05DF;;AYv5DA;EACE,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AZ05DF;;AYv5DA;EACE,yBAAA;EACA,uBAAA;AZ05DF;;AYv5DA;EACE,WAAA;EACA,gDAAA;AZ05DF;;AYv5DA,oBAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;AZ05DF;;AYv5DA;EACE,eAAA;AZ05DF;;AYv5DA;;;EAGE,eAAA;AZ05DF;;AYv5DA;EACE,6BAAA;EACA,YAAA;AZ05DF;;AYv5DA;EACE,gBAAA;AZ05DF;;AYv5DA;EACE,iBAAA;AZ05DF;;AYv5DA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AZ05DF;;AYv5DA;EACE,WAAA;EACA,WAAA;EACA,iBAAA;AZ05DF;;AYv5DA;EACE,gBAAA;AZ05DF;;AYv5DA;EACE,2BAAA;EACA,WAAA;EACA,uBAAA;AZ05DF;;AYv5DA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AZ05DF;;AYv5DA;EACE,UAAA;EACA,eAAA;EACA,yBAAA;AZ05DF;;AYv5DA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AZ05DF;;AYv5DA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AZ05DF;;AYv5DA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AZ05DF;;AYv5DA;EACE,0BAAA;AZ05DF;;AYv5DA,wBAAA;AAEA;EACE,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,uBAAA;AZy5DF;;AYt5DA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AZy5DF;;AYt5DA;EACE,YAAA;AZy5DF;;AYt5DA;EACE,gBAAA;AZy5DF;;AYt5DA;EACE,YAAA;AZy5DF;;AYt5DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AZy5DF;;AYt5DA;EACE,sBAAA;EACA,oCAAA;AZy5DF;;AYt5DA;;;EAGE,0BAAA;AZy5DF;;AYt5DA,sBAAA;AACA;EACE,YAAA;AZy5DF;;AYt5DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AZy5DF;;AYt5DA;;;EAGE,0BAAA;AZy5DF;;AYt5DA;EACE,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AZy5DF;;AYt5DA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AZy5DF;;AYt5DA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AZy5DF;;AYt5DA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AZy5DF;;AYt5DA;EACE,kCAAA;AZy5DF;;AYt5DA;EAEE,sBAAA;AZw5DF;;AYr5DA;EACE,gCAAA;EACA,+CAAA;EACA,kBAAA;AZw5DF;;AYh5DA;EACE,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AZm5DF;;AYj5DA;EACE,aAAA;AZo5DF;;AYl5DA;EACE,eAAA;EACA,cAAA;AZq5DF;;AYl5DA;EACE,YAAA;EACA,aAAA;AZq5DF;;AYl5DA;EACE,oCAAA;EACA,uBAAA;AZq5DF;;AYl5DA;EACE,gBAAA;EACA,kBAAA;AZq5DF;;AYl5DA;EACE,YAAA;EACA,YAAA;AZq5DF;;AYl5DA;EACE,oCAAA;AZq5DF;;AYl5DA;EACE,yBAAA;EACA,oCAAA;AZq5DF;;AYl5DA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AZq5DF;;AYl5DA;EACE,yBAAA;AZq5DF;;AYl5DA;EACE,YAAA;EACA,YAAA;AZq5DF;;AYl5DA;EACE,yBAAA;AZq5DF;;AYl5DA;EACE,oCAAA;AZq5DF;;AYl5DA;EACE,yBAAA;AZq5DF;;AYl5DA;EACE,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AZq5DF;;AYl5DA;EACE,yBAAA;EACA,uBAAA;AZq5DF;;AYl5DA;EACE,uBAAA;EACA,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AZq5DF;;AYl5DA;EACE,yBAAA;EACA,uBAAA;AZq5DF;;AYl5DA;EACE,yBAAA;AZq5DF;;AYl5DA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;AZq5DF;;AYl5DA;EACE,aAAA;AZq5DF;;AYl5DA;EACE,6BAAA;EACA,8BAAA;AZq5DF;;AYl5DA;EACE;IACE,wBAAA;EZq5DF;EYl5DA;IACE,yBAAA;EZo5DF;EYj5DA;IACE,eAAA;IACA,iBAAA;EZm5DF;EYh5DA;IACE,0BAAA;IACA,4BAAA;EZk5DF;AACF;Aa/9GA;EACE,2BAAA;EACA,yBAAA;Abi+GF;;Aa99GA;EACE,UAAA;EACA,yBAAA;Abi+GF;;Aa99GA;EACE,YAAA;EACA,yBAAA;Abi+GF;;Aa99GA;EACE,cAAA;Abi+GF;;Aa99GA;EACE,cAAA;Abi+GF;;Aa99GA;EACE,yBAAA;EACA,cAAA;Abi+GF;;Aa99GA;EACE,kBAAA;Abi+GF;;Aa99GA;EACE,YAAA;Abi+GF;;Aa99GA;EACE,oCAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;Abi+GF;;Aa99GA;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;Abi+GF;;Aa99GA;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;Abi+GF;;Aa99GA;EACE;IACE,eAAA;Ebi+GF;AACF;Ac7hHA;EAIE,uBAAA;EACA,cAAA;Ad4hHF;Ac1hHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;Ad4hHJ;Ac1hHI;EACE,SAAA;Ad4hHN;AczhHI;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;Ad2hHN;AcvhHE;EACE,yBAAA;EACA,YAAA;AdyhHJ;AcvhHI;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;AdyhHN;ActhHI;EACE,uBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AdwhHN;ActhHM;EACE,yBAAA;EACA,YAAA;AdwhHR;AchhHQ;EACE,sBAAA;EACA,0BAAA;AdkhHV;Ac/gHU;EACE,eAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AdihHZ;Ac3gHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;Ad6gHJ;Ac1gHE;EACE,eAAA;Ad4gHJ;Ac1gHE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;Ad4gHJ;;AevnHA;EACI,2BAAA;EACA,yBAAA;Af0nHJ;;AernHA;EACI,UAAA;EACA,yBAAA;AfwnHJ;;AepnHA;EACI,YAAA;EACA,yBAAA;AfunHJ;;AennHA;EACI,cAAA;AfsnHJ;;AennHA;EACI,cAAA;AfsnHJ;;AehnHA;EACI,UAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AfmnHJ;;AehnHA;EAEI,cAAA;EACA,eAAA;EACA,kBAAA;AfknHJ;;AehnHA;EACE,eAAA;EAEA,qBAAA;EACA,wBAAA;EACA,cAAA;AfknHF;;Ae7mHA;EACI,yBAAA;AfgnHJ;;Ae7mHA;EACI,WAAA;EACA,cAAA;EACA,cAAA;AfgnHJ;;Ae5mHA;EACI,kBAAA;Af+mHJ;;Ae5mHA;EACI,YAAA;Af+mHJ;;AetmHA;EACI,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AfymHJ;;AetmHA;EACI,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AfymHJ;;AetmHA;EACI,gCAAA;EACA,sBAAA;AfymHJ;;AetmHA;EACI,oCAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AfymHJ;;AetmHA;EAEE,kBAAA;AfwmHF;;AenmHA,+EAAA;AACA,+EAAA;AACA,+EAAA;AAEA;EACI,kBAAA;AfqmHJ;;AelmHE;EACE,kBAAA;AfqmHJ;;AelmHE;EACE,iBAAA;AfqmHJ;;AelmHE;EACE,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;EACA,+BAAA;AfqmHJ;;AelmHE;EACE,cAAA;EACA,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AfqmHJ;;AelmHE;EACE,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AfqmHJ;;AelmHE;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AfqmHJ;;AelmHE;EACE,oBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;AfqmHJ;;AelmHE;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AfqmHJ;;AelmHE;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AfqmHJ;;AelmHE;EACE,cAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;AfqmHJ;;AelmHE;EACE,eAAA;EACA,2BAAA;EACA,yBAAA;AfqmHJ;;AelmHE;EACE,oBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AfomHJ;;AejmHE;EACE,aAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AfomHJ;;AejmHE;EACE,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AfomHJ;;AejmHE;EACI,uBAAA;EACA,uBAAA;EACM,qBAAA;EACA,wBAAA;EACA,qBAAA;AfomHZ;;AejmHE;EACI,oCAAA;AfomHN;;AgBj1HA;EAEI,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,kCAAA;EACA,oBAAA;EACA,uBAAA;AhBm1HJ;;AgB30HA;EAEI,cAAA;EACA,gBAAA;AhB60HJ;;AgBz0HA;EAEI,cAAA;EACA,gBAAA;EACA,yBAAA;AhB20HJ;;AgBx0HA;EAEI,yBAAA;EACA,cAAA;EACA,qBAAA;AhB00HJ;;AgBv0HA;EAEI,sDAAA;EACA,mBAAA;EACA,0BAAA;AhBy0HJ;;AgBt0HA;EAEI,qCAAA;AhBw0HJ;;AgBr0HA;EAEI,qCAAA;EACA,yBAAA;AhBu0HJ;;AgBp0HA;EAEI,qCAAA;EACA,yBAAA;AhBs0HJ;;AgBj0HA;EAGI;IAEA,UAAA;EhBi0HF;AACF;AiBt4HA;EACI,oBAAA;EACD,cAAA;AjBw4HH;;AiBt4HC;EACG,oBAAA;AjBy4HJ;;AiBv4HA;EACI,qBAAA;EACJ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,kBAAA;EAEA,cAAA;AjBw4HA;;AiBt4HA;EACI,WAAA;AjBy4HJ;;AiBv4HA;EACI,WAAA;AjB04HJ;;AiBx4HA;EACK,SAAA;EACA,eAAA;AjB24HL;;AiBz4HA;EACI,YAAA;AjB44HJ;;AiB14HA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AjB64HA;;AiB34HA;EACI,eAAA;EACJ,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,8BAAA;AjB84HA;;AQn7HA;EACE,cAAA;EACA,oBAAA;ARs7HF;;AQn7HA;EACE;IACE,4CAAA;ERs7HF;AACF;AQp7HA;EACE,yBAAA;EACC,aAAA;EACC,cAAA;ARs7HJ;;AQl7HA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;ARq7HF;;AQl7HA;EACE,cAAA;ARq7HF;;AQl7HA;EACE;IACE,uBAAA;ERq7HF;EQn7HA;IACE,yBAAA;ERq7HF;AACF;AkBt+HA;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AlBw+HJ;;AkBr+HA;EACI,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AlBw+HJ;;AkBr+HA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AlBw+HJ;;AkBr+HA;EACI,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,uBAAA;EACA,6BAAA;EACA,SAAA;EACA,YAAA;EACA,qDAAA;AlBw+HJ;;AkBr+HA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,mCAAA;EACA,oCAAA;AlBw+HJ;;AkBr+HA;EACI,kBAAA;AlBw+HJ;;AkBr+HA;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AlBw+HJ;;AkBr+HA;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;AlBw+HJ;;AkBn+HA;EACG;IACC,kBAAA;ElBs+HF;AACF;AmBnjIA;EACE,wBAAA;EACA,gBAAA;AnBqjIF;;AmBnjIA;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,+CAAA;EACA,wBAAA;EAEA,2BAAA;AnBqjIF;;AmBnjIA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,+CAAA;EAEA,2BAAA;AnBqjIF;;AmBnjIA;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,+CAAA;EACA,qCAAA;EACA,2BAAA;AnBsjIF;;AmBpjIA;EACE,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,yBAAA;EACA,oCAAA;EACA,uBAAA;AnBujIF;;AmBrjIA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,kCAAA;EACA,yBAAA;EACA,2CAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AnBwjIF;;AmBtjIA;EACE,sBAAA;EACA,8BAAA;EACA,8BAAA;EACA,uBAAA;EACA,+CAAA;EACA,uBAAA;EAEA,2BAAA;AnBwjIF;;AmBtjIA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AnByjIF;;AmBvjIA;EACE,qBAAA;EACA,uBAAA;EAEA,8BAAA;EAEA,gCAAA;EACA,uBAAA;EACA,+CAAA;AnBwjIF;;AmBrjIA;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,uBAAA;EACA,oCAAA;EACA,wBAAA;EAEA,2BAAA;AnBujIF;;AmBpjIA;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,+CAAA;EACA,uBAAA;EACA,2BAAA;AnBujIF;;AmBrjIA;EACE,UAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,+CAAA;EACA,2BAAA;AnBwjIF;;AmBnjIA;EACE,WAAA;EACF,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBsjIA;;AmBnjIA;EACE,cAAA;EACF,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AnBsjIA;;AmBpjIA;EACE,WAAA;EACF,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBujIA;;AmBrjIA;EACE,SAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EAEA,kBAAA;EAEA,eAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gEAAA;AnBsjIF;;AmBpjIA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AnBujIF;;AmBrjIA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AnBwjIF;;AmBtjIA;EACE,iCAAA;EACF,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AnByjIA;;AmBtjIA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AnByjIF;;AmBvjIA;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,oCAAA;EACA,wBAAA;AnB0jIF;;AmBxjIA;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,oCAAA;EACA,uBAAA;AnB2jIF;;AmBzjIA;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,oCAAA;EACA,wBAAA;AnB4jIF;;AmBzjIA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AnB4jIF;;AmBljIA;EACE,aAAA;AnBqjIF;;AmBnjIA;EACE,aAAA;EAEA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AnBqjIF;;AmBnjIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AnBsjIF;;AmBpjIA;EACE,aAAA;EACA,4BAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;AnBujIF;;AmBrjIA;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;AnBwjIF;;AmBtjIA;EACE,iBAAA;EACA,iBAAA;AnByjIF;;AmBvjIA;EACE,kBAAA;AnB0jIF;;AmBxjIA;EACE,WAAA;EAEF,eAAA;EACA,kBAAA;EACA,gBAAA;AnB0jIA;;AmBvjIA;EACE,WAAA;EAEF,eAAA;EACA,kBAAA;EACA,gBAAA;AnByjIA;;AmBtjIA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;AnByjIF;;AmBvjIA;EACE,yBAAA;AnB0jIF;;AmBxjIA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AnB2jIF;;AmBzjIA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AnB4jIF;;AmB1jIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AnB6jIF;;AmB3jIA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,cAAA;EACA,iBAAA;AnB8jIF;;AmB5jIA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AnB+jIF;AmB9jIE;EACE,YAAA;AnBgkIJ;;AmB7jIA;EACE,aAAA;EACA,mBAAA;AnBgkIF;AmB9jIE;EACE,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,uDAAA;AnBgkIJ;;AmB7jIA;EACE,gBAAA;AnBgkIF;;AmB7jIA;EACE,sBAAA,EAAA,oCAAA;AnBgkIF;;AmB9jIA;EACE,sBAAA,EAAA,oCAAA;AnBikIF;;AmB9jIA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AnBikIF;;AmB/jIA;EACE,eAAA;EACA,iBAAA;AnBkkIF;;AmBhkIA;EACE,aAAA;EAIA,WAAA;AnBgkIF;;AmB9jIA;EACE,aAAA;AnBikIF;;AmB3jIA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AnB8jIF;;AmB5jIA;EACE,aAAA;AnB+jIF;;AmB7jIA;EACE,wBAAA;EACA,yCAAA;EACA,4BAAA;EACA,yBAAA;AnBgkIF;AmB/jIE;EACE,uBAAA;EACA,uBAAA;EACA,2DAAA;EACA,oBAAA;EACA,6BAAA;AnBikIJ;AmB/jIE;EACE,2DAAA;EACA,uBAAA;AnBikIJ;;AmB9jIA;EACE,eAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;AnBikIF;;AmB/jIA;EACE,aAAA;EACA,wBAAA;AnBkkIF;AmBjkIE;EACE,uBAAA;EACA,wBAAA;AnBmkIJ;AmBhkIE;EACE,oCAAA;EACA,eAAA;EAEA,iBAAA;AnBikIJ;;AmBjjIA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AnBojIF;AmBnjIE;EACE,8BAAA;EACA,uBAAA;AnBqjIJ;;AmBljIA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AnBqjIF;AmBpjIE;EACE,8BAAA;EACA,uBAAA;AnBsjIJ;;AmBnjIA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AnBsjIF;AmBrjIE;EACE,8BAAA;EACA,uBAAA;AnBujIJ;;AmBpjIA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;AnBujIF;;AmBpjIA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnBujIF;;AmBrjIA;EACE,iBAAA;AnBwjIF;;AmBjjIA;EACE,aAAA;EACA,yBAAA;EACA,uBAAA;AnBojIF;;AmBhjIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AnBmjIF;;AmBhjIE;EACE,YAAA;EACA,iBAAA;AnBmjIJ;;AmBhjIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AnBmjIF;;AmBjjIA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AnBojIF;;AmBljIA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AnBqjIF;;AmBnjIA;EACE,yBAAA;EACA,eAAA;AnBsjIF;;AmBpjIA;EACE,kBAAA;AnBujIF;;AmB/iIA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;EACA,YAAA;AnBkjIF;;AmB3iIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AnB8iIF;;AmB3iIA;EACE,eAAA;AnB8iIF;;AmB3iIA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;AnB8iIF;;AmB3iIA;EACE,2BAAA;AnB8iIF;;AmB3iIA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AnB8iIF;;AmB5iIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AnB+iIF;;AmB5iIA;EACE,eAAA;AnB+iIF;;AmB5iIA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;AnB+iIF;;AmB5iIA;EACE,2BAAA;AnB+iIF;;AmB5iIA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AnB+iIF;;AmB7iIA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AnBgjIF;;AmB7iIA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0BAAA;AnBgjIF;;AmB9iIA;EACE,aAAA;EACA,+BAAA;EACA,aAAA;AnBijIF;;AmB/iIA;EACE,eAAA;AnBkjIF;;AmBhjIA;EACE,YAAA;AnBmjIF;;AoBjuJE;EDkrBA;;;;IAIE,UAAA;IACA,aAAA;EnBmjIF;AACF;AoBruJE;EDsrBA;;;;;IAKE,UAAA;IACA,aAAA;EnBkjIF;EmBhjIA;IACE,cAAA;EnBkjIF;AACF;AmB7iIA;EACE,4CAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;EACA,QAAA;AnB+iIF;;AmB3iIA;EACE,+BAAA,EAAA,+BAAA;EACA,sBAAA;EACA,wBAAA;AnB8iIF;;AmB3iIA;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AnB8iIF;;AmB3iIA;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AnB8iIF;;AmB3iIA;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;AnB8iIF;;AmB1iIA;EACE,yBAAA;AnB6iIF;;AqB/yJA;EACA,iCAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;ArBkzJA;;AqBhzJA;EACI,+BAAA;EACJ,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ArBmzJA;;AqBjzJA;EAEA,YAAA;EACA,aAAA;EACA,6BAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,qBAAA;EAEA,cAAA;ArBgzJA;;AqB9yJE;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;ArBizJJ;;AqB/yJE;EACE,eAAA;ArBkzJJ;;AqBhzJE;EACE,aAAA;EACJ,cAAA;EACA,kCAAA;EACA,UAAA;EAEA,mBAAA;EACA,kBAAA;ArBkzJA;;AqBhzJE;EACE,YAAA;EACJ,aAAA;EACA,YAAA;EACA,UAAA;ArBmzJA;;AqBhzJE;EAEF,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACC,2CAAA;ArBkzJD;;AqBhzJE;EAGF,YAAA;EACA,aAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ArBizJA;;AqB9yJE;EACE,WAAA;EAEJ,WAAA;EACA,cAAA;EACA,mBAAA;ArBgzJA;;AqB9yJE;EACE,UAAA;EACJ,WAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAEA,UAAA;EACA,QAAA;EACA,YAAA;ArBgzJA;;AqB9yJA;EACA,oBAAA;EAEA,kBAAA;ArBgzJA;;AqB9yJA;EACI,cAAA;ArBizJJ;;AqB/yJA;EACI,qBAAA;EACJ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ArBkzJA;;AqBhzJA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ArBkzJA;;AqBhzJA;EACI,YAAA;EACJ,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EAEA,cAAA;ArBkzJA;;AqB/yJA;EACE,+BAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ArBkzJF;;AqB/yJA;EAEE,YAAA;EACA,aAAA;EACA,6BAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,qBAAA;EAEA,cAAA;ArB8yJF;;AqB3yJA;EACE,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;ArB8yJF;;AqB3yJA;EACE,eAAA;ArB8yJF;;AqB3yJA;EACE,aAAA;EACA,cAAA;EACA,kCAAA;EACA,UAAA;EAEA,mBAAA;EACA,kBAAA;ArB6yJF;;AqB1yJA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;ArB6yJF;;AqBzyJA;EAEE,uBAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,2CAAA;ArB2yJF;;AqBxyJA;EAGE,YAAA;EACA,aAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ArByyJF;;AqBtyJA;EACE,WAAA;EAEA,WAAA;EACA,cAAA;EACA,mBAAA;ArBwyJF;;AqBryJA;EACE,UAAA;EACA,WAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EAEA,UAAA;EACA,QAAA;EACA,YAAA;ArBuyJF;;AqBpyJA;EACE,oBAAA;EAEA,kBAAA;ArBsyJF;;AqBnyJA;EACE,cAAA;ArBsyJF;;AqBnyJA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ArBsyJF;;AqBnyJA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;ArBqyJF;;AqBlyJA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EAEA,cAAA;ArBoyJF;;AqBjyJA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ArBoyJF;;AqBjyJA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,qBAAA;EACA,yBAAA;EAEA,cAAA;ArBkyJF;;AqB/xJA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;ArBkyJF;;AqB/xJA;EAIE,SAAA;EACA,QAAA;EACA,kBAAA;ArB+xJF;;AqB5xJA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;ArB+xJF;;AqB5xJA;EACE,UAAA;EACA,4BAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;ArB8xJF;;AsB5pKA;EACI,sBAAA;EACA,YAAA;EACJ,aAAA;EACA,SAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AtB+pKA;;AsB7pKA;EACI,YAAA;EACA,kBAAA;AtBgqKJ;;AsB9pKA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACC,iCAAA;EACD,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,cAAA;AtBiqKA;;AsB/pKA;EACI,cAAA;EACJ,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AtBkqKA;;AsBhqKA;EACI,cAAA;EACJ,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AtBmqKA;;AsBjqKA;EAGI,SAAA;EACA,QAAA;EAEA,kBAAA;AtBiqKJ;;AsBtpKA;EACI,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AtBypKJ;;AsBtpKA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;AtBypKJ;;AsBvpKA;EACI,iCAAA;EACA,kBAAA;EACJ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AtB0pKA;;AsBxpKA;EACI,kBAAA;EACJ,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,iBAAA;EACA,cAAA;AtB2pKA;;AsBzpKA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qCAAA;AtB4pKA;;AsB1pKA;EACI,qBAAA;EACJ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AtB6pKA;;AsB3pKA;EAEA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;AtB6pKA;;AsB3pKA;EACI,WAAA;EACJ,aAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AtB8pKA;;AsB1pKA;EAEA,kBAAA;EAEA,kBAAA;AtB2pKA;;AsBzpKA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AtB4pKA;;AsB1pKA;EACI,iCAAA;EACJ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,cAAA;AtB6pKA;;AuB/yKA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AvBkzKF;;AuB/yKA;EACE,WAAA;EACA,cAAA;AvBkzKF;;AuB/yKA;EACE,yBAAA;EACA,cAAA;AvBkzKF;;AuBhzKA;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EAEA,mBAAA;AvBkzKF;;AuBhzKA;EACE,WAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AvBkzKF;;AuBhzKA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,2BAAA;AvBkzKF;;AuB/yKA;EACE,cAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;AvBizKF;;AuB/yKA;EACE,oCAAA;EAEA,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,2BAAA;AvBgzKF;;AuB7yKA;EACE,YAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;AvB+yKF;;AuB5yKA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AvB+yKF;;AuB5yKA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,eAAA;AvB8yKF;;AuB3yKA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AvB8yKF;;AuB3yKA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AvB8yKF;;AuB3yKA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AvB8yKJ;;AuB3yKA;EACE,cAAA;AvB8yKF;;AuB3yKA;EACE,YAAA;EACA,kBAAA;AvB8yKF;;AuB3yKA;EACE,YAAA;EACA,kBAAA;AvB8yKF;;AuB3yKA;EACE,aAAA;AvB8yKF;;AuB3yKA;EACE,oCAAA;EACA,uBAAA;EACA,oCAAA;AvB8yKF;;AuB3yKA;EACE,SAAA;EACA,iBAAA;AvB8yKF;;AuB3yKA;EACE,oDAAA;EACA,mBAAA;EACA,yBAAA;AvB8yKF;;AuB3yKA;EACE,UAAA;EACA,yBAAA;AvB8yKF;;AuB3yKA;EACE,mBAAA;EACA,oDAAA;EACA,yBAAA;AvB8yKF;;AuB3yKA;EACE,oCAAA;EACA,0BAAA;AvB8yKF;;AuBzyKA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AvB4yKF;;AuBzyKA;EACE,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AvB4yKF;;AuBzyKA;EACE,SAAA;EACA,kBAAA;EACA,UAAA;AvB4yKF;;AuBzyKA;EACE,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AvB4yKF;;AwBr/KA;EACE,iBAAA;EACA,kBAAA;EAEA,kBAAA;AxBu/KF;;AwBp/KA;EACE,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AxBu/KF;;AwBr/KA;EACE,2BAAA;EACA,mBAAA;EACA,uBAAA;AxBw/KF;;AwBt/KA;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,+CAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AxBy/KF;;AwBt/KA;EACE,oCAAA;EACA,6BAAA;AxBy/KF;;AwBt/KA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBy/KF;;AwBt/KA;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EAEA,mBAAA;AxBw/KF;;AwBr/KA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBw/KF;;AwB/+KA;EACE,aAAA;AxBk/KF;;AwB/+KA;EACE,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;AxBk/KF;;AwB/+KA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,0DAAA;EACA,oCAAA;AxBk/KF;;AwBh/KA;EACE,YAAA;EACA,WAAA;AxBm/KF;;AwB9+KA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBi/KF;;AwB/+KA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBk/KF;;AwB9+KA;EACE,6BAAA;AxBi/KF;;AwB/+KA;EACE,cAAA;AxBk/KF;;AwBh/KA;EACE,qBAAA;EACA,YAAA;AxBm/KF;;AwBj/KA;EACE,eAAA;EACA,cAAA;AxBo/KF;;AwBj/KA;EACE,cAAA;EACA,WAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,cAAA;EACD,uBAAA;AxBm/KD;;AwB5+KA;EACE,eAAA;AxB++KF;;AwB7+KA;EACE,cAAA;EACA,WAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,cAAA;EACD,iCAAA;AxB++KD;;AwB3+KA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;AxB8+KF;;AwB5+KA;EACE,gBAAA;EACA,eAAA;AxB++KF;;AwB5+KA;EACE,cAAA;EACA,WAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EAED,uBAAA;AxB6+KD;;AwBj+KA;EACE,UAAA,EAAA,uCAAA;AxBo+KF;;AwBh+KA;EACE,uBAAA;AxBm+KF;;AwBh+KA;EACE,kBAAA;EACA,mBAAA;AxBm+KF;;AwBh+KA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AxBm+KF;;AwBh+KA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBm+KF;;AwBh+KA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBm+KF;;AwBh+KA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBm+KF;;AwBj+KA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AxBo+KF;;AwBj+KA;EACE,WAAA;EACA,cAAA;AxBo+KF;;AwBj+KA;EACE,yBAAA;EACA,cAAA;AxBo+KF;;AwBj+KA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AxBo+KF;;AwBj+KA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,eAAA;AxBm+KF;;AwBh+KA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AxBm+KF;;AwBh+KA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AxBm+KF;;AwBh+KA;EACE,cAAA;AxBm+KF;;AwBj+KA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AxBo+KF;;AwBl+KA;EACE,cAAA;EACA,eAAA;AxBq+KF;;AwBj+KA;EACA,cAAA;EACA,eAAA;AxBo+KA;;AwBl+KA;EACE,cAAA;EACA,eAAA;AxBq+KF;;AwBn+KA;EACE,YAAA;EACA,kBAAA;AxBs+KF;;AwBn+KA;EACE,YAAA;EACA,kBAAA;AxBs+KF;;AwBn+KA;EACE,aAAA;AxBs+KF;;AwBn+KA;EACE,oCAAA;EACA,uBAAA;EACA,oCAAA;AxBs+KF;;AwBn+KA;EACE,SAAA;EACA,iBAAA;AxBs+KF;;AwBn+KA;EACE,oDAAA;EACA,mBAAA;EACA,yBAAA;AxBs+KF;;AwBn+KA;EACE,UAAA;EACA,wBAAA;EACA,yBAAA;AxBs+KF;;AwBn+KA;EACE,mBAAA;EACA,oDAAA;EACA,yBAAA;AxBs+KF;;AwBn+KA;EACE,oCAAA;EACA,0BAAA;AxBs+KF;;AwBh+KA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AxBm+KF;;AwBh+KA;EACE,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AxBm+KF;;AwBh+KA;EACE,SAAA;EACA,kBAAA;EACA,UAAA;AxBm+KF;;AwBh+KA;EACE,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AxBm+KF;;AwBh+KA;EACE,uBAAA;EACA,gBAAA;AxBm+KF;;AwBh+KA;EACE,qBAAA;EACA,uBAAA;AxBm+KF;;AwBh+KA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AxBm+KF;;AwBh+KA;EACE;IACG,kBAAA;IACA,mBAAA;ExBm+KH;EwBj+KA;IACE,aAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,iBAAA;ExBm+KF;EwBj+KA;IACE,kBAAA;IACA,gBAAA;ExBm+KF;EwBj+KA;IACE,sBAAA;IACA,wBAAA;IACA,eAAA;IACA,8BAAA;IACA,6BAAA;IACA,uBAAA;IACA,+CAAA;IACA,uBAAA;IACA,2BAAA;IACA,2BAAA;ExBm+KF;AACF;AA75LA;EAKE,4CAAA;EACA,yBAAA;AA25LF;;AAv5LA;EACE,YAAA;AA05LF;;AAx5LA;EACE,yBAAA;AA25LF;;AAz5LA;EACE,yBAAA;EACA,mBAAA;EACA,wBAAA;AA45LF;;AA15LA;EACE,YAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA,EAAA,4CAAA;EACA,kCAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;AA65LF;;AA15LA;EACE,UAAA;EACA,YAAA;EACA,cAAA,EAAA,sBAAA;EACA,2BAAA;EACA,kCAAA;EACA,kBAAA;AA65LF;;AA15LA;EACE;IACE,YAAA;EA65LF;AACF;AA35LA;EACE,eyBjBQ;EzBkBR,cyB7CI;EzB8CJ,qBAAA;EACA,gBAAA;AA65LF;;AA35LA;EACE,UAAA;EACA,oCAAA;EACA,yBAAA;AA85LF;;AA35LA;EACE,UAAA;AA85LF;;AA35LA;EACE,mBAAA;EACA,oBAAA;AA85LF;;AA35LA;EACE,sBAAA;EACA,iCAAA;EACA,2BAAA;AA85LF;;AA35LA;EACE,sBAAA;EACA,kCAAA;EACA,+BAAA;EACA,uBAAA;AA85LF;;AAx5LA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AA25LF;;AAz5LA;;GAAA;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;AA45LF;;AAz5LA;EACE,uBAAA;AA45LF;;AAz5LA;EACE,uBAAA;AA45LF;;AAz5LA;EACE,2BAAA;EACA,uBAAA;AA45LF;;AAz5LA;EACE,yBAAA;AA45LF;;AAz5LA;;GAAA;AAGA;EACE,6BAAA;AA45LF;;AAz5LA;EACE,YAAA;AA45LF;;AAz5LA;EACE,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AA45LF;;AAz5LA;EACE,aAAA;EACA,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2BAAA;EACA,yBAAA;AA45LF;;AAz5LA;EAEE,sBAAA;EACA,kBAAA;EACA,4BAAA;EACA,4CAAA;AA25LF;;AAz5LA;EACE,kBAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;AA45LF;;AAz5LA;EACE,YAAA;AA45LF;;AA15LA;EACE,kBAAA;AA65LF;;AA15LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AA65LF;;AA35LA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;AA85LF;;AA15LA;EACE,cAAA;EACA,aAAA;AA65LF;;AA15LA;EACE,eAAA;EACA,UAAA;AA65LF;;AA15LA;EACE,yBAAA;EACA,eAAA;AA65LF;;AA35LA;EAEE,WAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,mBAAA;AA65LF;;AA35LA;uCACuC,WAAA;EACrC,UAAA;AA85LF;;AA35LA;EACE,gBAAA;EACA,wBAAA;AA85LF;;AA35LA;EACE,gBAAA;AA85LF;;AAt5LA;EACE,sBAAA;AAy5LF;;AAr5LA;EACE,oDAAA;EACA,yBAAA;EACA,mBAAA;AAw5LF;;AAr5LA;EACE,UAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;AAw5LF;;AAr5LA;EACE,yBAAA;EACA,mBAAA;EACA;;;;;;;2BAAA;AA+5LF;;AAr5LA;EACE,wCAAA;AAw5LF;;AAr5LA;EACE,sBAAA;EACA,6BAAA;AAw5LF;;AAr5LA;EACE,6BAAA;AAw5LF;;AAr5LA;EACE,sBAAA;AAw5LF;;AAr5LA;EACE,qBAAA;AAw5LF;;AAr5LA;EACE,uBAAA;EACA,2BAAA;AAw5LF;;AAr5LA;EACE,oCAAA;EACA,uBAAA;AAw5LF;;AAr5LA;EACE,oCAAA;AAw5LF;;AAr5LA;EACE,sBAAA;EACA,qCAAA;AAw5LF;;AAr5LA;EACE,wBAAA;AAw5LF;;AA/4LA;EACE,wBAAA;AAk5LF;;AA/4LA;EACE,qBAAA;AAk5LF;;AA/4LA;EACE,yBAAA;AAk5LF;;AA/4LA;EACE,oCAAA;AAk5LF;;AA/4LA;EACE,wBAAA;AAk5LF;;AA/4LA;EACE,uBAAA;AAk5LF;;AA/4LA;EACE,uBAAA;AAk5LF;;AA/4LA;EACE,aAAA;EACA,mBAAA;AAk5LF;;AA/4LA;EACE,wBAAA;AAk5LF;;AA/4LA;;GAAA;AAGA;EACE,uBAAA;AAk5LF;;AA/4LA;;EAEE,uBAAA;AAk5LF;;AA/4LA;EACE,yCAAA;EACA,4CAAA;EACA,gBAAA;AAk5LF;;AA94LA;EACE,yBAAA;EACA,qBAAA;EACA,oBAAA;AAi5LF;;AA54LA;EACE,uCAAA;AA+4LF;;AA54LA;EACE,6BAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;AA+4LF;;AA54LA;EACE,aAAA;AA+4LF;;AA54LA;EACE,uBAAA;AA+4LF;;AA54LA;EACE,wCAAA;AA+4LF;;AA54LA;EAEE,wBAAA;AA84LF;;AA34LA;EAEE,wBAAA;AA64LF;;AA14LA;EACE,oCAAA;EACA,gJAAA;AA64LF;;AAz4LA;EACE,6BAAA;AA44LF;;AAz4LA;EACE,eAAA,EAAA,2BAAA;AA44LF;;AAz4LA;EACE,mBAAA,EAAA,kCAAA;AA44LF;;AAz4LA;EACE,mBAAA,EAAA,kCAAA;EACA,uBAAA,EAAA,kCAAA;AA44LF;;AAz4LA,wCAAA;AACA;EACE,qBAAA,EAAA,+BAAA;EACA,gCAAA,EAAA,2BAAA;AA44LF;;AAz4LA;EACE,YAAA;EACA,uBAAA,EAAA,qBAAA;EACA,mBAAA,EAAA,oCAAA;EACA,gBAAA,EAAA,kDAAA;AA44LF;;AAz4LA;EACE,eAAA;EACE,0BAAA;EACA,WAAA;AA44LJ;;AAz4LA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AA44LF;;AAz4LA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA44LF;;AAn4LA;EACE,YAAA;EACA,sBAAA;EACA,UAAA;EAEA,kBAAA;EACA,WAAA;AAq4LF;;AAl4LA;EACE,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AAq4LF;;AAl4LA;EACE,UAAA;EACA,yBAAA;EACA,WAAA;AAq4LF;;AAj4LA;EACE,oDAAA;EACA,yBAAA;EACA,mBAAA;AAo4LF;;AAj4LA;EACE,yBAAA;EACA,mBAAA,EAAA,oBAAA;AAo4LF;;AAj4LA;EACE,gBAAA,EAAA,gCAAA;AAo4LF;;AAj4LA;EACE,wBAAA;AAo4LF;;AA73LA;EACE;;IAEE,sBAAA;EAg4LF;EA93LA;IACE,0BAAA;EAg4LF;EA93LA;IACE,0BAAA;EAg4LF;EA73LA;IACE,cAAA;EA+3LF;EA53LA;IACE,cAAA;EA83LF;EA33LA;IACE,cAAA;EA63LF;AACF","sourcesContent":["@import \"./veriables.scss\";\n@import \"~react-pro-sidebar/dist/scss/styles.scss\";\n@import \"./components\";\n\nbody {\n  // font-family: $font-family-Roboto !important;\n  // font-size: $font-14;\n  // font-family: Roboto;\n\n  font-family: \"Roboto\", sans-serif !important;\n  background-color: #fbfcff;\n\n  // color: $light-gray;\n}\n.vh-69{\n  height:69vh\n}\n.break-word {\n  overflow-wrap: break-word;\n}\n.selected-attribute{\n  border: 2px solid #FFD705;\n  border-radius: 10px;\n  padding: 2px 0px 2px 0px;\n}\n.side_nav_main_1 {\n  height: 89vh;\n  overflow: auto;\n  width: 3%;\n  transition: width 0.7s ease; /* Smooth transitions for width and margin */\n  border-top: 0.025rem solid #ffd705;\n  border-right: 0.025rem solid #ffd705;\n  border-top-right-radius: 0.625rem;\n  background-color: white;\n  cursor: pointer;\n  z-index: 99999999 !important;\n  position: absolute;\n}\n\n.side_nav_main_1.expanded {\n  width: 14%;\n  margin: auto;\n  margin-left: 0; /* Reset margin-left */\n  transition: width 0.7s ease;\n  z-index: 99999999999999 !important;\n  position: absolute;\n}\n\n@media (max-width: 500px) {\n  .side_nav_main_1.expanded {\n    width: 150px;\n  }\n}\n.errorMessage {\n  font-size: $font-12;\n  color: $red;\n  line-height: 1.125rem;\n  text-align: left;\n}\n.fade-in-text {\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n  color: #000000 !important;\n}\n\n.fade-in-text.visible {\n  opacity: 1;\n}\n\n.react-tel-input .selected-flag .arrow {\n  top: 60% !important;\n  left: 5px !important;\n}\n\n.css-i4bv87-MuiSvgIcon-root {\n  color: grey !important;\n  border-radius: 6.25rem !important;\n  padding: 0.25rem !important;\n}\n\n.css-1db085k-MuiSvgIcon-root {\n  color: grey !important;\n  background-color: white !important;\n  border-radius: 100px !important;\n  padding: 4px !important;\n}\n\n.rbc-row-content {\n  // display: none !important;\n}\n.rbc-date-cell{\n  flex: 1 1;\n  min-width: 0;\n  padding-left: 5px;\n  text-align: left;\n}\n/*.rbc-btn-group{\n  display: none !important;\n} */\n.rbc-toolbar-label {\n  font-weight: 600;\n  text-align: start;\n  padding: 2;\n  color: #5599ff;\n}\n\n.rbc-time-view {\n  border: none !important;\n}\n\n.rbc-time-header-content {\n  border: none !important;\n}\n\n.rbc-time-header-content > .rbc-row.rbc-row-resource {\n  border-bottom: 0 !important;\n  height: 4rem !important;\n}\n\n.rbc-time-content > * + * > * {\n  border-left: 0 !important;\n}\n\n/* .rbc-toolbar{\n  display: none !important;\n} */\n.rbc-timeslot-group {\n  min-height: 2.6rem !important;\n}\n\n.rbc-time-slot {\n  height: 100%;\n}\n\n.rbc-event {\n  border: 1px solid white !important;\n  display: flex;\n  flex-direction: column;\n  width: 100% !important;\n  left: 0 !important;\n}\n\n.rbc-label {\n  display: flex;\n  text-align: center !important;\n  min-width: 3.125rem !important;\n  font-weight: 500 !important;\n  font-size: 0.625rem !important;\n  margin-top: -2px !important;\n  color: #5b5b5b !important;\n}\n\n.rbc-events-container {\n  // min-width: 13vw !important;\n  width: 100% !important;\n  left: 0 !important;\n  margin-right: 2px !important;\n  border-right: 0.2px solid #666666 !important;\n}\n.container-less-more {\n  text-align: center;\n  margin: auto;\n  /* justify-content: space-evenly; */\n  max-width: 30rem;\n}\n\n.geeks {\n  color: green;\n}\n.audio-container {\n  position: relative;\n}\n\n.no-preview-label {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n  padding: 8px;\n  border-radius: 5px;\n  display: none;\n}\n.list-group{\n  position: relative;\n  display: block;\n  padding: 10;\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  // border: 1px solid #f8f8f8 !important;\n}\n\n.audio-container:hover .no-preview-label {\n  display: block;\n  color:\"#000\"\n}\n\n.text-read-hide-less {\n  display: inline;\n  width: 90%;\n}\n\n.read-or-hide {\n  color: rgb(192, 192, 192);\n  cursor: pointer;\n}\n.rbc-header {\n  // height: 3.75rem !important;\n  color: #000;\n  font-size: 20px !important;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n.rbc-month-header > div:nth-child(1), /* Saturday */\n.rbc-month-header > div:nth-child(7) { /* Sunday */\n  color: red;\n}\n\n.rbc-event-label {\n  font-weight: 700;\n  display: none !important;\n}\n\n.rbc-event {\n  font-weight: 600;\n}\n\n// .rbc-time-view-resources .rbc-header,\n// .rbc-time-view-resources .rbc-day-bg {\n//   width: 13vw !important;\n// }\n\n.rbc-time-content > .rbc-day-slot {\n  width: 100% !important;\n  // min-width: 13vw !important;\n}\n\n.rbc-time-content::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n  border-radius: 10px;\n}\n\n.rbc-time-content::-webkit-scrollbar {\n  width: 5px;\n  display:hide !important;\n  height: 5px;\n  background-color: #f5f5f5;\n}\n\n.rbc-time-content::-webkit-scrollbar-thumb {\n  background-color: #ffbf00;\n  border-radius: 10px;\n  /* background-image: -webkit-linear-gradient(0deg,\n\t                                          rgba(255, 255, 255, 0.8) 25%,\n\t\t\t\t\t\t\t\t\t\t\t  transparent 25%,\n\t\t\t\t\t\t\t\t\t\t\t  transparent 50%,\n\t\t\t\t\t\t\t\t\t\t\t  rgba(255, 255, 255, 0.8) 50%,\n\t\t\t\t\t\t\t\t\t\t\t  rgba(255, 255, 255, 0.8) 75%,\n\t\t\t\t\t\t\t\t\t\t\t  transparent 75%,\n\t\t\t\t\t\t\t\t\t\t\t  transparent) */\n}\n\n.rbc-today {\n  background-color: transparent !important;\n}\n\n.react-datepicker-wrapper {\n  width: 40px !important;\n  margin-left: -40px !important;\n}\n\n.react-datepicker__input-container input {\n  text-align: center !important;\n}\n\n.css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n  width: 100% !important;\n}\n\n.react-datepicker__triangle {\n  left: 40px !important;\n}\n\n.rbc-toolbar button {\n  border: none !important;\n  font-weight: 500 !important;\n}\n\n.rbc-active {\n  background-color: #5599ff !important;\n  color: white !important;\n}\n\n.rbc-btn-group button:hover {\n  background-color: rgb(107, 107, 107);\n}\n\n.react-datepicker-popper {\n  z-index: 99 !important;\n  inset: 0px auto auto -51px !important;\n}\n\n.rbc-month-view {\n  height: 100vh !important;\n}\n\n// .rbc-current-time-indicator {\n//   background-color: #ffffff !important;\n//   border: 1px solid #FE0000 !important;\n//   border-radius: 100px;\n//   z-index: 99999999999999 !important;\n// }\n.rbc-current-time-indicator {\n  display: none !important;\n}\n\n.css-bdhsul-MuiTypography-root-MuiDialogTitle-root {\n  padding: 0 !important;\n}\n\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: #5599ff !important;\n}\n\n.css-1aquho2-MuiTabs-indicator {\n  background-color: #5599ff !important;\n}\n\n.css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon {\n  display: none !important;\n}\n\n.css-74e2me-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  border: none !important;\n}\n\n.css-13xfq8m-MuiTabPanel-root {\n  padding: 0px !important;\n}\n\n.css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input.css-1rxz5jq-MuiSelect-select-MuiInputBase-input-MuiInput-input {\n  display: flex;\n  align-items: center;\n}\n\n.css-19khbc0-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  display: none !important;\n}\n\n/* .css-l4u8b9-MuiInputBase-root-MuiInput-root:before{\n  display: none !important;\n} */\n.rbc-time-header .rbc-overflowing {\n  border: none !important;\n}\n\n.rbc-time-view-resources .rbc-time-gutter,\n.rbc-time-view-resources .rbc-time-header-gutter {\n  border: none !important;\n}\n\n.rbc-time-content {\n  border-top: 2px solid darkgray !important;\n  border-bottom: 2px solid darkgray !important;\n  padding-top: 5px;\n  // padding-bottom: 5px;\n}\n\n.rbc-time-view .rbc-time-header {\n  height: 3.6rem !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  // background-color: anas;\n  // margin: 0rem 0 !important;\n}\n\n.rbc-time-content > .rbc-time-gutter {\n  border-right: 1px solid #ddd !important;\n}\n\n.rbc-event {\n  border-radius: 5px !important;\n  padding: 0 !important;\n  border-width: 1px !important;\n  min-height: 1rem !important;\n  width: 100% !important;\n  margin-left: 0px !important;\n  margin-top: 0.03rem !important;\n}\n\ntextarea:focus {\n  outline: none;\n}\n\n.rbc-timeslot-group {\n  border: none !important;\n}\n\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid #e3e3e3 !important;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::after {\n  display: none !important;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before {\n  display: none !important;\n}\n\n.pt1 {\n  background-color: #343a40 !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='hexagons' fill='%239C92AC' fill-opacity='0.25' fill-rule='nonzero'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\"),\n    linear-gradient(to right top, #343a40, #2b2c31, #211f22, #151314, #000000) !important;\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 3.2px 8px !important;\n}\n\nul.dropdown-menu::-webkit-scrollbar {\n  width: 0.313rem; /* Width of the scrollbar */\n}\n\nul.dropdown-menu::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Track color (gray by default) */\n}\n\nul.dropdown-menu::-webkit-scrollbar-thumb {\n  background: #ffbf00; /* Thumb color (gray by default) */\n  border-radius: 0.125rem; /* Rounded corners for the thumb */\n}\n\n/* Customize the scrollbar for Firefox */\nul.dropdown-menu {\n  scrollbar-width: thin; /* Thin scrollbar for Firefox */\n  scrollbar-color: #ffbf00 #f1f1f1; /* Thumb and track colors */\n}\n\n.ellipsis {\n  width: 100px;\n  text-overflow: ellipsis; /* enables ellipsis */\n  white-space: nowrap; /* keeps the text in a single line */\n  overflow: hidden; /* keeps the element from overflowing its parent */\n}\n\n.booking_customer_name {\n  font-size: 12px;\n    text-transform: capitalize;\n    margin: 0px;\n}\n\n.booking_service_name {\n  font-size: 12px;\n  font-weight: 400;\n  margin: 7px 0px;\n}\n\n.booking_time {\n  font-size: 10px;\n  margin: 0px;\n  font-weight: normal;\n}\n\n// .rbc-event .rbc-event-content {\n// display: flex;\n// align-items: center;\n// padding: 0 !important;\n// }\n\n.input-container input {\n  border: none;\n  box-sizing: border-box;\n  outline: 0;\n  // padding: .75rem;\n  position: relative;\n  width: 100%;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  background: transparent;\n  bottom: 0;\n  color: transparent;\n  cursor: pointer;\n  height: auto;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: auto;\n}\n\n::-webkit-scrollbar {\n  width: 1px;\n  display: block !important;\n  height: 2px;\n  // background-color: #f5f5f5; /* width of the scrollbar */\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #ffbf00;\n  border-radius: 10px; /* rounded corners */\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555; /* color of the thumb on hover */\n}\n\n.rbc-calendar {\n  height: 99.70% !important;\n} \n\n// *:hover {\n//   border: 1px solid #ffbf00;\n// }\n\n@media (max-width: 700px) {\n  .rbc-time-view-resources .rbc-header,\n  .rbc-time-view-resources .rbc-day-bg {\n    width: 70px !important;\n  }\n  .rbc-time-content > .rbc-day-slot {\n    min-width: 70px !important;\n  }\n  .rbc-events-container {\n    min-width: 70px !important;\n  }\n\n  .booking_customer_name {\n    font-size: 9px;\n  }\n  \n  .booking_service_name {\n    font-size: 8px;\n  }\n  \n  .booking_time {\n    font-size: 7px;\n  }\n}\n","@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n",".form-container{\n  width:100%;\n  max-width: 1400px;\n  padding-left: 50px;\n  height:100vh;\n  padding-bottom: 100px;\n  padding-right: 50px;\n  margin: auto;\n  overflow: auto;\n}\n.form-container-business{\n  width:100%;\n  max-width: 1400px;\n  padding-left: 50px;\n  height:70vh;\n  padding-right: 50px;\n  margin: auto;\n  overflow: auto;\n  padding-bottom: 180px\n}\n.search-bar-text{\n  // font-family: \"Roboto\";\nfont-size: 12px;\nfont-weight: 400;\nline-height: 14px;\nletter-spacing: 0em;\ntext-align: left;\ncolor:'#AAAAAA'\n}\n.search-card {\n  width:max-content!important;\n  padding: 20px !important;\n  height: max-content!important;\n  border-radius: 5px !important;\n  color: black !important;\n  background-color: #F5F5F5 !important;\n  padding: 1px !important;\n \n}\n.table-container{\n  max-width: 100%;\n  margin: auto;\n  height:80vh;\n}\n.loader{\n  flex:1,\n}\n.perfect-scroll{\nheight: 80vh;\noverflow-y: auto;\n}\n.link-hover{\ncursor: pointer;\n\n}\n.type{\n  color: #414141;\nfont-family: Barlow;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n.link-hover:hover{\n  color:#548dff;\n  font-weight: 600;\n}\n.map-container{\n  max-width: 100%;\n  margin: auto;\n  overflow-x: hidden;\n}\n.spanUser{\n  color:#6B6B6B;\n  \n}\n.tab-container{\n  max-width: 100%;\n  margin: auto;\n}\n// .span{\n// color: #b2b2b2;\n// }\n.spanTerm{\n  color: #C2C2C2;\nfont-family: Roboto;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 18px;\n}\n.span2{\n  color: #1e1d1d;\n  font-size: 16px;\n  font-weight: 700;\n  box-shadow: #1e1d1d;\n  }\n  .businessName{\n    font-size: 18px;\n    color: #616161;\n    font-weight: 400;\n    line-height: 26px;\n  }\n  .businessId{\n    font-size: 14px;\n    color: #8A8A8A;\n    font-weight: 200;\n  }\n  .bolds{\n    font-size: 12px;\n    text-align: left;\n    font-weight: 500;\n    color:#979595\n  }\n  .switch{\n    font-size:\"14px\";color:#548DFF;font-weight:500\n  }\n  .success{\nbackground-color: #e7fcf6; \ncolor:#13710e;\npadding:5px 10px 5px 10px;\nborder-radius: 10px;\nfont-weight: 500;\n\n }\n .pending{\n  background-color: #fff7ed  ; \n  color:#fed6a9;\n  padding:5px 10px 5px 10px;\n  border-radius: 10px;\n  font-weight: 500;\n   }\n   .statusText{ \n    color:#fff;\n    padding:5px 10px 5px 10px;\n    border-radius: 10px;\n    font-weight: 500;\n     }\n   .suspended{\n    background-color: #ffb0ad  ; \n    color:#d8382d;\n    padding:5px 10px 5px 10px;\n    border-radius: 10px;\n    font-weight: 500;\n     }\n  .arrow{\n    font-size: 30px;\n    color: #b2b2b2;\n    margin-left: 25px;\n    margin-top: 20px;\n  }\ninput.lager{\n  width: 16px;\n  height: 16px;\n  border-radius: 50px;\n  background-color:#9b1d1d ;\n}\ninput.lager:checked{\n  width: 16px;\n  height: 16px;\n  border-radius: 50px;\n}\n\n.permission{\n  color:#548dff;\n  font-size: small;\n  cursor: pointer;\n}\n.permission2{\n  color:#b2b2b2;\n  font-size: small;\n  cursor: pointer;\n\n}\n\nul.orderlist{\n  text-align: left;\n  font-size: 12px;\n}\n.serviceText{\n  font-size: 14px;\n  font-weight: 400;\n}\n.service{\n  padding: 8px;\n  border: 1px solid #d2d2d2;\n  border-radius: 6px;\n  /* width:120px; */\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n\n}\n.service:hover{\n  cursor: pointer;\n  background-color: #a5bff5;\n  color:white\n}\n.link{\n  text-decoration: none;\n    color: #999191;\n    font-size: 14px;\n    font-weight: 500;\n}\n.active{\n  border-bottom:2px solid #548dff;\n  text-decoration: none;\n\n}\n.homeIcon{\n  font-size: 16px;\n}\n.link:hover{\n   text-decoration: none;\n    color: #999191;\n    font-size: 14px;\n    font-weight: 500;\n    border-bottom:2px solid #548dff;\n}\n.icon{\n  color: rgb(255, 255, 255);\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    background-color: #5599FF;\n    font-size: 12px;\n    border-radius: 10px;\n}\n\n.bold{\n  font-weight: 700;\n  margin-left: 5px;\n}\n.paddings{\n  /* margin-left: 250px; */\n  margin-right: 450px;\n\n   text-align: center;\n}\n.grey-letter{\n  color: #AAA;\n  // font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal; \n}","// .App {\n//   text-align: center;\n//   display: flex;\n//   justify-content: center;\n//   align-items: center;\n//   width: 100%;\n//   height: 100vh;\n//   background-color: #ebe7e5;\n//   overflow: hidden;\n// }\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n.App {\n  background-color: #fbfcff; \n   height: 100vh;\n    overflow: auto;\n  }\n  \n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}",".overflow_calender {\n    overflow-y: scroll;\n    // height: 71.8vh;\n    scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n//   padding-bottom: 120px\n}\n\n.height_for_booking {\n    height: 76vh !important;\n    border: 1px solid rgb(229, 228, 228);\n    border-radius: 10px;\n}\n\n.height_for_calendar {\n    height: 93vh !important;\n}\n\n\n\n.overflow_calender::-webkit-scrollbar {\n    display: none; /* WebKit (Chrome, Safari, etc.) */\n  }\n  \n\n// .overflow_calender::-webkit-scrollbar {\n//     display: none;\n// }\n\n.height_fixed_cal {\n    height: 75vh;\n    overflow-y: scroll;\n}\n\n#style-2::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    border-radius: 10px;\n    background-color: #F5F5F5;\n}\n\n#style-2::-webkit-scrollbar {\n    width: 5px;\n    background-color: #F5F5F5;\n}\n\n#style-2::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n    height: 5px;\n    background-color: #FFBF00;\n}",".col input,\n.col select,\n.col textarea {\n  border: none !important;\n  font-size: 14px;\n  color: gray;\n}\n\n:focus {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.col input:focus,\n.col select:focus,\n.col textarea:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n.input_wrapper {\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n}\n\n.input_wrapper label {\n  padding-left: 10px;\n  font-size: 12px;\n  color: gray;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.form-check {\n  padding-left: 45px !important;\n  padding-top: 10px;\n}\n\n.checkbox_lbl {\n  font-size: 14px !important;\n  color: black !important;\n}\n\n.cancel_btn {\n  background-color: lightgray !important;\n}\n\n.service_publish {\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  background-color: white !important;\n}\n\n.form_btns {\n  height: 35px;\n  font-size: 14px !important;\n}\n\n.span_input_url {\n  border-top-right-radius: 25px !important;\n  border-top-left-radius: 0px !important;\n  font-size: 14px !important;\n  color: gray !important;\n  background-color: #e5e5e5 !important;\n}\n\n.switch_btn_col_th {\n  width: 50px !important;\n}\n\n// .service-add-detail {\n//   .service-card-img {\n//     width: 100px !important;\n//     height: 100px !important;\n//     background-color: green;\n//   }\n\n//   .accordion-button::after {\n//     rotate: -90deg !important;\n//   }\n\n//   .service-add-detail .accordion-button::after {\n//     rotate: -180deg !important;\n//   }\n\n//   .accordion-item:first-of-type .accordion-button {\n//     padding: 10px !important;\n//   }\n// }\n\n.MuiTableCell-root {\n  text-align: unset !important;\n}\n.css-g2z002-MuiSvgIcon-root-MuiPaginationItem-icon {\n  fill: #f0bc08 !important;\n}\n\nli {\n  list-style: none;\n}\n\n.text-green {\n  color: #89e0c1;\n}\n\n.border-green {\n  border: 1px solid #89e0c1;\n}\n\n.text-light-grey {\n  color: #b1b4b7 !important;\n}\n\n.text-secondary {\n  color: #6f6f6f !important;\n}\n\n.custom-border {\n  border: 1px solid #e7eaec !important;\n  border-radius: 8px !important;\n}\n\n.MuiButtonBase-root {\n  font-size: 16px !important;\n  // color: black !important;\n}\n\n.pr-6px {\n  padding-right: 6px !important;\n}\n\n.pl-6px {\n  padding-left: 6px !important;\n}\n\n.mt-12px {\n  margin-top: 12px !important;\n}\n\n.mt-9px {\n  margin-top: 9px !important;\n}\n\n:focus {\n  outline: 0 !important;\n  box-shadow: none !important;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root {\n  position: static !important;\n}\n\n.border-right {\n  border-right: 1px solid #eeeff0;\n}\n\n.service-add-detail {\n  .price-input-wrapper {\n    .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\n      color: #7f7f7f !important;\n      padding-left: 6px;\n    }\n    .MuiOutlinedInput-notchedOutline {\n      border: none !important;\n    }\n  }\n\n  .form-check {\n    padding: 0 !important;\n    padding-left: 24px !important;\n  }\n  height: 100% !important;\n  .service-menu {\n    background: white;\n    padding: 0;\n    margin: 0;\n\n    a {\n      text-decoration: none;\n    }\n\n    .active-menu {\n      background: #fdf8e6;\n      .menu-link,\n      .caret {\n        color: #f0bc08 !important;\n      }\n    }\n\n    li:hover {\n      background: #fdf8e6;\n      .menu-link,\n      .caret {\n        color: #f0bc08 !important;\n      }\n    }\n\n    li {\n      padding: 12px 10px;\n      padding-bottom: 0;\n      border-radius: 8px;\n      cursor: pointer;\n\n      .caret {\n        color: #aaaaaa;\n        font-size: 18px;\n      }\n\n      .link-wrap {\n        border-bottom: 0.5px solid #ededed !important;\n      }\n      .menu {\n        font-size: 14px;\n        font-weight: 400;\n        color: #4c4c4c;\n        padding-bottom: 10px;\n      }\n    }\n  }\n\n  .service-card {\n    width: 100px;\n    height: 100px;\n    background: lightgray;\n    border-radius: 100%;\n    position: relative;\n    .camera {\n      position: absolute;\n      bottom: 0;\n      right: 8px;\n    }\n  }\n\n  .head {\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .card-detail {\n    font-size: 12px;\n  }\n\n  .input-group {\n    position: relative;\n    width: 100%;\n\n    .input-label {\n      position: absolute;\n      font-size: 11px;\n      top: 5px;\n      left: 10px;\n    }\n\n    .input {\n      width: 100%;\n      padding: 25px 10px 4px 10px;\n      font-weight: 400;\n      color: black !important;\n      background: white;\n      font-size: 14px;\n    }\n    .input:focus {\n      outline: 1px solid #ffd705 !important;\n      outline-offset: 2px;\n    }\n\n    ::placeholder {\n      font-size: 14px !important;\n    }\n  }\n\n  .form-check-label {\n    color: black !important;\n  }\n\n  .form-check-input[type=\"checkbox\"]:checked {\n    background-color: #ffd705 !important;\n  }\n\n  input[type=\"checkbox\"] {\n    border-radius: 4px !important;\n  }\n\n  .form-check-label {\n    font-size: 14px !important;\n  }\n\n  .checkbox-label {\n    color: black !important;\n    font-size: 14px;\n  }\n\n  .cancel-btn,\n  .save-btn {\n    border: 0;\n    outline: 0;\n    border-radius: 8px;\n    font-weight: 400;\n    box-shadow: none !important;\n    text-transform: capitalize;\n    outline: none !important;\n    border: 0 !important;\n  }\n\n  .save-btn {\n    padding: 10px 60px;\n  }\n\n  .cancel-btn {\n    padding: 10px 45px;\n  }\n  .save-btn:hover {\n    background: #ffd705 !important;\n  }\n\n  // .css-sghohy-MuiButtonBase-root-MuiButton-root {\n  //   box-shadow: none !important;\n  // }\n\n  .save-btn {\n    background: #ffd705;\n    color: white;\n  }\n\n  .add-btn {\n    border: 0;\n    outline: 0;\n    padding: 16px 20px;\n    border-radius: 8px;\n    background: #ffd705;\n    color: white;\n    font-size: 14px;\n  }\n\n  .cancel-btn {\n    background: #e9e9e9;\n    color: #9f9f9f;\n  }\n\n  .cancel-btn:hover {\n    background: #e9e9e9 !important;\n  }\n\n  .select-service-type {\n    font-size: 12px;\n    color: black;\n  }\n\n  .input-dropdown {\n    padding: 12.5px !important;\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n  }\n}\n\n.right-select {\n  position: relative;\n  span {\n    position: absolute;\n    top: 0;\n  }\n  .right-select-input {\n    padding: 27px 10px 2px 10px;\n    font-size: 14px !important;\n  }\n  .select-label {\n    position: absolute;\n    font-size: 11px;\n    top: 5px;\n    left: 10px;\n  }\n}\n\n.attributes {\n  padding: 10px;\n\n  .areas {\n    font-size: 14px;\n  }\n\n  .tag {\n    padding: 10px 25px;\n\n    .cross {\n      color: #ffd705 !important;\n      position: absolute;\n      right: 0px;\n      top: 0px;\n    }\n  }\n\n  .enter-tags {\n    font-weight: 400;\n    border: 0;\n    outline: 0;\n    font-size: 14px !important;\n    background: transparent;\n  }\n\n  .enter-tags::placeholder {\n    font-size: 14px !important;\n  }\n\n  .tags-wrap {\n    margin-bottom: 5px;\n  }\n}\n\n.group-input {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n  border-top-right-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n  border: none !important;\n  font-size: 14px !important;\n  position: absolute !important;\n  width: 130px;\n  right: 0;\n  top: -52px;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  background: #efefef;\n  color: #7f7f7f;\n}\n\n.add-column {\n  background-color: white;\n  background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23dcdcdc' stroke-width='2' stroke-dasharray='13' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e\");\n\n  .add-circle-icon {\n    color: #cfcfcf;\n    border: 1px solid #cfcfcf;\n    border-radius: 8px;\n    padding: 0 7px;\n    margin: 5px;\n  }\n}\n\n.att-table {\n  border: 1px solid #e7eaec !important;\n  overflow-x: hidden;\n\n  .description-cell {\n    width: 260px;\n  }\n\n  .table-add-new {\n    cursor: pointer;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    background: white;\n    padding: 10px 6px;\n    font-size: 12px;\n    color: #ffd705;\n\n    .add-circle-table {\n      color: #ffd705 !important;\n    }\n  }\n  .mins {\n    font-size: 12px;\n    padding-left: 5px;\n  }\n\n  .area-wrap {\n    background: #f6f6f6;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    .area {\n      font-weight: 600;\n      padding: 12px 20px;\n      border-bottom: 1px solid #e7eaec !important;\n      width: 32%;\n    }\n  }\n}\n\n.price-table-wrap {\n  border: 1px solid #ffd705;\n  border-radius: 8px;\n  background: white;\n\n  .delete-field {\n    cursor: pointer;\n    position: absolute;\n    right: -30px;\n    font-size: 25px;\n  }\n\n  .table-top-select {\n    color: black !important;\n  }\n\n  .table-cell {\n    width: 20px;\n  }\n\n  .table-select {\n    border: none !important;\n  }\n\n  .table {\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    thead,\n    tbody tr {\n      display: table;\n      width: 100%;\n      table-layout: fixed;\n    }\n    thead {\n      th {\n        background: #f6f6f6;\n        padding-top: 14px;\n        padding-bottom: 14px;\n      }\n    }\n\n    tbody {\n      max-height: 253px;\n      overflow: auto;\n      display: block;\n      border: 0 8px 8px 0;\n    }\n\n    tr,\n    td,\n    th {\n      border: none !important;\n      text-align: left !important;\n    }\n    tr {\n      border-bottom: 1px solid #f6f6f6 !important;\n    }\n\n    tbody .tr:last-child {\n      border-bottom: 0 !important;\n    }\n\n    th {\n      font-size: 12px;\n      font-weight: 500;\n      cursor: default;\n    }\n\n    td {\n      font-size: 14px;\n      color: #676464;\n      cursor: default;\n      padding-top: 12px !important;\n      padding-bottom: 12px !important;\n    }\n  }\n\n  .cell-currency,\n  .cell-time {\n    background-color: #f4f4f4;\n    color: #c3c3c3;\n    padding: 5px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n  }\n\n  .price-cell {\n    width: 170px;\n    path {\n      fill: #ffd705;\n    }\n  }\n\n  .duration-cell {\n    width: 100px;\n  }\n\n  .sku-cell {\n    width: 110px;\n  }\n\n  .down-arrow {\n    font-size: 16px;\n    color: #ffd705;\n  }\n\n  .price-type-cell {\n    width: 136px;\n    padding-right: 0;\n    padding-left: 10px;\n  }\n}\n\n.publish-status-wrapper {\n  margin-top: 1px !important;\n  position: relative;\n\n  .publish-label {\n    font-size: 11px;\n    position: absolute;\n    top: 5px;\n    left: 10px;\n    z-index: 1;\n  }\n\n  .green-border div:first-child {\n    color: #14c284 !important;\n  }\n  .red-border div:first-child {\n    color: #e8003f !important;\n  }\n  .publish-status {\n    padding-top: 11px;\n    padding-bottom: 11px;\n    background: white;\n\n    input[value=\"10\"] ~ .MuiOutlinedInput-notchedOutline {\n      border: 2px solid #14c284 !important;\n    }\n    input[value=\"20\"] ~ .MuiOutlinedInput-notchedOutline {\n      border: 2px solid #e8003f !important;\n    }\n\n    .MuiOutlinedInput-notchedOutline {\n      border: 1px solid #e7eaec !important;\n      // background: white;\n    }\n  }\n\n  .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {\n    color: black !important;\n    padding-left: 2px;\n    // border: 1px solid #e7eaec !important;\n    // outline: none !important;\n    border-radius: 8px;\n  }\n\n  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n    position: relative;\n    top: 10px;\n    font-size: 14px;\n  }\n\n  svg {\n    position: relative;\n    top: 10px;\n  }\n}\n\n.service-group-wrap {\n  .cards-wrap {\n    max-height: 365px;\n    overflow: auto;\n    width: 100%;\n    background: transparent;\n    border: none;\n    .group-card {\n      border-radius: 5px !important;\n      margin-bottom: 12px;\n      .group-service-card {\n        width: 50px;\n        height: 50px;\n        background: lightgray;\n        border-radius: 100%;\n        position: relative;\n      }\n    }\n    .group-card:last-child {\n      margin-bottom: 0;\n    }\n  }\n  .add-new {\n    width: fit-content;\n    border: 1px solid #ffd705;\n    background: #fdf8e6;\n    border-radius: 8px;\n    padding: 10px 40px;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: auto;\n    margin-top: 40px;\n    margin-bottom: 80px;\n    cursor: pointer;\n\n    .plus {\n      padding: 0 7px;\n      background: #ffd705;\n      border-radius: 6px;\n      color: white;\n    }\n  }\n}\n\n.offcanvas {\n  --bs-offcanvas-width: 50vw !important;\n}\n\n.offcanvas-end {\n  border-top-left-radius: 16px;\n  border-bottom-left-radius: 16px;\n}\n\n.offcanvas-title {\n  font-size: 24px !important;\n  font-weight: 400 !important;\n}\n\n.pricing-select {\n  position: relative;\n  .select-label {\n    font-size: 11px;\n    position: absolute;\n    top: 7px;\n    left: 17px;\n    z-index: 1;\n  }\n\n  .pricing-dropdown {\n    padding: 21px 0px 2px 3px;\n    border-radius: 8px;\n    background: white;\n    margin-top: 3px;\n\n    .MuiOutlinedInput-notchedOutline {\n      border: 1px solid #e7eaec !important;\n    }\n  }\n\n  .pricing-dropdown div:first-child {\n    font-size: 14px;\n    position: relative;\n    bottom: -2px;\n    color: black;\n  }\n\n  div svg {\n    margin-top: -17px;\n  }\n}\n\n.pricing-table-select div:first-child {\n  font-size: 14px;\n  color: #676464 !important;\n}\n\n.pricing-table-select {\n  .MuiOutlinedInput-notchedOutline {\n    border: none;\n  }\n}\n\n.pricing-table {\n  .price-cell {\n    width: 155px;\n  }\n  .desc-cell {\n    width: 85px;\n  }\n  tbody {\n    overflow-x: hidden !important;\n    tr td {\n      background: transparent !important;\n    }\n    max-height: 325px !important;\n  }\n\n  .table-cell {\n    border-top-left-radius: 8px;\n  }\n\n  .price-cell {\n    border-top-right-radius: 8px;\n  }\n}\n\n.variable-price-table-wrap {\n  margin-right: -11px;\n  .table {\n    background: transparent;\n\n    tbody {\n      tr {\n        margin-bottom: 1px solid #f6f6f6;\n      }\n    }\n    tr td:first-child {\n      border-bottom-left-radius: 8px;\n    }\n\n    tr td div {\n      border-right: 1px solid #eeeff0 !important;\n    }\n    tr td:last-child {\n      border-bottom-right-radius: 8px;\n    }\n\n    tr td:last-child div {\n      border-right: none !important;\n    }\n  }\n\n  border: 1px solid #c6c4bc !important;\n  background: white;\n  border-radius: 8px !important;\n  .variable-prices-table {\n    th {\n      background: #ffd705 !important;\n      color: white;\n      font-size: 12px;\n      font-weight: 400;\n    }\n\n    td {\n      font-size: 12px;\n    }\n  }\n  .variable-prices-table th:first-child {\n    border-top-left-radius: 8px;\n  }\n\n  .variable-prices-table th:last-child {\n    border-top-right-radius: 8px;\n  }\n}\n\n.service-pricing-wrap {\n  .pricing-table {\n    border-bottom-left-radius: 8px !important;\n    border-bottom-right-radius: 8px !important;\n    .tr {\n      border-bottom: none !important;\n    }\n  }\n  .pricing-table {\n    .variable-child {\n      padding: 0 23px !important;\n      border-bottom-left-radius: 8px !important;\n      border-bottom-right-radius: 8px !important;\n    }\n  }\n  .add-new {\n    background: white;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    padding-left: 10px;\n    cursor: pointer;\n    .add-icon {\n      color: #ffd705 !important;\n    }\n\n    .add-icon + span {\n      color: #ffd705;\n      font-size: 11px;\n    }\n  }\n}\n\n.service-cost-wrap {\n  .table {\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n\n    .duration-cell {\n      width: 140px;\n    }\n\n    .price-cell {\n      width: 120px;\n      padding-left: 13px;\n      path {\n        fill: #b1b4b7 !important;\n      }\n    }\n  }\n  .add-service-table {\n    color: #ffd705;\n  }\n\n  thead {\n    tr th:first-child {\n      border-top-left-radius: 8px;\n    }\n    tr th:last-child {\n      border-top-right-radius: 8px;\n    }\n  }\n}\n\n.service-settings {\n  .color-card {\n    background: white;\n\n    .color-wrap {\n      position: relative;\n      .color-picker {\n        position: absolute;\n        left: 0;\n      }\n    }\n\n    ul {\n      padding: 0;\n      margin: 0;\n      .color-list {\n        font-size: 12px;\n        position: relative;\n        .color-picker {\n          position: absolute;\n          z-index: 1;\n          right: 34px;\n        }\n\n        .color-circle {\n          height: 25px;\n          width: 25px;\n          border-radius: 100%;\n          border: 1px solid black;\n        }\n      }\n    }\n  }\n}\n\n.cost-offcanvas {\n  .table-cell {\n    border-top-left-radius: 8px !important;\n  }\n  .price-cell {\n    border-top-right-radius: 8px !important;\n  }\n  thead {\n    border-top-right-radius: 8px;\n    border-top-left-radius: 8px;\n  }\n  tbody {\n    tr {\n      .price-cell {\n        path {\n          fill: #b1b4b7 !important;\n        }\n      }\n    }\n  }\n}\n\n// dynamic table\n\n.css-13i4rnv-MuiGrid-root {\n  border: 1px solid #dcdcdc;\n  border-radius: 8px;\n}\n\n.dynamic-table-main-grid {\n  border: 1px solid #dcdcdc !important;\n  border-radius: 8px !important;\n}\n\n.dynamic-table-wrapper {\n  background: white;\n  height: 100%;\n}\n\n.dynamic-table {\n  table-layout: fixed;\n  width: 100%;\n  border-radius: 8px;\n  thead {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 999 !important;\n\n    .col1-th-sticky {\n      background: #fbfbfb;\n      width: 45px;\n      border-bottom: 1px solid #efefef;\n      position: sticky;\n      left: 0;\n      top: 0;\n      padding: 8px 0;\n    }\n\n    .col1-th-sticky::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      border-top: 5px solid #f5bf00;\n      border-top-left-radius: 8px;\n    }\n\n    .th-sticky {\n      padding: 8px 0;\n    }\n\n    .th-sticky::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      border-top: 5px solid #f5bf00;\n    }\n\n    th {\n      border-right: 1px solid #efefef;\n      color: #9f9e9e;\n      font-size: 14px;\n      text-transform: capitalize;\n      font-weight: 400;\n      cursor: default;\n    }\n\n    tr {\n      th:first-child {\n        border-top-left-radius: 8px;\n      }\n      th:last-child {\n        border-top-right-radius: 8px;\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      td {\n        background: white;\n        color: #434343;\n        font-size: 14px;\n        cursor: default;\n      }\n\n      .col1-td {\n        width: 45px;\n        text-align: center;\n        border-bottom: 1px solid #efefef;\n        position: sticky;\n        left: 0;\n        padding: 10px 0;\n      }\n\n      .td-dynamic {\n        border: 1px solid #efefef;\n        padding: 10px 0;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .table-th-bg {\n    background: #fbfbfb;\n  }\n\n  .col1-rec {\n    border: 1px solid #b2b2b2;\n    padding: 0 3.6px;\n    height: 16px;\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n  }\n\n  .col1-plus {\n    color: #b2b2b2;\n    font-size: 8px;\n    margin-left: 2px;\n  }\n}\n",".service_header {\n  height: 60px;\n  background-color: white;\n  border-bottom: 1px solid lightgray;\n}\n\n.service_header_mobile {\n  height: 60px;\n  background-color: white;\n}\n\n.tab_menu {\n  width: auto;\n}\n\n.tab_menu button {\n  background-color: transparent;\n  border: none !important;\n  color: gray;\n  font-size: 14px;\n  border-radius: 5px !important;\n}\n\n.tab_menu button:hover {\n  background-color: #f5bf00 !important;\n  color: white;\n}\n\n.tab_menu_mobile {\n  margin-bottom: 20px;\n  border-bottom: 1px solid lightgray !important;\n  border-radius: 0px !important;\n}\n\n.tab_menu_mobile button {\n  border-radius: 0px;\n}\n\n.tab_menu_mobile button {\n  font-size: 11px;\n  padding: 4px 8px;\n}\n\n.active_tab_mobile {\n  background-color: transparent;\n  border-bottom: 2px solid #f5bf00 !important;\n  color: #f5bf00 !important;\n  font-size: 14px;\n}\n\n.search_btn,\n.filter_btn {\n  height: 35px;\n  font-size: 14px !important;\n  background-color: lightgray !important;\n}\n\n.search_btn:hover,\n.filter_btn:hover {\n  color: rgb(53, 52, 52) !important;\n}\n\n// .form-check-input[type=\"checkbox\"] {\n//    border: 1px solid lightgray !important;\n// }\n\n// .form-check-input[type=\"checkbox\"]:checked {\n//    background-color: #f5bf00 !important;\n//    border: none !important;\n//    box-shadow: none !important;\n//    outline: none !important;\n// }\n\n.form-check-input2[type=\"checkbox\"] {\n  border: 1px solid lightgray !important;\n}\n\n.checkbox_btn2[type=\"checkbox\"] {\n  // margin-top: -4px;\n  // margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n.form-check-input2[type=\"checkbox\"]:checked {\n  background-color: #5599ff !important;\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.theme_btn_color {\n  background-color: #f5bf00 !important;\n  color: white !important;\n  border: none !important;\n}\n\n.theme_icon_color {\n  color: #f5bf00 !important;\n}\n\n.small_btn {\n  height: 30px !important;\n  font-size: 12px !important;\n  background-color: #f5bf00 !important;\n  color: white !important;\n  border-radius: 5px !important;\n}\n\n// button {\n//    border: none !important;\n//    outline: none !important;\n//    box-shadow: none !important;\n// }\n\n.inventory_service {\n  max-height: 92vh !important;\n  overflow-y: scroll !important;\n  padding-bottom: 100px !important;\n}\n\n.checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n// yelllow theme checkbox\n\n.blue_theme_checkbox .form-check-input[type=\"checkbox\"]:checked {\n  background-color: #548dff !important;\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.MuiPagination-ul {\n  margin-left: 45px !important;\n  display: flex !important;\n  margin-top: 20px !important;\n}\n\nbutton[aria-label=\"Go to previous page\"] {\n  margin-left: -120px !important;\n}\n\n.MuiPagination-ul li:last-child {\n  order: -1 !important;\n  margin-right: 45px !important;\n}\n\n.css-lqq3n7-MuiButtonBase-root-MuiPaginationItem-root.Mui-disabled {\n  opacity: 1 !important;\n}\n\n.css-9nek4c-MuiPagination-root\n  .css-lqq3n7-MuiButtonBase-root-MuiPaginationItem-root.Mui-selected {\n  color: #6a6a6a !important;\n}\n\n.css-g2z002-MuiSvgIcon-root-MuiPaginationItem-icon {\n  color: #ffd705 !important;\n}\n\n.items_per_page_select {\n  margin-top: 20px !important;\n}\n",".table-container {\n  // overflow: auto;\n  // max-width: 100%;\n  border-radius: 7px !important;\n  //   box-shadow: 3px 5px 0px #c6c5c5 !important;\n  // overflow: scroll !important;\n}\n\n.sticky_header {\n  position: sticky;\n  left: 0;\n}\n\n.sticky_row {\n  position: sticky;\n  bottom: 0;\n  z-index: 4;\n  margin: 0;\n  padding: 0;\n}\n\n.sticky_row td {\n  margin: 0 !important;\n  padding: 7px !important;\n  //  vertical-align: middle !important;\n}\n\n.sticky_row input,\n.sticky_row select {\n  background-color: #f5f5f5;\n  color: black;\n  height: 35px;\n  width: 100%;\n}\n\n.hide_scrollbar::-webkit-scrollbar,\n.inv_list_container::-webkit-scrollbar,\n.price_list_container::-webkit-scrollbar,\n.group_list_container::-webkit-scrollbar,\n.packages_table_container::-webkit-scrollbar,\n.gp_pkg_list_container::-webkit-scrollbar,\n.package_list_container::-webkit-scrollbar,\n.package_list_container_mobile::-webkit-scrollbar,\n.form_main_container::-webkit-scrollbar {\n  display: none !important;\n}\n\n.form_main_container {\n  max-height: 95vh;\n  overflow: scroll;\n  padding-bottom: 100px;\n}\n\n.table {\n  table-layout: fixed;\n  border-collapse: collapse;\n  background-color: white;\n  border-top-left-radius: 9px !important;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ccc;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n  vertical-align: middle;\n}\n\n#table_form_row td,\n#table_form_row td,\n#table_form_row td input,\n#table_form_row td select {\n  font-weight: bold !important;\n  color: gray !important;\n  background-color: rgb(252, 250, 250);\n}\n\n.list_wrapper {\n  padding: 20px;\n  font-size: 14px;\n}\n\n.list_wrapper .row:hover {\n  background-color: #f8fafc;\n}\n\n.list_wrapper .row .col,\n.list_wrapper .row .check_col {\n  border-bottom: 1px solid #e7e8ea;\n  background-color: transparent;\n  color: gray;\n}\n\n.switch_btn_div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/*List style for PC */\n\n.table_main_list thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table_main_list th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -12px;\n  z-index: 4;\n}\n\n.table_main_list th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 58px;\n  z-index: 4;\n  cursor: pointer;\n}\n\n.table_main_list td:nth-child(1) {\n  position: sticky;\n  left: -12px;\n  z-index: 2;\n}\n\n.table_main_list td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.table_main_list td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.table_main_list #sticky_col0 {\n  position: sticky;\n  left: 58px;\n  z-index: 2;\n}\n\n.table_main_list th:last-child {\n  width: 60px;\n}\n\n.table_main_list th,\n.table_main_list td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* List style for Mobile */\n.table_main_list_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.table_main_list_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.table_main_list_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.table_main_list_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.table_main_list_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.table_main_list_mobile th:last-child,\n.table_main_list_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  //  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.table_main_list_mobile th,\n.table_main_list_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Inventory Services List style for PC */\n\n.inv_list_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.inv_list_container th:nth-child(1) {\n  width: 60px;\n  border-top: 7px solid #ff9669;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.inv_list_container th:nth-child(2) {\n  width: 250px !important;\n  border-top: 7px solid #ff9669;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.inv_list_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.inv_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.inv_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.inv_list_container #sticky_col0 {\n  //  position: sticky;\n  left: 0px;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.inv_list_container #sticky_col0:hover {\n  color: #f5bf00 !important;\n}\n\n.inv_list_container th:last-child {\n  width: 60px;\n}\n\n.inv_list_container th,\n.inv_list_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Inventory Services List style for Mobile */\n.inv_list_container_mobile thead {\n  //  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.inv_list_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.inv_list_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.inv_list_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.inv_list_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.inv_list_container_mobile #sticky_col0:hover {\n  color: #f5bf00 !important;\n}\n\n.inv_list_container_mobile th:last-child,\n.inv_list_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.inv_list_container_mobile th,\n.inv_list_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Pricing Form style for PC */\n.pricing_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_form_container th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.pricing_form_container th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.pricing_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.pricing_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.pricing_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.pricing_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.pricing_form_container th:last-child {\n  width: 60px;\n}\n\n.pricing_form_container th,\n.pricing_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Pricing form style for Mobile */\n.pricing_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.pricing_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.pricing_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.pricing_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.pricing_form_container_mobile th:last-child,\n.pricing_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.pricing_form_container_mobile th,\n.pricing_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Pricing list style for PC */\n.pricing_list_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_list_container th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.pricing_list_container th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.pricing_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.pricing_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.pricing_list_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.pricing_list_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.pricing_list_container th:last-child {\n  width: 60px;\n}\n\n.pricing_list_container th,\n.pricing_list_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Pricing list style for Mobile */\n.pricing_list_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.pricing_list_container_mobile th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: -2px; */\n}\n\n.pricing_list_container_mobile th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: 67px; */\n}\n\n.pricing_list_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.pricing_list_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.pricing_list_container_mobile th:last-child,\n.pricing_list_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.pricing_list_container_mobile th,\n.pricing_list_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Cost Form style for PC */\n.cost_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.cost_form_container th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.cost_form_container th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.cost_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.cost_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.cost_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.cost_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.cost_form_container th:last-child {\n  width: 60px;\n}\n\n.cost_form_container th,\n.cost_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Cost form style for Mobile */\n.cost_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.cost_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.cost_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.cost_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.cost_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.cost_form_container_mobile th:last-child,\n.cost_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.cost_form_container_mobile th,\n.cost_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Attribute Form style for PC */\n.attribute_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.attribute_form_container th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.attribute_form_container th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.attribute_form_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.attribute_form_container\n  td:nth-child(1)\n  .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.attribute_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.attribute_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.attribute_form_container th:last-child {\n  width: 60px;\n}\n\n.attribute_form_container th,\n.attribute_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Attribute form style for Mobile */\n.attribute_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.attribute_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: -2px; */\n}\n\n.attribute_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  border-top: 7px solid #f5bf00;\n  /* position: sticky;\n    left: 67px; */\n}\n\n.attribute_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.attribute_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.attribute_form_container_mobile th:last-child,\n.attribute_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.attribute_form_container_mobile th,\n.attribute_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Package Form style for PC */\n.package_list_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.package_list_container th:nth-child(1) {\n  width: 70px;\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.package_list_container th:nth-child(2) {\n  width: 250px;\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.package_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"] {\n  margin-top: -4px;\n  margin-left: -20px;\n  height: 18px;\n  width: 18px;\n}\n\n.package_list_container td:nth-child(1) .checkbox_btn[type=\"checkbox\"]:checked {\n  background-color: #f5bf00 !important;\n}\n\n.package_list_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.package_list_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.package_list_container th:last-child {\n  width: 60px;\n}\n\n.package_list_container th,\n.package_list_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Package form style for Mobile */\n.package_list_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.package_list_container_mobile th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: -2px; */\n}\n\n.package_list_container_mobile th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: 67px; */\n}\n\n.package_list_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.package_list_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.package_list_container_mobile th:last-child,\n.package_list_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.package_list_container_mobile th,\n.package_list_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Group Form style for PC */\n.group_form_container thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.group_form_container th:nth-child(1) {\n  width: 35px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: -2px;\n  z-index: 4;\n}\n\n.group_form_container th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  position: sticky;\n  left: 67px;\n  z-index: 4;\n}\n\n.group_form_container td:nth-child(1) {\n  position: sticky;\n  left: -2px;\n  z-index: 2;\n}\n\n.group_form_container #sticky_col0 {\n  position: sticky;\n  left: 67px;\n  z-index: 2;\n}\n\n.group_form_container th:last-child {\n  width: 35px !important;\n}\n\n.group_form_container th,\n.group_form_container td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/*  Cost form style for Mobile */\n.group_form_container_mobile thead {\n  position: sticky;\n  top: -4px;\n  z-index: 3;\n  background-color: white;\n}\n\n.group_form_container_mobile th:nth-child(1) {\n  width: 70px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: -2px; */\n}\n\n.group_form_container_mobile th:nth-child(2) {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00; */\n  /* position: sticky;\n    left: 67px; */\n}\n\n.group_form_container_mobile td:nth-child(1) {\n  /* position: sticky;;\n    left: -2px;\n    z-index: 2; */\n}\n\n.group_form_container_mobile #sticky_col0 {\n  /* position: sticky;\n    left: 67px;\n    z-index: 2; */\n}\n\n.group_form_container_mobile th:last-child,\n.group_form_container_mobile td:last-child {\n  width: 60px;\n  position: sticky;\n  right: -2px;\n  background-color: rgb(245, 241, 241);\n}\n\n.group_form_container_mobile th,\n.group_form_container_mobile td {\n  width: 120px;\n  font-size: 12px;\n  color: gray !important;\n}\n\n/* Create Service */\n.create_service {\n  height: 100vh;\n  overflow-y: scroll;\n  padding-bottom: 180px;\n  width: 100%;\n}\n\n.detail_form input,\n.detail_form select {\n  border: none;\n  font-size: 14px;\n}\n\n.detail_form input:focus,\n.detail_form select:focus {\n  box-shadow: none;\n  outline: none;\n  border: none;\n}\n\n.detail_form input,\n.detail_form select {\n  border: none;\n  font-size: 14px;\n}\n\n.detail_form input:focus,\n.detail_form select:focus {\n  box-shadow: none;\n  outline: none;\n  border: none;\n}\n\n.create_form_row input {\n  border-left: none;\n  border-top: none;\n  border-right: none;\n  border-bottom: 2px solid white;\n  border-radius: 0px;\n  font-size: 14px;\n  color: gray;\n}\n\n.create_form_row input:focus {\n  box-shadow: none;\n  font-size: 14px;\n  border-bottom: 2px solid #f5bf00;\n}\n\n.create_form_row .input_wrapper input,\n.create_form_row .input_wrapper textarea {\n  border-left: none;\n  border-top: none;\n  border-right: none;\n  border-bottom: 2px solid white !important;\n  border-radius: 0px;\n  font-size: 14px;\n  color: gray;\n}\n\n.create_form_row .input_wrapper input:focus,\n.create_form_row .input_wrapper textarea:focus {\n  border-bottom: 2px solid #f5bf00 !important;\n}\n\n.add-btn {\n  margin-left: 10px;\n  border-radius: 20px;\n  background-color: transparent;\n}\n\n.addcol_btn_th {\n  text-align: center;\n  width: 40 !important;\n}\n\n.delete-btn {\n  padding: 2px 5px;\n  margin-left: 5px;\n  background-color: #f44336;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n}\n\n.add-row-btn {\n  margin-top: 10px;\n}\n\n.delete-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\ntd input,\ntd select {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n}\n\n.tbl_footer_main {\n  border-radius: 8px;\n  opacity: 1;\n  padding: 0;\n}\n\n.small_col {\n  width: 70px !important;\n}\n\n.gp_package_list_container #sticky_cell_top_border {\n  width: 70px !important;\n  /* border-top: 7px solid #f5bf00 !important; */\n  position: sticky !important;\n  left: 0px !important;\n}\n\n.gp_package_list_container #sticky_col1 {\n  width: 250px;\n  /* border-top: 7px solid #f5bf00 !important; */\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.group_list_container #sticky_cell_top_border {\n  width: 40px;\n  position: sticky !important;\n  left: 0px !important;\n}\n\n.group_list_container #sticky_col1 {\n  width: 250px;\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.price_list_container #sticky_cell_top_border {\n  width: 70px;\n  position: sticky !important;\n  left: 0px !important;\n}\n\n.price_list_container #sticky_col1 {\n  width: 250px;\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.disable_area {\n  pointer-events: none;\n  background-color: rgb(251, 248, 248) !important;\n}\n\n.pricing_table thead {\n  position: sticky;\n  background-color: white;\n}\n\n.pricing_table thead th:first-child {\n  width: 70px;\n  border-top: 7px solid #f5bf00 !important;\n  position: sticky !important;\n  left: 0 !important;\n}\n\n.pricing_table thead th:nth-child(2) {\n  width: 200px;\n  border-top: 7px solid #f5bf00 !important;\n  position: sticky !important;\n  left: 70px !important;\n}\n\n.pricing_table tbody td:first-child {\n  position: sticky !important;\n  left: 0 !important;\n}\n\n.pricing_table thead {\n  z-index: 9999 !important;\n}\n\n.pricing_table tbody {\n  position: relative;\n  z-index: 999;\n}\n\n.media_menu_listing {\n  font-size: 11px;\n  color: rgb(158, 158, 158);\n}\n\n/* Responsive Style */\n.pc_display {\n  display: block !important;\n}\n\n.mobile_display {\n  display: none !important;\n}\n\n.dragging-row {\n  background-color: rgb(168, 77, 77) !important;\n  cursor: move !important;\n  color: blue !important;\n}\n\n.table {\n  width: auto;\n  table-layout: fixed;\n  border-collapse: collapse;\n  background-color: white;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ccc;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.dragging-row {\n  border: 2px dotted #f5bf00 !important;\n  background-color: transparent !important;\n  cursor: move;\n  background-color: #a48204 !important;\n  color: white !important;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.dragging-row td:nth-child(1) {\n  background-color: lightgray !important;\n}\n\n.dragtr {\n  cursor: move;\n}\n\n.over {\n  border: 2px dotted #f5bf00 !important;\n  opacity: 1 !important;\n  background-color: #a48204 !important;\n}\n\n.hb {\n  background-color: black !important;\n}\n\n.css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root.Mui-focused\n  .MuiOutlinedInput-notchedOutline {\n  //  border-color: #f5bf00 !important;\n  border: none;\n  //  border-width: 2px\n}\n\n.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  //  border-color: #f5bf00 !important;\n  border: none;\n\n  //  border-width: 2px\n}\n\n.selected_service_list {\n  background-color: white;\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  padding: 10px;\n  color: gray;\n  font-size: 90%;\n}\n\n.selected_service_list .selected_row {\n  cursor: pointer;\n  border-bottom: 1px solid lightgray;\n}\n\n.selected_service_list .selected_row:hover {\n  background-color: rgb(252, 253, 252);\n}\n\n.add_service_btn {\n  background-color: white;\n  border: 1px solid lightgray !important;\n  color: gray;\n  border-radius: 8px;\n  font-size: 80%;\n  height: 35px;\n}\n\n.add_service_btn .addbox_icon {\n  color: #f5bf00 !important;\n  height: auto !important;\n}\n\n.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-outlined {\n  color: gray;\n  /* Replace 'red' with your desired label color */\n}\n\n/* Contact US Form */\n.contact {\n  max-height: 100vh;\n  overflow: scroll;\n  padding-bottom: 100px;\n}\n\n.contact p {\n  font-size: 13px;\n}\n\n.contact input,\n.contact label,\n.contact textarea {\n  font-size: 12px;\n}\n\n.contact textarea {\n  border-radius: 0px !important;\n  border: none;\n}\n\n.contact textarea:focus {\n  box-shadow: none;\n}\n\n.contact_row .contact_sec1 {\n  padding-top: 50px;\n}\n\n.contact_row .contact_sec2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact_row .text_line {\n  height: 5px;\n  width: auto;\n  margin-top: -25px;\n}\n\n.contact_row .input_wrapper {\n  overflow: hidden;\n}\n\n.textarea_wrapper {\n  border: 1px solid lightgray;\n  width: 100%;\n  background-color: white;\n}\n\n.textarea_wrapper label {\n  padding-left: 10px;\n  font-size: 12px;\n  color: gray;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.contact_row .contact_btn {\n  width: 40%;\n  font-size: 12px;\n  background-color: #6188fe;\n}\n\n.media_links .media_gp {\n  border-radius: 12px;\n  color: white;\n  font-size: 12px;\n  background-color: #6188fe;\n}\n\n.media_links {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.media_links .icon_name {\n  font-size: 10px;\n  margin-top: 4px;\n  margin-left: 3px;\n}\n\n.list_publish_btn {\n  font-size: 10px !important;\n}\n\n/* Create category Form*/\n\n.cat_textarea_wrapper {\n  border-radius: 8px;\n  border: 1px solid lightgray;\n  width: 100%;\n  background-color: white;\n}\n\n.cat_textarea_wrapper label {\n  padding-left: 10px;\n  font-size: 12px;\n  color: gray;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.create_form_row textarea {\n  border: none;\n}\n\n.create_form_row textarea:focus {\n  box-shadow: none;\n}\n\n.create_category {\n  height: 85vh;\n}\n\n.create_category .fixed_btn_gp {\n  position: absolute;\n  right: 5%;\n  bottom: 5%;\n}\n\n.fixed_btn_gp .cancel_btn {\n  color: gray !important;\n  background-color: #edf0f5 !important;\n}\n\n.category_form input,\n.category_form textarea,\n.category_form select {\n  font-size: 12px !important;\n}\n\n/* Sub category Form */\n.create_scategory {\n  height: 85vh;\n}\n\n.create_scategory .fixed_btn_gp {\n  position: absolute;\n  right: 5%;\n  bottom: 5%;\n}\n\n.scategory_form input,\n.scategory_form textarea,\n.scategory_form select {\n  font-size: 12px !important;\n}\n\n.switch_input_wrapper {\n  border: 1px solid lightgray;\n  border-radius: 8px;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n}\n\n.detail_view_img {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 75px;\n  width: 75px;\n  border-radius: 50px;\n  border: 1px solid lightgray;\n}\n\n.detail_view_img img {\n  height: 75px;\n  width: 75px;\n  border-radius: 50px;\n  border: 1px solid lightgray;\n  object-fit: cover;\n}\n\n.detail_view_img .img_upload_label {\n  position: absolute;\n  right: 0;\n  bottom: -5px;\n  padding: 2px;\n  border-radius: 50px;\n  background-color: #f5bf00;\n}\n\n.add_attrib_value {\n  background-color: azure !important;\n}\n\n.select_business {\n  // font-size: 12px;\n  color: gray !important;\n}\n\n.enable_validation {\n  border: 2px solid red !important;\n  background-color: rgb(253, 244, 246) !important;\n  border-radius: 4px;\n}\n\n//  .Mui-selected {\n//      background-color: transparent !important;\n//      color: black !important;\n//  }\n\n.items_per_page_select {\n  border: 1px solid #aeaeae;\n  padding: 3px 5px 3px 5px;\n  width: 29px;\n  -webkit-appearance: none;\n  text-align: center;\n  border-radius: 6px;\n  color: #f5bf00 !important;\n  font-size: 14px;\n}\n.items_per_page_select::-webkit-appearance {\n  display: none;\n}\n.per-page-text {\n  font-size: 16px;\n  color: #969696;\n}\n\n.items_per_page_select:focus {\n  border: none;\n  outline: none;\n}\n\n.items_per_page_select option:hover {\n  background-color: #f5bf00 !important;\n  color: white !important;\n}\n\n.column_main_wrapper {\n  max-height: 70vh;\n  overflow-y: scroll;\n}\n\n.col_btn_div {\n  height: 60px;\n  width: 300px;\n}\n\n.col_btn_div button {\n  border: 2px solid #f5bf00 !important;\n}\n\n.col_btn_div button:hover {\n  background-color: #facf35;\n  border: 2px solid #facf35 !important;\n}\n\n.list_col_container {\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  height: 95vh;\n  padding-bottom: 100px;\n}\n\n.selectedColumn {\n  background-color: #f5bf00;\n}\n\n.col_blue_btn_div {\n  height: 60px;\n  width: 300px;\n}\n\n.selectedColumnBlue {\n  background-color: #548dff;\n}\n\n.col_blue_btn_div button {\n  border: 2px solid #548dff !important;\n}\n\n.col_blue_btn_div button:hover {\n  background-color: #548dff;\n}\n\n.add_blue_btn {\n  background-color: white;\n  border: 1px solid lightgray !important;\n  color: gray;\n  border-radius: 8px;\n  font-size: 80%;\n  height: 35px;\n}\n\n.add_blue_btn .addbox_blue_icon {\n  color: #548dff !important;\n  height: auto !important;\n}\n\n.add_yellow_btn {\n  background-color: white;\n  border: 1px solid lightgray !important;\n  color: gray;\n  border-radius: 8px;\n  font-size: 80%;\n  height: 35px;\n}\n\n.add_yellow_btn .addbox_yellow_icon {\n  color: #f5bf00 !important;\n  height: auto !important;\n}\n\n.selectedColumnyellow {\n  background-color: #f5bf00;\n}\n\n.scrollable_col_list {\n  display: flex;\n  list-style: none;\n  max-width: 88vw;\n  overflow-x: scroll;\n  border: 2px dotted #f5bf00;\n  height: 40px;\n  width: 100%;\n}\n\n.scrollable_col_list::-webkit-scrollbar {\n  display: none;\n}\n\n.scrollable_div {\n  padding-left: 60px !important;\n  padding-right: 60px !important;\n}\n\n@media screen and (max-width: 576px) {\n  .pc_display {\n    display: none !important;\n  }\n\n  .mobile_display {\n    display: block !important;\n  }\n\n  .service_header_mobile p {\n    font-size: 12px;\n    margin-top: -10px;\n  }\n\n  .service_header_mobile button {\n    font-size: 12px !important;\n    padding: 2px 12px !important;\n  }\n}\n",".overflow_main_dashboard {\n  overflow-x: auto !important;\n  background-color: #f8fafc;\n}\n\n.link-active {\n  color: red;\n  background-color: #ffd705;\n}\n\n.link-active:hover {\n  color: white;\n  background-color: #ffd705;\n}\n\n.link-white {\n  color: #ffd705;\n}\n\n.link-white:hover {\n  color: #ffd705;\n}\n\n.background_nav1_header {\n  background-color: #548dff;\n  height: 2.5rem;\n}\n\n.margin_left_m3 {\n  margin-left: -60px;\n}\n\n.col6section {\n  color: white;\n}\n\n.background_sidenav_one {\n  background-color: rgb(248, 250, 252);\n  height: 96vh;\n  overflow: hidden !important;\n  padding-left: 2%;\n}\n\n.background_sidenav_two {\n  background-color: white;\n  padding-top: 5%;\n  padding-bottom: 5%;\n  border-radius: 6px;\n}\n\n.background_sidenav_two_t {\n  background-color: white;\n  padding-top: 3%;\n  padding-bottom: 3%;\n  border-radius: 6px;\n}\n\n@media (max-width: 1200px) {\n  .background_sidenav_one {\n    padding-left: 0;\n  }\n}\n",".calendar {\n  // display: flex;\n  // flex-direction: column;\n  // align-items: center;\n  font-family: sans-serif;\n  padding: 100px;\n\n  &-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 16px;\n    width: 100%;\n\n    h2 {\n      margin: 0;\n    }\n\n    button {\n      border: none;\n      background-color: white;\n      font-size: 16px;\n      cursor: pointer;\n    }\n  }\n\n  &-table {\n    border-collapse: collapse;\n    margin: 16px;\n\n    th {\n      border: 1px solid black;\n      padding: 8px;\n      text-align: center;\n    }\n\n    td {\n      border: none !important;\n      cursor: pointer;\n      display: flex;\n      justify-content: end;\n      align-items: end;\n      height: 100%;\n      color: black;\n      font-weight: bold;\n      font-size: 10pxß;\n      padding: 10px 10px;\n\n      &.selected {\n        background-color: #0074d9;\n        color: white;\n      }\n    }\n  }\n\n  table {\n    tbody {\n      tr {\n        td {\n          background-color: #fff;\n          border: 10px solid #EDF0F6\n          ;\n          // margin: 10px;\n          div {\n            cursor: pointer;\n            display: flex;\n            justify-content: end;\n            align-items: end;\n            height: 100%;\n            color: black;\n            font-weight: bold;\n            font-size: 12px;\n            padding: 10px 10px;\n          }\n        }\n      }\n    }\n  }\n  .tool-tip {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    margin-top: 20px;\n    border-radius: 25px;\n    background-color: #b5d5ff;\n    color: white;\n    font-size: 18px;\n    font-weight: bold;\n    text-transform: uppercase;\n    border: none;\n  }\n\n  .tool-tip:hover {\n    cursor: pointer;\n  }\n  tool-tip::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    border-radius: 50%;\n    background-color: #b5d5ff;\n    transform: scale(0);\n    transition: transform 0.2s;\n  }\n}",".overflow_main_dashboard {\n    overflow-x: auto !important;\n    background-color: #F8FAFC;\n}\n\n\n\n.link-active {\n    color: red;\n    background-color: #FFD705;\n\n}\n\n.link-active:hover {\n    color: white;\n    background-color: #FFD705;\n\n}\n\n.link-white {\n    color: #FFD705;\n}\n\n.link-white:hover {\n    color: #FFD705;\n\n}\n\n\n\n.height_fiz_menu_active {\n    height: 2%;\n    background-color: #FFD705;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    color: white;\n    margin-top: 10%;\n}\n\n.height_fiz_menu {\n    // margin-top: 10%;\n    color: #FFD705;\n    font-size: 100%;\n    margin-right: 10px;\n}\n.sidebar-title{\n  font-size: 12px;\n  // font-family: 'circular';\n  font-family: \"Roboto\";\n  margin: 2px 2px 2px 10px;\n  color:#5C5C5C\n  // opacity: 0;\n  // transition: opacity 0.3s;\n}\n\n.background_nav1_header {\n    background-color: #548DFF;\n}\n\n.side_nav_1_right {\n    width: 100%;\n    height:87.5vh;\n    overflow: auto;\n    \n}\n\n.margin_left_m3 {\n    margin-left: -60px;\n}\n\n.col6section {\n    color: white;\n}\n\n// .background_sidenav_one {\n//     background-color: #FBFCFF;\n//     height: 96vh;\n//     overflow-y: auto !important;\n// }\n\n.background_sidenav_two {\n    background-color: white;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    border-radius: 6px;\n}\n\n.background_sidenav_two_t {\n    background-color: white;\n    padding-top: 3%;\n    padding-bottom: 3%;\n    border-radius: 6px;\n}\n\n.height_fiz_menu a {\n    text-decoration: none !important;\n    color: #000 !important;\n}\n\n.inv_active_menu {\n    background-color: #FFD705 !important;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    color: black;\n    padding-left: 10px;\n\n}\n.inv_inactive_menu {\n\n  padding-left: 10px;\n\n}\n\n\n/* -------------------------------------------------------------------------- */\n/*                        Selected Business From Header                       */\n/* -------------------------------------------------------------------------- */\n\n.makeRelative {\n    position: relative;\n  }\n  \n  .marginFromSearch {\n    margin: \"4% 0 0 0\";\n  }\n  \n  .searchDivPadding {\n    padding: \"3.6% 0\";\n  }\n  \n  .searchDiv {\n    border: \"1px solid #59F\";\n    background-color: \"#FFFFFF\";\n    border-radius: \"0.375rem\";\n    margin: \"0 4.12% 0 4.12%\";\n    padding: \"0 0.188rem 0 0.75rem\";\n  }\n  \n  .searchInput {\n    border: \"none\";\n    font-size: \"0.625rem\";\n    color: \"#AAA\";\n    font-style: \"normal\";\n    font-weight: 400;\n    line-height: \"1.8rem\";\n  }\n  \n  .addBusinessButton {\n    border: \"1px solid #D9DEEC\";\n    border-radius: \"0.938rem\";\n    margin-top: \"2.6%\";\n    height: \"4.9%\";\n    padding: \"1.5rem 1.25rem \";\n  }\n  \n  .addBusinessButtonFont {\n    color: \"#000\";\n    font-size: \"1rem\";\n    font-style: \"normal\";\n    font-weight: 400;\n    line-height: \"1.8rem\";\n  }\n  \n  .absoluteToCross {\n    position: \"absolute\";\n    top: \"0\";\n    right: \"0\";\n    cursor: \"pointer\";\n  }\n  \n  .selectedBusinessIdFont {\n    color: \"#FFF\";\n    font-size: \"16px\";\n    font-style: \"normal\";\n    font-weight: 400;\n    line-height: \"normal\";\n  }\n  \n  .selectedBusinessNameFont {\n    color: \"#FFF\";\n    font-size: \"20px\";\n    font-style: \"normal\";\n    font-weight: 600;\n    line-height: \"normal\";\n  }\n  \n  .selectedBusinessBack {\n    height: \"9.6%\";\n    background-color: \"#5599FF\";\n    border-radius: \"0.938rem\";\n    display: \"flex\";\n    align-items: \"center\";\n  }\n  \n  .allBusiness {\n    height: \"89.5%\";\n    border: \"1px solid #5599FF\";\n    border-radius: \"0.938rem\";\n  }\n  \n  .buttonInHeader {\n    position: \"absolute\";\n    top: \"90%\";\n    right: \"-70%\";\n    z-index: 10000000000000;\n    height: \"95.8vh\";\n    // maxWidth: \"23%\",\n    width: \"26.3vw\";\n    overflow: \"auto\";\n    background-color: \"white\";\n    border-radius: 0;\n  }\n  \n  .businessNameFont {\n    color: \"#000\";\n    font-size: \"1.125rem\";\n    font-style: \"normal\";\n    font-weight: 500;\n    line-height: \"1.8rem\";\n  }\n  \n  .businessDesignationFont {\n    color: \"#838383\";\n    font-size: \"0.75rem\";\n    font-style: \"normal\";\n    font-weight: 400;\n    line-height: \"0.8rem\";\n  }\n  \n  .businessBack{\n      background-color: white;\n      margin-bottom: \"0.5rem\";\n            padding-top: \"0.5rem\";\n            padding-bottom: \"0.5rem\";\n            padding-right: \"1rem\";\n  }\n  \n  .selectedBusinessBackColor{\n      background-color: #E0EDFF !important;\n  }\n  \n\n","\n.border_bottom_header\n{\n    border-top: none !important;\n    border-left: none !important;\n    border-right: none !important;\n    border-bottom: 1px solid lightgray;\n    border-style: dashed;\n    background-color: white;\n}\n\n// .img_width\n// {\n//     width: 80%;\n// }\n\n.font_header_admin\n{\n    font-size: 80%;\n    font-weight: 800;\n}\n\n\n.font_header_admin1\n{\n    font-size: 80%;\n    font-weight: 800;\n    color: #0575E6 !important;\n}\n\n.button_profile\n{\n    background-color: #EDECFF;\n    color: #3E50F7;\n    border-color: #EDECFF;\n}\n\n.dropdown_style\n{\n    box-shadow: 1px 1px 7px 7px rgba(211, 211, 211, 0.263);\n    border-radius: 10px;\n    border: 1px dashed #0575E6;\n}\n\n.btn_style_dash\n{\n    border: 1px dashed #0575E6 !important;\n}\n\n.btn_style_dash:hover\n{\n    border: 1px dashed #0575E6 !important;\n    color: #0575E6 !important;\n}\n\n.btn_style_dash:focus\n{\n    border: 1px dashed #0575E6 !important;\n    color: #0575E6 !important;\n}\n\n\n\n@media screen and (max-width: 980px) \n{\n\n    .img_width\n{\n    width: 30%;\n}\n\n\n  }",".dropdow{\n    /* bottom: 36.03%; */\n   color: #FF9669;\n }\n .img, svg {\n    vertical-align: none;\n}\n.name{\n    font-family: 'Roboto';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 16px;\nline-height: 29px;\n/* identical to box height, or 180% */\n\ntext-align: center;\n\ncolor: #6B6B6B;\n}\n.check{\n    width: 40px;\n}\n.delete{\n    width:12px;\n}\n.greater{\n     width: 1%;\n     font-Size: 25px;\n}\n.gent{\n    width: 145px;\n}\n.namestyle{\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 16px;\nline-height: 29px;\ncolor: #A4A4A4;\nflex: none;\norder: 0;\nflex-grow: 0;\n}\n.table{\n    max-width: 100%;\nbackground: #FFFFFF;\nborder: 0 solid #DCDCDC;\nbox-shadow: 0px 6px 10px rgba(0, 0, 0, 0.02);\nborder-radius: 6px 0px 0px 0px;\n}",".selected-service-amount{\n    color: #4D4D4D;\n    text-align: center;\n    font-family: \"Roboto\";\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500,\n}\n\n.selected-services{\n    color: #443F3F;\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400,\n}\n\n.portal-heading{\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    text-align: left;\n    color: #8E8E8E;\n}\n\n.portal-card-add-booking{\n    cursor: pointer;\n    border-radius: 10px;\n    border: 0.5px solid rgb(220, 220, 220);\n    background-color: white;\n    padding: 18px 38px !important;\n    gap: 15px;\n    width: 100px;\n    box-shadow: 0px 5px 9px 0px rgba(176, 176, 176, 0.25);\n}\n\n.payment-choice-bottom-arrow:after {\n    content:'';\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 0;\n    height: 0;\n    border-top: 10px solid #FFD705;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n}\n\n.pos-relative{\n    position: relative;\n}\n\n.payment-for-customer-heading{\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n    color: #FFD705;\n}\n\n.add-booking-custom-dropdown-header{\n    border-radius: 6px;\n    border: 1px solid #D7D7D7;\n    background: #FFF;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0;\n    cursor: pointer;\n    height: 40px;\n}\n\n\n\n@media (max-width: \"799px\") {\n   .column-state{\n    margin-bottom: 1em;\n   }\n  }\n","@import \"./App.scss\";\n@import \"./mediaQueries.scss\";\n@import \"./AddBookings.scss\";\n\n.wrapper {\n  height: 100vh !important;\n  padding-left: 5%;\n}\n.card {\n  width: 100% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 8px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  padding: 10px !important;\n  // box-shadow: 0px 0px 0px #c6c5c5 !important;\n  border: 0.5px solid #dcdcdc;\n}\n.card-mobile {\n  width: 100% !important;\n  min-width: 100px;\n  padding: 9px !important;\n  height: max-content !important;\n  border-radius: 8px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  // box-shadow: 0px 0px 0px #c6c5c5 !important;\n  border: 0.5px solid #dcdcdc;\n}\n.card_selector {\n  width: 100% !important;\n  padding: 20px !important;\n  height: 50px;\n  border-radius: 8px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  padding: 4px 10px 20px 3px !important;\n  border: 0.5px solid #dcdcdc;\n}\n.card-grey-provider {\n  width: 70% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 9px 0px 0px 9px !important;\n  color: #AFAFAF !important;\n  background-color: #F8FAFC !important;\n  padding: 5px !important;\n}\n.provider-content{\n  position: fixed;\n  top: \"50%\";\n  left: \"50%\";\n  transform: \"translate(-50%, -50%)\";\n  background-color: \"white\",;\n  box-shadow: \"rgb(0 0 0 / 58%) 0px 4px 16px\";\n  padding: \"1rem\";\n  border-radius: \"8px\";\n  z-index: \"999\",\n}\n.card2 {\n  width: 100% !important;\n  height: max-content !important;\n  border-radius: 20px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  padding: 2px !important;\n  // box-shadow: 0px 0px 0px #c6c5c5 !important;\n  border: 0.5px solid #dcdcdc;\n}\n.schedular-button {\n  background-color: #337ab7;\n  padding: 10px;\n  border-radius: 10px;\n  color: white;\n}\n.chat-card {\n  width: 93% !important;\n  padding: 6px !important;\n\n  height: max-content !important;\n  // border-radius: 8px !important;\n  border-bottom: 1px solid #c4c4c4;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  // padding: 10px !important;\n}\n.card_mobile {\n  width: 100% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 20px !important;\n  color: black !important;\n  background-color:#f4f7fc  !important;\n  padding: 10px !important;\n  // box-shadow: 0px 0px 0px #c6c5c5 !important;\n  border:0.5px solid #DCDCDC\n}\n\n.card-text {\n  width:48%;\n  min-width: 550px;\n  max-width: auto;\n  height: max-content !important;\n  border-radius: 8px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  padding: 3px !important;\n  border: 0.5px solid #dcdcdc;\n}\n.card-text-mobile {\n  width:10%;\n  min-width: 130px;\n  height: max-content !important;\n  border-radius: 5px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  border: 0.5px solid #dcdcdc;\n  // box-shadow: 0 2px 2px -2px rgb(169, 169, 169);\n\n}\n\n.schedule_text{\n  color: #000;\nfont-family: Roboto;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\n}\n\n.schedule_text2{\n  color: #838383;\nfont-family: Roboto;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 16px;\n}\n.schedule_text_mobile{\n  color: #000;\nfont-family: Roboto;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 700;\nline-height: normal;\n}\n.upload {\n  width: 70;\n  height: 15;\n  padding:2px 8px 2px 8px;\n  background-color: #548DFF;\n  // border: 1px solid #DCDCDC;\n  border-radius: 8px;\n  // border-color: #DCDCDC;\n  font-size: 12px;\n  color: #ffffff;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.3s, color 0.3s, border-color 0.3s;\n}\n.subtype {\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 15px;\n  color: #a9a9a9;\n}\n.product-name {\n  font-family:\"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 19px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n.version{\n  font-family:\"Roboto\", sans-serif;\nfont-size: 14px;\nfont-weight: 500;\nline-height: 16px;\nletter-spacing: 0em;\ntext-align: left;\ncolor: #B5B6BA;\n\n}\n.subtype2 {\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15px;\n  letter-spacing: 0em;\n  text-align: left;\n  color: #b5b6ba;\n}\n.card-black {\n  width: 100% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 9px !important;\n  color: black !important;\n  background-color: #d9d9d9 !important;\n  padding: 10px !important;\n}\n.card-grey {\n  width: 100% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 9px !important;\n  color: #AFAFAF !important;\n  background-color: #F1F6FE !important;\n  padding: 5px !important;\n}\n.card-blue {\n  width: 100% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 9px !important;\n  color: white !important;\n  background-color: #548DFF !important;\n  padding: 10px !important;\n}\n\n.spanText {\n  font-size: 14;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0em;\n  text-align: left;\n  \n}\n// .card-header {\n//   display: flex;\n//   flex-direction: row;\n//   justify-content: space-between;\n//   align-items: center;\n// }\n\n.scroll {\n  height: 100vh;\n}\n.arrows {\n  display: flex;\n  // justify-content: space-between;\n  flex-direction: row;\n  padding: 40px;\n  height: 100%;\n  overflow: hidden;\n}\n.form {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: auto;\n}\n.add {\n  display: flex;\n  align-content: space-between;\n  justify-content: center;\n  align-items: baseline;\n  justify-items: stretch;\n  flex-direction: row;\n}\n.content {\n  display: flex;\n  align-content: center;\n  justify-content: flex-start;\n  align-items: stretch;\n  margin-bottom: 20px;\n}\n.text {\n  font-size: medium;\n  font-weight: bold;\n}\n.text2 {\n  padding-right: 50%;\n}\n.business_profile{\n  color: #FFF;\n// font-family: Roboto;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 500;\n// line-height: 28px; \n}\n.business_role{\n  color: #FFF;\n// font-family: Roboto;\nfont-size: 10px;\nfont-style: normal;\nfont-weight: 300;\n// line-height: 14px; /* 140% */\n}\n.vl {\n  border-left: 0.7px solid white;\n  height: 39px;\n  opacity: 0.3;\n}\n.form-check-input[type=\"radio\"] {\n  border: 1px solid #5599ff;\n}\n.span {\n  color: #aaaaaa;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n.spanDate {\n  font-size: 16px;\n  font-weight: bold;\n  color: #8d8b8b;\n}\n.round-circle {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #337ab7;\n}\n.span2 {\n  font-size: large;\n  font-weight: bold;\n  font-family: Arial, Helvetica, sans-serif;\n  color: #212121;\n  margin-top: 200px;\n}\n.date {\n  font-size: medium;\n  font-weight: bold;\n  color: #559fff;\n  .css-1u3bzj6-MuiFormControl-root-MuiTextField-root {\n    width: 200px;\n  }\n}\n.check-box {\n  display: flex;\n  flex-direction: row;\n  // margin: 20px;\n  .css-1qwvv1b-MuiTypography-root {\n    color: #8d8b8b !important;\n    font-size: 13px !important;\n    font-weight: bold !important;\n    font-family: \"Times New Roman\", Times, serif !important;\n  }\n}\n.card-cont {\n  max-height: 92vh;\n  // min-height: auto;\n}\n.card-header {\n  background-color: #fff; /* replace with your desired color */\n}\n.card-footer {\n  background-color: #fff; /* replace with your desired color */\n}\n\n.card-body-cont {\n  overflow: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.button_schedular {\n  margin-top: 5px;\n  margin-left: 20px;\n}\n.checkbox {\n  display: flex;\n  // align-content: center;\n  // justify-content: space-around;\n  // align-items: center;\n  width: 60px;\n}\n.checkboxes {\n  display: flex;\n  // align-content: center;\n  // justify-content: center;\n  // align-items: center;\n  // width:60px\n}\n.format3 {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  color: #8d8b8b;\n  font-weight: bold;\n  margin-left: 40px;\n  margin-bottom: 10px;\n}\n.row {\n  display: flex;\n}\n.dates {\n  display: flex !important;\n  justify-content: space-between !important;\n  font-weight: bold !important;\n  color: #8d8b8b !important;\n  .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input {\n    height: 15px !important;\n    width: 150px !important;\n    background-color: hwb(187 78% 5%) !important;\n    border: 0 !important;\n    border-radius: 2px !important;\n  }\n  .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {\n    background-color: hwb(187 78% 5%) !important;\n    width: 180px !important;\n  }\n}\n.form-error {\n  font-size: 12px;\n  font-weight: normal;\n  color: red;\n  text-align: initial;\n}\n.autocomplete {\n  display: flex;\n  margin: 0px 0px 20px 0px;\n  .css-l3ln04-MuiAutocomplete-root {\n    width: 250px !important;\n    height: -50px !important;\n  }\n\n  .MuiAutocomplete-input {\n    padding: 10px 4px 0px 5px !important;\n    font-size: 12px;\n    // font-family: fangsong;\n    margin-top: -12px;\n    // height: 10px;\n\n    // color: #c8eef3;\n  }\n\n  // .MuiSvgIcon-root{\n  //   color:'red'\n  // }\n  // .css-a5xs0d-MuiFormLabel-root-MuiInputLabel-root {\n  //   margin-top: -9px;\n  //   font-size: 14px;\n  //   // font-family:Georgia, 'Times New Roman', Times, serif;\n  // }\n}\n\n.format {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  margin-left: 10px;\n  font-weight: bold;\n  color: #8d8b8b;\n  .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {\n    background: #c8eef3 !important;\n    width: 150px !important;\n  }\n}\n.format_mobile {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  font-weight: bold;\n  color: #8d8b8b;\n  .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {\n    background: #c8eef3 !important;\n    width: 150px !important;\n  }\n}\n.formatFlex {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  margin-left: 10px;\n  font-weight: bold;\n  color: #8d8b8b;\n  .css-1unc4a9-MuiInputBase-root-MuiOutlinedInput-root {\n    background: #c8eef3 !important;\n    width: 150px !important;\n  }\n}\n.format2 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: baseline;\n  align-content: baseline;\n  margin-left: 20px;\n}\n\n.time {\n  color: #a3a3a3;\n  font-family: \"Roboto\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.padding {\n  margin-left: 20px;\n}\n\n// [class*=\"col-\"] {\n//   width: 100%;\n// }\n\n.week-wrapper {\n  display: flex;\n  justify-content: baseline;\n  align-content: baseline;\n  // width: 60px;\n}\n\n.load-more-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 200px;\n  height: 50px;\n  margin-top: 20px;\n  border-radius: 1825px;\n  background-color: #b5d5ff;\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n  text-transform: uppercase;\n  position: relative;\n  overflow: hidden;\n  border: none;\n}\n.buttons {\n  .css-sghohy-MuiButtonBase-root-MuiButton-root {\n    height: 30px;\n    margin-left: 300%;\n  }\n}\n.footer {\n  display: flex;\n  flex-direction: row;\n  align-content: stretch;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 6px 12px;\n}\n.business_role {\n  color: rgb(255, 255, 255);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 300;\n}\n.business_profile {\n  color: rgb(255, 255, 255);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n}\n.load-more-button:hover {\n  background-color: #b5d5ff;\n  cursor: pointer;\n}\n.checkboxs {\n  margin-right: 20px;\n  // display: flex;\n  // align-content: center;\n  // justify-content: space-around;\n  // align-items: center;\n  // width: 60px;\n}\n\n.arrow {\n  position: absolute;\n  right: 20px;\n  font-size: 24px;\n  transition: transform 0.2s;\n  color: white;\n}\n\n// .load-more-button:hover .arrow {\n//   transform: translateX(10px);\n// }\n\n.edit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  margin-top: 20px;\n  border-radius: 25px;\n  background-color: #b5d5ff;\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n  text-transform: uppercase;\n  border: none;\n}\n\n.edit:hover {\n  cursor: pointer;\n}\n\n.arrow {\n  position: absolute;\n  right: 20px;\n  font-size: 24px;\n  transition: transform 0.2s;\n}\n\n.edit:hover .arrow {\n  transform: translateY(10px);\n}\n\n.edit::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  background-color: #b5d5ff;\n  transform: scale(0);\n  transition: transform 0.2s;\n}\n.show-more-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  margin-top: 20px;\n  border-radius: 25px;\n  background-color: #ffb5b5;\n  color: white;\n  font-size: 18px;\n  font-weight: bold;\n  text-transform: uppercase;\n  border: none;\n}\n\n.show-more-button:hover {\n  cursor: pointer;\n}\n\n.arrow {\n  position: absolute;\n  right: 20px;\n  font-size: 24px;\n  transition: transform 0.2s;\n}\n\n.show-more-button:hover .arrow {\n  transform: translateY(10px);\n}\n\n.border_schedule {\n  border: 1px solid rgb(223, 222, 222);\n  border-radius: 5px;\n  padding-top: 8px;\n  padding-bottom: 3px;\n}\n.new_font {\n  color: #000;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 900;\n}\n\n.show-more-button::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  background-color: #b5d5ff;\n  transform: scale(0);\n  transition: transform 0.2s;\n}\n.dx-scheduler-header {\n  height: \"0px\";\n  background-color: \"transparent\";\n  border: \"0px\";\n}\n.dx-menu {\n  font-size: 12px;\n}\n.dx-menu:hover {\n  color: white;\n}\n\n@include tablet {\n  .card,\n  .card-schedular,\n  .card-header,\n  .check-box.content {\n    width: 80%;\n    padding: auto;\n  }\n}\n\n@include mobile {\n  .card,\n  .card-schedular,\n  .card-header,\n  .check-box,\n  .content {\n    width: 75%;\n    padding: auto;\n  }\n  .wrapper {\n    overflow: auto;\n  }\n}\n\n\n\n.slide-in {\n  box-shadow: rgb(0 0 0 / 58%) 0px 4px 16px;\n  z-index: 999;\n  transition: right 0.8s ease-in-out;\n  position: fixed;\n  top: 50%;\n\n}\n\n.slide-in.active {\n  transform: translate(72%, -50%); /* Move the content into view */\n  width: 50vw !important;\n  height: 100vh !important;\n}\n\n.cancel-creating-schedule{\n  text-transform: capitalize;\n  padding: 8px 30px;\n  border-radius: 5px;\n  margin-top: 20px;\n  border: none;\n  color: #999797;\n  background: #E9E9E9;\n  margin-right: 1em;\n}\n\n.save-creating-schedule{\n  text-transform: capitalize;\n  padding: 8px 30px;\n  border-radius: 5px;\n  margin-top: 20px;\n  border: none;\n  color: white;\n  background: #5599FF;\n\n}\n.edit-creating-schedule{\n  text-transform: capitalize;\n  padding: 8px 30px;\n  border-radius: 5px;\n  margin-top: 20px;\n  border: none;\n  color: white;\n  background: rgb(221, 75, 75);\n\n}\n\n.col-black{\n  color: #1D1D1B !important;\n}","@mixin smallDesktop {\n  @media (max-width: \"1000px\") {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media (max-width: \"799px\") {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: \"500px\") {\n    @content;\n  }\n}\n",".card1{\nleft: calc(50% - 1507px/2 - 0.5px);\nbackground: #FFFFFF;\nborder: 0.8px solid #DCDCDC;\nborder-radius: 8px;\nwidth:20%\n}\n.calander{\n    left: calc(50% - 260px/2 - 522px);\ntop: 160px;\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 500;\nfont-size: 24px;\nline-height: 29px;\ncolor: #414141;\n}\n.text{\n\nleft: 16.04%;\nright: 58.85%;\ntop: calc(50% - 74px/2 - 531px);\n\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 20px;\nline-height: 38px;\n/* or 192% */\n\nletter-spacing: 0.2px;\n\ncolor: #414141;\n}\n  .see {\n    font-family: 'Roboto', sans-serif;\n    font-size: 20px;\n    line-height: 38px;\n    letter-spacing: 0.2px;\n    color: #5599FF;\n  }\n  .see:hover{\n    cursor: pointer;\n  }\n  .image{\n    width: 58.4px;\nheight: 58.4px;\nleft: calc(50% - 58.4px/2 - 708.8px);\ntop: 145px;\n\nbackground: #FBFCFF;\nborder-radius: 8px;\n  }\n  .image2{\n    width: 644px;\nheight: 397px;\nleft: 1014px;\ntop: 172px;\n\n  }\n  .bold-text {\n    \nleft: calc(50% - 676px/2);\ntop: calc(50% - 56px/2 - 130px);\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 700;\nfont-size: 35px;\nline-height: 56px;\ntext-align: center;\ncolor: #414141;\n /* Change the color to your desired value */\n  }\n  .bold-text1{\n\n    \nleft: 42.92%;\nright: 43.02%;\ntop: calc(50% - 28px/2 - 79px);\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 18px;\nline-height: 28px;\n/* identical to box height, or 156% */\ntext-align: center;\nletter-spacing: 0.2px;\ncolor: #414141;\n  }\n\n  .image4{\n    width: 100%;\n \ntop: 57.21%;\nbottom: 39.47%;\nbackground: #E8F0FD;\n  }\n  .hr{\n    width: 93%;\nheight: 0px;\nborder: 0.6px solid #E5E9EE;\ntransform: rotate(-180deg);\n/* Inside auto layout */\n\nflex: none;\norder: 1;\nflex-grow: 0;\n  }\n.dropdown{\n/* bottom: 36.03%; */\n// border: 1px solid #3C89FF;\nborder-radius: 6px;\n}\n.dropdow{\n    color: #3C89FF;\n}\n.use{\n    font-family: 'Roboto';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 14px;\nline-height: 17px;\ncolor: #414141;\n}\n.dol{\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 700;\n\nfont-size: 36px;\nline-height: 44px;\n/* identical to box height */\ntext-align: center;\nletter-spacing: 0.6px;\ncolor: #414141;\n}\n.month{\n    height: 30px;\nfont-family: 'Roboto';\nfont-style: normal;\nfont-weight: 400;\nfont-size: 14px;\nline-height: 16px;\nletter-spacing: 0.6px;\n\ncolor: #BCBCBC;\n}\n\n.calander {\n  left: calc(50% - 260px/2 - 522px);\n  top: 160px;\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 29px;\n  color: #414141;\n}\n\n.text {\n\n  left: 16.04%;\n  right: 58.85%;\n  top: calc(50% - 74px/2 - 531px);\n\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 38px;\n  /* or 192% */\n\n  letter-spacing: 0.2px;\n\n  color: #414141;\n}\n\n.see {\n  font-family: 'Roboto', sans-serif;\n  font-size: 20px;\n  line-height: 38px;\n  letter-spacing: 0.2px;\n  color: #5599FF;\n}\n\n.see:hover {\n  cursor: pointer;\n}\n\n.image {\n  width: 58.4px;\n  height: 58.4px;\n  left: calc(50% - 58.4px/2 - 708.8px);\n  top: 145px;\n\n  background: #FBFCFF;\n  border-radius: 8px;\n}\n\n.image2 {\n  width: 644px;\n  height: 397px;\n  left: 1014px;\n  top: 172px;\n\n}\n\n.bold-text {\n\n  left: calc(50% - 676px/2);\n  top: calc(50% - 56px/2 - 130px);\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 35px;\n  line-height: 56px;\n  text-align: center;\n  color: #414141;\n  /* Change the color to your desired value */\n}\n\n.bold-text1 {\n\n\n  left: 42.92%;\n  right: 43.02%;\n  top: calc(50% - 28px/2 - 79px);\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 28px;\n  /* identical to box height, or 156% */\n  text-align: center;\n  letter-spacing: 0.2px;\n  color: #414141;\n}\n\n.image4 {\n  width: 100%;\n\n  top: 57.21%;\n  bottom: 39.47%;\n  background: #E8F0FD;\n}\n\n.hr {\n  width: 93%;\n  height: 0px;\n  border: 0.6px solid #E5E9EE;\n  transform: rotate(-180deg);\n  /* Inside auto layout */\n\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.dropdown {\n  /* bottom: 36.03%; */\n  // border: 1px solid #3C89FF;\n  border-radius: 6px;\n}\n\n.dropdow {\n  color: #3C89FF;\n}\n\n.use {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 17px;\n  color: #414141;\n}\n\n.dol {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n\n  font-size: 36px;\n  line-height: 44px;\n  /* identical to box height */\n  text-align: center;\n  letter-spacing: 0.6px;\n  color: #414141;\n}\n\n.month {\n  height: 30px;\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n\n  color: #BCBCBC;\n}\n\n.btns {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  /* identical to box height */\n  text-align: center;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #FFFFFF;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.buy {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 15px;\n  /* identical to box height */\n\n  text-align: center;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n\n  color: #AEB9D3;\n}\n\n.ba {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  /* identical to box height */\n  text-align: center;\n  color: #414141;\n}\n\n.form-check-input {\n  // width: 23px;\n  // height: 23px;\n  // background: #5599FF;\n  left: 0px;\n  top: 0px;\n  border-radius: 6px;\n}\n\n.tick {\n  box-sizing: border-box;\n  width: 19px;\n  height: 19px;\n  background: #FFFFFF;\n  border: 1px solid #DCDCDC;\n  border-radius: 6px;\n}\n\n.spans {\n  width: 70%;\n  /* box-sizing: border-box; */\n  background: #5599FF;\n  border: 0.8px solid #5599FF;\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 12px;\n  /* line-height: 15px; */\n  /* identical to box height */\n  text-align: center;\n  letter-spacing: 0.8px;\n\n  text-transform: uppercase;\n  color: #FFFFFF;\n  display: flex;\n  justify-content: center;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  align-items: center;\n}",".cards{\n    box-sizing: border-box;\n    width: 330px;\nheight: 188px;\nleft: 0px;\ntop: 0px;\nbackground: #FFFFFF;\nborder: 0.8px solid #DCDCDC;\nborder-radius: 8px;\n}\n.box-height{\n    height: 75vh;\n    overflow-y: scroll;\n}\n.subs{\nwidth: 91px;\nheight: 29px;\nleft: 209px;\ntop: 190px;\n font-family: \"Roboto\", sans-serif;\nfont-style: normal;\nfont-weight: 500;\nfont-size: 19px;\n/* identical to box height, or 180% */\ncolor: #484848;\n}\n.record{\n    color: #616161;\nfont-family: Poppins;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 28.8px;\n}\n.subscribe{\n    color: #484848;\nfont-family: Poppins;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 28.8px;\n}\n.form-check-input{\n    // width: 23px;\n    // height: 23px;\n    left: 0px;\n    top: 0px;\n    // background: #5599FF;\n    border-radius: 6px;\n    }\n    // .form-check-input2{\n    //     width: 19px;\n    //     height: 19px;\n    //     left: 0px;\n    //     top: 0px;\n    //     // background: #5599FF;\n    //     border-radius: 6px;\n    //     border:1px solid #DCDCDC\n    //     }\n.select{\n    color: #616161;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 28.8px;\n}\n\n.position{\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding:20px\n}\n.pro{\n    font-family: \"Roboto\", sans-serif;\n    font-style: normal;\nfont-weight: 500;\nfont-size: 13px;\nline-height: 11px;\ncolor: #313131;\n}\n.twinty{\n    font-style: normal;\nfont-weight: 500;\nfont-size: 11px;\nline-height: 11px;\nfont-family: \"Roboto\", sans-serif;\ntext-align: right;\ncolor: #5599FF;\n}\n.chat{\n/* font-family: roboto, Heebo Medium; */\nfont-style: normal;\nfont-weight: 600;\nfont-style: normal;\nfont-size: 15px;\n/* identical to box height, or 180% */\n}\n.four{\n    font-family: 'Roboto';\nfont-style: normal;\nfont-weight: 600;\nfont-size: 11px;\n/* line-height: 16px; */\n/* or 132% */\ncolor: #5599FF;\n}\n.vector{\n    // left: 1.38%;\nright: 97.83%;\n/* top: 81.25%; */\nbottom: 10.03%;\n/* border: 1.2px solid #D5D5D5; */\n}\n.vector1{\n    left: 1.05%;\nright: 95.82%;\n/* top: 81.4%; */\nbottom: 9.88%;\nsize: 7rem;\n// background: #D5D5D5;\n// border: 0.2px solid #FFFFFF;\n}\n.button{\n    // width: 100%;\n/* height: 34px; */\n// background: #5599FF;\nborder-radius: 6px;\n}\n.button1{\nbox-sizing: border-box;\nwidth: 100%;\nheight: 34px;\n/* left: 556px; */\nborder: 1px solid #A9A9A9;\nborder-radius: 6px;\n}\n.h1{\n    font-family: \"Roboto\", sans-serif;\nfont-style: normal;\nfont-weight: 400;\nfont-size: 12px;\n/* line-height: 29px; */\n/* identical to box height, or 240% */\ntext-align: center;\ncolor: #A9A9A9;\n}",".img_profile_shape {\n  height: 100px;\n  width: 100px;\n  object-fit: fill;\n  border: 1px solid;\n  border-radius: 50px;\n}\n\n.text_color_account {\n  color: gray;\n  font-size: 90%;\n}\n\n.sub_text_color_account {\n  color: rgb(194, 194, 194);\n  font-size: 80%;\n}\n.complete {\n  background-color: #1ce0a3;\n  opacity: 0.1;\n  color: #1ce0a3;\n  width: 74px;\n  height: 20px;\n  color: red;\n\n  border-radius: 50px;\n}\n.complete-text {\n  color: #fff;\n  // font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.custom-div {\n  background-color: #e8fcf6;\n  width: 80px;\n  height: 30px;\n  border-radius: 50px;\n\n  /* Add padding as desired */\n}\n\n.green-text {\n  color: #1ce0a3;\n  // font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  /* Additional styling for the <p> element */\n}\n.custom-div2 {\n  background-color: rgba(118,164,255,255)\n  ;\n  width: 80px;\n  height: 30px;\n  border-radius: 50px;\n\n  /* Add padding as desired */\n}\n\n.white-text {\n  color: white;\n  // font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  /* Additional styling for the <p> element */\n}\n\n.sub_text_color_account_alltext {\n  color: #aaa;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.background_color_showboxes {\n  background-color: #fff;\n  padding-top: 1%;\n  padding-bottom: 1%;\n  border-radius: 8px;\n  border: 1px solid #dcdcdc;\n  // margin: 0px 20px 0px 0px;\n  cursor: pointer;\n}\n\n.sub_text_color_account_alltext_show {\n  color: #aaa;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.sub_text_color_account_alltext_show_actual {\n  color: #000;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.sub_text_color_account_alltext_show_grey {\n    color: #AFAFAF;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n\n#color_icon_right {\n  color: #a9a9a9;\n}\n\n.box_height_profile {\n  height: 75vh;\n  overflow-y: scroll;\n}\n\n.box_height_profile1 {\n  height: 75vh;\n  overflow-y: scroll;\n}\n\n.box_height_profile1::-webkit-scrollbar {\n  display: none;\n}\n\n.background_color_line {\n  background-color: #f1f1f1 !important;\n  color: white !important;\n  border: 2px solid #f1f1f1 !important;\n}\n\n.img_verified_size {\n  width: 8%;\n  padding-right: 3%;\n}\n\n#style-2::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n#style-2::-webkit-scrollbar {\n  width: 5px;\n  background-color: #f5f5f5;\n}\n\n#style-2::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #548dff;\n}\n\n.disabled_button {\n  background-color: #548dff !important;\n  cursor: no-drop !important;\n}\n\n// upload file button\n\n.upload-btn-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.btnn {\n  border: 2px solid #0069d9;\n  color: #0069d9;\n  background-color: white;\n  padding: 2px 5px;\n  border-radius: 50px;\n  font-size: 10px;\n  font-weight: bold;\n  cursor: pointer !important;\n}\n\n.margin_neg_button {\n  top: 80px;\n  position: absolute;\n  left: 90px;\n}\n\n.upload-btn-wrapper input[type=\"file\"] {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n",".padding_left_right {\n  padding-left: 20%;\n  padding-right: 20%;\n  // height: 95vh;\n  overflow-y: scroll;\n}\n\n.border_rad_new {\n  border: 0.8px solid #dcdcdc;\n  border-radius: 10px;\n  background-color: white;\n  padding-bottom: 9px;\n}\n.border_rad_new1{\n  border: 0.8px solid #dcdcdc;\n  border-radius: 10px;\n  background-color: white;\n}\n.card-link{\n  width: 100% !important;\n  padding: 20px !important;\n  height: max-content !important;\n  border-radius: 8px !important;\n  color: black !important;\n  background-color: rgb(255, 255, 255) !important;\n  padding: 5px !important;\n  border: 0.5px solid #DCDCDC;\n  box-shadow: 2px 2px #DCDCDC;\n}\n\n.button_color_primary {\n  background-color: #548dff !important;\n  border-radius: 6px !important;\n}\n\n.label_text_business {\n  color: #dcdcdc;\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.input_style_fix {\n  border: 0px solid white;\n  outline: none;\n  padding-left: 0px;\n  padding-top: 0px;\n  \n  padding-bottom: 0px;\n}\n\n.input_style_fix::placeholder {\n  color: #aaaaaa;\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n// .padding_left_right\n// {\n// height: 95vh;\n// overflow-y: scroll;\n//     padding-bottom: 15%;\n// }\n\n.padding_left_right::-webkit-scrollbar {\n  display: none;\n}\n\n.padding_next_primary_button {\n  padding-left: 10%;\n  padding-right: 10%;\n  background-color: #548dff !important;\n  border-radius: 6px !important;\n}\n\n.padding_next_secondary_button {\n  padding-left: 10%;\n  padding-right: 10%;\n  border-radius: 6px;\n  background: #edf0f5 !important;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.16) !important;\n  color: rgb(179, 179, 179) !important;\n}\n.height_width_fix {\n  height: 70px;\n  width: 70px;\n}\n\n//////////////////////////owner detail page\n\n.text_heading_owner {\n  color: #548dff;\n  font-family: \"Roboto\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n.text_heading_customer {\n  color: #0f0f10;\n  font-family: \"Roboto\";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n\n.padding_set_new {\n  padding-left: 22px !important;\n}\n.owner-text {\n  color: #dcdcdc;\n}\n.greenText{\n  background-color: red($color: red);\n  color:white\n}\n.label_text_department{\n  font-size: 12px;\n  color: #dcdcdc;\n\n}\n.form-control1 {\n  display: block;\n  width: 100%;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  padding: 2px;\n  appearance: auto;\n  /* line-height: 29px; */\n  /* identical to box height, or 160% */\n  color: #232323;\n border:none !important\n  /* outline-color: red;\nbox-shadow: 0 0 0 2px red; */\n}\n// select option[disabled]{\n//   color: #adadad; /* Set the text color for the first option */\n// }\n.text-size{\n  font-size: 14px;\n}\n.search-bar-textfield {\n  display: block;\n  width: 100%;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  padding: 2px;\n  appearance: auto;\n  /* line-height: 29px; */\n  /* identical to box height, or 160% */\n  color: #232323;\n border: 1px solid grey !important\n  /* outline-color: red;\nbox-shadow: 0 0 0 2px red; */\n}\n.form-control:focus {\n  border: 0;\n  box-shadow: none;\n  font-size: 12px;\n}\n.form-control::placeholder{\n  color:\"#AAAAAA\";\n  font-size: 12px;\n    \n}\n.custom-dropdown {\n  display: block;\n  width: 100%;\n\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  padding: 2px;\n  appearance: auto;\n  /* line-height: 29px; */\n  /* identical to box height, or 160% */\n  // color: #232323;\n border:none !important\n}\n\n// .custom-dropdown::after {\n//   content: '\\25BC'; /* Unicode character for down arrow */\n//   position: absolute;\n//   top: 50%;\n//   right: 10px;\n//   transform: translateY(-50%);\n//   pointer-events: none;\n// }\n\n.custom-select option:nth-child(1) {\n  color: red; /* Set the color for disabled options */\n}\n\n\n.hide_input_border:focus {\n  border: none !important;\n}\n\n.padding_Set_add {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.img_height_w {\n  height: 40px;\n  width: 40px;\n  object-fit: cover;\n}\n\n.heaing_it_sol {\n  color: #616161;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.heaing_it_sol1 {\n  color: #8a8a8a;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.heaing_it_sol2 {\n  color: #8a8a8a;\n  font-family: Poppins;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n}\n.img_profile_shape {\n  height: 100px;\n  width: 100px;\n  object-fit: fill;\n  border-radius: 50px;\n  border: 1px solid;\n}\n\n.text_color_account {\n  color: gray;\n  font-size: 90%;\n}\n\n.sub_text_color_account {\n  color: rgb(194, 194, 194);\n  font-size: 80%;\n}\n\n.sub_text_color_account_alltext {\n  color: #AAA;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.background_color_showboxes {\n  background-color: #fff;\n  padding-top: 1%;\n  padding-bottom: 1%;\n  border-radius: 8px;\n  border:1px solid #DCDCDC;\n  // margin: 0px 20px 0px 0px;\n  cursor: pointer;\n}\n\n.sub_text_color_account_alltext_show {\n  color: #AAA;\n  font-family: Inter;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.sub_text_color_account_alltext_show_actual {\n  color: #000;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n#color_icon_right {\n  color:#A9A9A9;\n}\n.img_profile_shape1{\n  height: 100px;\n  width: 100px;\n  object-fit: fill;\n  border-radius: 10px;\n  border: 1px solid;\n}\n.text_color_account1{\n  color:#808080;\n  font-size: 12px;\n\n\n}\n.sub_text_color_account_alltext1{\ncolor:#AAAAAA;\nfont-size: 13px;\n}\n.id_text_color{\n  color:#B1B4B7;\n  font-size:10px\n}\n.box_height_profile {\n  height: 75vh;\n  overflow-y: scroll;\n}\n\n.box_height_profile1 {\n  height: 75vh;\n  overflow-y: scroll;\n}\n\n.box_height_profile1::-webkit-scrollbar {\n  display: none;\n}\n\n.background_color_line {\n  background-color: #F1F1F1 !important;\n  color: white !important;\n  border: 2px solid #F1F1F1 !important;\n}\n\n.img_verified_size {\n  width: 8%;\n  padding-right: 3%;\n}\n\n#style-2::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #F5F5F5;\n}\n\n#style-2::-webkit-scrollbar {\n  width: 5px;\n  display: hide !important;\n  background-color: #F5F5F5;\n}\n\n#style-2::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);\n  background-color: #548DFF;\n}\n\n.disabled_button {\n  background-color: #548DFF !important;\n  cursor: no-drop !important;\n\n}\n\n// upload file button \n\n.upload-btn-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.btnn {\n  border: 2px solid #0069D9;\n  color: #0069D9;\n  background-color: white;\n  padding: 2px 5px;\n  border-radius: 50px;\n  font-size: 10px;\n  font-weight: bold;\n  cursor: pointer !important;\n}\n\n.margin_neg_button1 {\n  top: 80px;\n  position: absolute;\n  left: 90px;\n}\n\n.upload-btn-wrapper input[type=file] {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.provider-popup-dataview-field{\n  color: black !important;\n  font-weight: 500;\n}\n\n.center-cols{\n  width: 96% !important;\n  margin: auto !important;\n}\n\n.selected-business{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 500px) {\n  .padding_left_right {\n     padding-left: 12px;\n     padding-right:12px\n  }\n  .img_profile_shape1{\n    height: 100px;\n    width: 100px;\n    object-fit: fill;\n    border-radius: 50%;\n    border: 1px solid;\n  }\n  .margin_neg_button1 {\n    margin-left: 150px;\n    margin-top: 70px;\n  }\n  .card-link {\n    width: 100% !important;\n    padding: 20px !important;\n    max-width: 90px;\n    height: max-content !important;\n    border-radius: 8px !important;\n    color: black !important;\n    background-color: rgb(255, 255, 255) !important;\n    padding: 0px !important;\n    border: 0.5px solid #DCDCDC;\n    box-shadow: 2px 2px #DCDCDC;\n}\n \n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$font-family: \"Poppins\" !default;\n$font-family-Roboto: \"Roboto\" !default;\n$font-family-Dosis: \"Dosis\" !default;\n\n$white: #fff !default;\n$light-gray: rgba(255, 255, 255, 0.5) !default;\n\n$red: #d41313 !default;\n\n$primary: #0575E6 !default;\n\n$black: #131313 !default;\n$light-black: #201f23 !default;\n$dark-black: #0e0e0e !default;\n$blue: #0575E6 !default;\n$gray: Gray !default;\n$lightgray: lightgray !default;\n$green: #42D742 !default;\n\n\n$border: 1px solid #D1D1D1 !default;\n$bold-border: 3px solid #b59b41 !default;\n\n$border-radius-10: 10px !default;\n$border-radius-20: 20px !default;\n$border-radius-24: 24px !default;\n\n$text-uppercase: uppercase !default;\n\n\n$font-8: 8px !default;\n$font-9: 9px !default;\n$font-10: 10px !default;\n$font-11: 11px !default;\n$font-12: 12px !default;\n$font-14: 14px !default;\n$font-15: 15px !default;\n$font-16: 16px !default;\n$font-17: 17px !default;\n$font-18: 18px !default;\n$font-20: 20px !default;\n$font-22: 22px !default;\n$font-24: 24px !default;\n$font-26: 26px !default;\n$font-28: 28px !default;\n$font-32: 32px !default;\n$font-36: 36px !default;\n$font-50: 50px !default;\n$font-40: 40px !default;\n$font-144: 144px !default;\n\n$font-weight-300: 300 !default;\n$font-weight-400: 400 !default;\n$font-weight-500: 500 !default;\n$font-weight-600: 600 !default;\n$font-weight-700: 700 !default;\n$font-weight-800: 800 !default;\n$font-weight-900: 900 !default;\n$font-weight-1200: 1900 !default;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
